import './index.css';var Us = Object.defineProperty, Gs = Object.defineProperties;
var Ks = Object.getOwnPropertyDescriptors;
var vt = Object.getOwnPropertySymbols;
var ts = Object.prototype.hasOwnProperty, ss = Object.prototype.propertyIsEnumerable;
var es = (s, n, a) => n in s ? Us(s, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : s[n] = a, y = (s, n) => {
  for (var a in n || (n = {}))
    ts.call(n, a) && es(s, a, n[a]);
  if (vt)
    for (var a of vt(n))
      ss.call(n, a) && es(s, a, n[a]);
  return s;
}, ge = (s, n) => Gs(s, Ks(n));
var S = (s, n) => {
  var a = {};
  for (var c in s)
    ts.call(s, c) && n.indexOf(c) < 0 && (a[c] = s[c]);
  if (s != null && vt)
    for (var c of vt(s))
      n.indexOf(c) < 0 && ss.call(s, c) && (a[c] = s[c]);
  return a;
};
import e, { createContext as $t, Children as Ys, isValidElement as Pe, useState as R, useContext as ke, forwardRef as Be, cloneElement as Ge, useEffect as oe, useRef as se, useLayoutEffect as Xs, useCallback as Gt, createRef as Qs } from "react";
import t from "prop-types";
import { NavLink as hs, MemoryRouter as Js } from "react-router-dom";
import { useFloating as Ie, offset as yt, flip as wt, shift as Nt, autoUpdate as qe, useHover as _t, useFocus as gs, useDismiss as Se, useRole as Te, useInteractions as Oe, useId as fs, useListNavigation as pt, useTransitionStyles as Xe, useClick as ot, safePolygon as bs, FloatingOverlay as e1, FloatingFocusManager as vs, arrow as t1, FloatingArrow as s1 } from "@floating-ui/react";
import { useHotkeys as n1 } from "react-hotkeys-hook";
import { useMeasure as kt } from "@reactuses/core";
import { useFloating as a1, flip as l1 } from "@floating-ui/react-dom";
import _s from "hash-sum";
import { ToastContainer as c1, Slide as r1, cssTransition as o1, toast as ns } from "react-toastify";
import i1 from "focus-trap-react";
const d1 = (r) => {
  var o = r, {
    darkBackground: s,
    listItems: n,
    className: a
  } = o, c = S(o, [
    "darkBackground",
    "listItems",
    "className"
  ]);
  const l = "pds-avatar-tile-list", i = "pds-tile-list", d = s ? `${i}--reverse` : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [
        l,
        d,
        `${i}--avatar`,
        i,
        a
      ].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    n.map((u, h) => {
      const m = u.linkContent ? u.linkContent.type : "div", p = u.linkContent.props.href ? "href" : "to", f = p === "href" ? u.linkContent.props.href : u.linkContent.props.to, C = u.linkContent.props.target ? "target" : null;
      return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
        m,
        {
          key: `avatar-tile-item-${h}`,
          className: `${i}__item`,
          href: p === "href" ? f : null,
          to: p === "to" ? f : null,
          target: C
        },
        /* @__PURE__ */ e.createElement(
          "div",
          {
            className: `${i}__image ${i}__image--avatar`
          },
          /* @__PURE__ */ e.createElement("img", { src: u.image, alt: u.alt })
        ),
        /* @__PURE__ */ e.createElement("div", { className: `${i}__name` }, u.name),
        /* @__PURE__ */ e.createElement("div", { className: `${i}__title` }, u.title),
        /* @__PURE__ */ e.createElement("div", { className: `${i}__org` }, u.org)
      ), /* @__PURE__ */ e.createElement("div", { className: "pds-tile__separator" }));
    })
  );
};
d1.propTypes = {
  /**
   * Boolean to set for dark background
   */
  darkBackground: t.bool,
  /**
   * Array of items for each avatar tile keys are image, alt, title, org, link
   */
  listItems: t.arrayOf(
    t.shape({
      image: t.string,
      alt: t.string,
      title: t.string,
      org: t.string,
      link: t.string,
      linkContent: t.node
    })
  ),
  /**
   * Additional class names
   */
  className: t.string
};
const m1 = {
  crumbs: [],
  deferredCrumbIds: [],
  register: () => {
  },
  unregister: () => {
  },
  deferCrumb: () => {
  },
  resolveCrumb: () => {
  }
}, Es = $t(m1), je = () => Math.random().toString(32).substring(2, 13), Cs = (s, n) => {
  let a;
  for (n = n || [], a = 0; a < s.childNodes.length; a++)
    n.push(s.childNodes[a]), Cs(s.childNodes[a], n);
  return n;
}, Y = (s) => s.join(" ").trim().replace(/\s+/g, " "), $s = (s) => {
  const n = {};
  return Ys.forEach(s, (a) => {
    if (Pe(a)) {
      const c = a.props.slot;
      c && (n[c] ? n[c].push(a) : n[c] = [a]);
    }
  }), n;
}, q = (r) => {
  var o = r, {
    iconName: s,
    iconSize: n = "md",
    className: a
  } = o, c = S(o, [
    "iconName",
    "iconSize",
    "className"
  ]);
  const l = `pds-icon pds-icon--${n} pds-icon--${s}`, i = `0 0 ${Wt[s].width} 512`, d = {
    sm: "0.8rem",
    md: "1rem",
    lg: "1.2rem",
    xl: "1.44rem",
    "2xl": "1.728rem",
    "3xl": "2.074rem",
    "4xl": "3.052rem"
  };
  return /* @__PURE__ */ e.createElement(
    "svg",
    y({
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      viewBox: i,
      height: d[n],
      fill: "none",
      "aria-hidden": "true",
      preserveAspectRatio: "xMidYMid meet",
      focusable: "false",
      className: [l, a != null ? a : ""].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    /* @__PURE__ */ e.createElement("path", { d: Wt[s].path, fill: "currentColor" })
  );
}, Wt = {
  angleDown: {
    path: "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z",
    width: "440"
  },
  angleLeft: {
    path: "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z",
    width: "320"
  },
  angleRight: {
    path: "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z",
    width: "320"
  },
  angleUp: {
    path: "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z",
    width: "440"
  },
  arrowDownToLine: {
    path: "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zM214.6 342.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 242.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V242.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128z",
    width: "384"
  },
  arrowLeft: {
    path: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z",
    width: "448"
  },
  arrowRight: {
    path: "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z",
    width: "448"
  },
  asterisk: {
    path: "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z",
    width: "384"
  },
  banBug: {
    path: "M256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5C335.9 434.9 297.5 448 256 448zm89-148.3l19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7V246.7l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-18.7 0-35.9 6.4-49.6 17.2L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L345 299.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z",
    width: "512"
  },
  bars: {
    path: "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z",
    width: "460"
  },
  barsFilter: {
    path: "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM288 416c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32z",
    width: "460"
  },
  billboard: {
    path: "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H80C53.5 32 32 53.5 32 80V352c-17.7 0-32 14.3-32 32s14.3 32 32 32H80 288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416H560h48c17.7 0 32-14.3 32-32s-14.3-32-32-32V80c0-26.5-21.5-48-48-48H448zM320 352H96V96h96v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V96H384v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V96h96V352H320z",
    width: "640"
  },
  bitbucket: {
    path: "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z",
    width: "512"
  },
  bolt: {
    path: "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z",
    width: "448"
  },
  book: {
    path: "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z",
    width: "448"
  },
  books: {
    path: "M0 32C0 14.3 14.3 0 32 0L96 0c17.7 0 32 14.3 32 32l0 64L0 96 0 32zm0 96l128 0 0 256L0 384 0 128zM0 416l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM160 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64L160 96l0-64zm0 96l128 0 0 256-128 0 0-256zm0 288l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm203.6-19.9L320 232.6l0-89.9 100.4-26.9 66 247.4L363.6 396.1zM412.2 85L320 109.6 320 11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zM371.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z",
    width: "512"
  },
  bracketRight: {
    path: "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z",
    width: "548"
  },
  broomWide: {
    path: "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z",
    width: "512"
  },
  building: {
    path: "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z",
    width: "400"
  },
  buildings: {
    path: "M256 0c-35.3 0-64 28.7-64 64v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256 448c35.3 0 64-28.7 64-64V192 64c0-35.3-28.7-64-64-64H256zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304zm208 16c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272zm112-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80zM400 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 208V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400z",
    width: "512"
  },
  calendarDays: {
    path: "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z",
    width: "448"
  },
  ccAmex: {
    path: "M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z",
    width: "600"
  },
  ccDiscover: {
    path: "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z",
    width: "600"
  },
  ccGeneric: {
    path: "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z",
    width: "600"
  },
  ccMC: {
    path: "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z",
    width: "600"
  },
  ccVisa: {
    path: "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z",
    width: "600"
  },
  chartSimple: {
    path: "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z",
    width: "500"
  },
  cloud: {
    path: "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z",
    width: "640"
  },
  cloudArrowUp: {
    path: "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z",
    width: "640"
  },
  code: {
    path: "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z",
    width: "640"
  },
  codeBranch: {
    path: "M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3V256c20.1-15.1 45-24 72-24h96c39.8 0 72-32.2 72-72v-3.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V160c0 66.3-53.7 120-120 120H176c-39.8 0-72 32.2-72 72v3.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V352 156.3C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm240 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64z",
    width: "500"
  },
  codeMerge: {
    path: "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z",
    width: "480"
  },
  caretDown: {
    path: "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z",
    width: "320"
  },
  caretLeft: {
    path: "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z",
    width: "256"
  },
  caretRight: {
    path: "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z",
    width: "256"
  },
  caretUp: {
    path: "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z",
    width: "320"
  },
  chartLine: {
    path: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z",
    width: "512"
  },
  chartNetwork: {
    path: "M288 64c0 13.7-4.3 26.3-11.6 36.7l29.2 62.5c9.8-2.1 20-3.2 30.4-3.2c36.1 0 69 13.3 94.3 35.2L512.4 135c-.2-2.3-.4-4.6-.4-7c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.2 0-17.9-1.9-25.8-5.4l-82 60.2c7.6 17.5 11.8 36.9 11.8 57.2c0 15.6-2.5 30.7-7.1 44.8l72 43.2c9.2-5.1 19.8-8 31.1-8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64l0-1.1-72.1-43.3C413.7 431 376.8 448 336 448c-68.5 0-125.9-47.9-140.4-112H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c23.7 0 44.4 12.9 55.4 32h76.1c7.5-33 26.3-61.6 52.1-81.7l-29.2-62.5C185.7 124.9 160 97.5 160 64c0-35.3 28.7-64 64-64s64 28.7 64 64zm48 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z",
    width: "640"
  },
  check: {
    path: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z",
    width: "448"
  },
  circle: {
    path: "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z",
    width: "512"
  },
  circleExclamation: {
    path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z",
    width: "512"
  },
  circleCheck: {
    path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z",
    width: "512"
  },
  circleInfo: {
    path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z",
    width: "512"
  },
  circleMinus: {
    path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z",
    width: "512"
  },
  circleMinusOutline: {
    path: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z",
    width: "512"
  },
  circleNotch: {
    path: "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z",
    width: "512"
  },
  circlePlus: {
    path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z",
    width: "512"
  },
  circlePlusOutline: {
    path: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z",
    width: "512"
  },
  circleQuestion: {
    path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z",
    width: "512"
  },
  circleXmark: {
    path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z",
    width: "512"
  },
  command: {
    path: "M0 96C0 43 43 0 96 0s96 43 96 96v32H320V96c0-53 43-96 96-96s96 43 96 96s-43 96-96 96H384V320h32c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96V384H192v32c0 53-43 96-96 96s-96-43-96-96s43-96 96-96h32V192H96C43 192 0 149 0 96zm128 32V96c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32h32zm64 192H320V192H192V320zm-64 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32V384zm256 0v32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H384zm0-256h32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32v32z",
    width: "512"
  },
  comment: {
    path: "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z",
    width: "512"
  },
  copy: {
    path: "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z",
    width: "480"
  },
  diamondExclamation: {
    path: "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z",
    width: "512"
  },
  discourse: {
    path: "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z",
    width: "512"
  },
  download: {
    path: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z",
    width: "520"
  },
  drupal: {
    path: "M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z",
    width: "440"
  },
  ellipsis: {
    path: "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z",
    width: "448"
  },
  ellipsisVertical: {
    path: "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z",
    width: "120"
  },
  emptySet: {
    path: "M435.4 121.9l67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1zm-91.2 .7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5zm-176.5 267L389.5 167.8C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z",
    width: "512"
  },
  exclamation: {
    path: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z",
    width: "100"
  },
  externalLink: {
    path: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z",
    width: "512"
  },
  eye: {
    path: "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z",
    width: "576"
  },
  eyeSlash: {
    path: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z",
    width: "640"
  },
  facebook: {
    path: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z",
    width: "512"
  },
  file: {
    path: "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z",
    width: "400"
  },
  fileContract: {
    path: "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z",
    width: "400"
  },
  fileCSV: {
    path: "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z",
    width: "512"
  },
  fileExport: {
    path: "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z",
    width: "576"
  },
  fileImport: {
    path: "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z",
    width: "512"
  },
  filePDF: {
    path: "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z",
    width: "512"
  },
  folder: {
    path: "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z",
    width: "512"
  },
  gear: {
    path: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z",
    width: "512"
  },
  github: {
    path: "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2",
    width: "512"
  },
  gitlab: {
    path: "M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z",
    width: "512"
  },
  globe: {
    path: "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z",
    width: "512"
  },
  globeLine: {
    path: "M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320H347.7c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160H342c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3H374.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z",
    width: "512"
  },
  graduationCap: {
    path: "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z",
    width: "640"
  },
  grid: {
    path: "M224 80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM288 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z",
    width: "512"
  },
  gripDots: {
    path: "M336 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z",
    width: "448"
  },
  gripDotsVertical: {
    path: "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 416A48 48 0 1 0 0 416a48 48 0 1 0 96 0zM208 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z",
    width: "280"
  },
  heart: {
    path: "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z",
    width: "532"
  },
  house: {
    path: "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z",
    width: "600"
  },
  idCard: {
    path: "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z",
    width: "575"
  },
  instagram: {
    path: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z",
    width: "480"
  },
  keySkeleton: {
    path: "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c22.2 14 48.5 22.1 76.7 22.1z",
    width: "480"
  },
  laptopCode: {
    path: "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z",
    width: "640"
  },
  leaf: {
    path: "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z",
    width: "512"
  },
  lifeRing: {
    path: "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z",
    width: "512"
  },
  linkedin: {
    path: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z",
    width: "480"
  },
  linkSimple: {
    path: "M0 256C0 167.6 71.6 96 160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96 43-96 96s43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96-43 96-96s-43-96-96-96H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160zM192 224H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z",
    width: "600"
  },
  linkSimpleSlash: {
    path: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96c0 43.3-28.6 79.8-67.9 91.8L399.7 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H318.1l-81.7-64H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zM121 191.4L70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-53 0-96-43-96-96c0-24.9 9.5-47.6 25-64.6z",
    width: "640"
  },
  magnifyingGlass: {
    path: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z",
    width: "512"
  },
  messages: {
    path: "M64 0C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM352 352H256v32c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448V256c0 53-43 96-96 96z",
    width: "640"
  },
  minus: {
    path: "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z",
    width: "448"
  },
  moon: {
    path: "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z",
    width: "384"
  },
  paperclip: {
    path: "M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.3-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z",
    width: "448"
  },
  paperPlane: {
    path: "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z",
    width: "512"
  },
  pen: {
    path: "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z",
    width: "512"
  },
  phone: {
    path: "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z",
    width: "512"
  },
  play: {
    path: "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z",
    width: "440"
  },
  plus: {
    path: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z",
    width: "448"
  },
  quotesLeft: {
    path: "M232.896 226.425C228.749 226.425 225.964 231.118 227.632 235.301L286.746 413.714L116.988 224.541C113.406 220.543 102.507 208.132 99.9534 203.926L11.645 108.127C9.0914 103.92 11.8346 98.2854 16.4278 98.2854H227.018C227.811 98.2854 228.592 98.3754 229.349 98.5481C229.87 98.3779 230.428 98.2854 231.017 98.2854H441.605C446.22 98.2854 450.387 101.323 452.187 106.003L495.176 217.627C496.786 221.801 494.005 226.425 489.888 226.425H447.484C443.338 226.425 440.551 231.118 442.221 235.301L501.333 413.714L331.576 224.541C327.995 220.543 317.095 208.132 314.542 203.926L247.159 130.829L280.589 217.627C282.198 221.801 279.418 226.425 275.3 226.425H232.896Z",
    width: "512"
  },
  quotesRight: {
    path: "M289.771 226.425C293.918 226.425 296.703 231.118 295.035 235.301L235.921 413.714L405.679 224.541C409.261 220.543 420.16 208.132 422.713 203.926L511.022 108.127C513.575 103.92 510.832 98.2854 506.239 98.2854H295.649C294.855 98.2854 294.075 98.3754 293.317 98.5481C292.797 98.3779 292.239 98.2854 291.65 98.2854H81.0613C76.4469 98.2854 72.2795 101.323 70.48 106.003L27.4902 217.627C25.8806 221.801 28.6614 226.425 32.7787 226.425H75.183C79.3291 226.425 82.1152 231.118 80.4459 235.301L21.3334 413.714L191.09 224.541C194.672 220.543 205.571 208.132 208.125 203.926L275.507 130.829L242.078 217.627C240.468 221.801 243.249 226.425 247.366 226.425H289.771Z",
    width: "512"
  },
  rectangleList: {
    path: "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z",
    width: "575"
  },
  robot: {
    path: "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z",
    width: "640"
  },
  rotate: {
    path: "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z",
    width: "512"
  },
  rotateClock: {
    path: "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z",
    width: "512"
  },
  rss: {
    path: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z",
    width: "448"
  },
  save: {
    path: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z",
    width: "448"
  },
  server: {
    path: "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z",
    width: "512"
  },
  shield: {
    path: "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM80 141.4L256 66.8V224H90.1c-6.9-30-9.8-58.5-10.1-82.6zM256 444.8V224H422c-18.5 80.5-65.5 172.2-166 220.8z",
    width: "512"
  },
  shovel: {
    path: "M361.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-44.1 44.1c-18.7 18.7-44.1 29.3-70.6 29.3c-15.9 0-30.9-3.7-44.3-10.3l-97 97 50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32V386.3c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7 97-97C291.7 155.1 288 140 288 124.1c0-26.5 10.5-51.9 29.3-70.6L361.4 9.4zM384 77.3L362.5 98.7c-6.7 6.7-10.5 15.9-10.5 25.4c0 19.8 16.1 35.9 35.9 35.9c9.5 0 18.6-3.8 25.4-10.5L434.7 128 384 77.3z",
    width: "512"
  },
  siren: {
    path: "M69.3 36l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM597.3 76l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM144 352l25-199.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L496 352H234.1l21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L201.9 352H144zM96 416c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416z",
    width: "640"
  },
  sitemap: {
    path: "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z",
    width: "600"
  },
  slack: {
    path: "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z",
    width: "480"
  },
  slashForward: {
    path: "M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9S-4.6 479.5 4.2 464.1l256-448C269 .8 288.5-4.6 303.9 4.2z",
    width: "320"
  },
  slidersSimple: {
    path: "M96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm90.5 0L480 320c17.7 0 32 14.3 32 32s-14.3 32-32 32l-293.5 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96s43-96 96-96c41.8 0 77.4 26.7 90.5 64zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-58.5-32c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64L32 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l293.5 0z",
    width: "512"
  },
  snowflake: {
    path: "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z",
    width: "470"
  },
  sparkles: {
    path: "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z",
    width: "512"
  },
  squareCheck: {
    path: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z",
    width: "448"
  },
  squareCode: {
    path: "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm262.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L324.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L123.9 256l60.2-54.2z",
    width: "448"
  },
  squareMinus: {
    path: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z",
    width: "448"
  },
  squarePen: {
    path: "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z",
    width: "512"
  },
  squareQuestion: {
    path: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm73.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H190.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z",
    width: "448"
  },
  squareTerminal: {
    path: "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm70.3 55.8c-9 9.8-8.3 25 1.5 33.9L148.5 256 71.8 326.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z",
    width: "448"
  },
  star: {
    path: "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z",
    width: "576"
  },
  sun: {
    path: "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z",
    width: "512"
  },
  table: {
    path: "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 0V224H448V96H128zM448 288H128V416H448V288z",
    width: "512"
  },
  terminal: {
    path: "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z",
    width: "576"
  },
  threads: {
    path: "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z",
    width: "440"
  },
  trash: {
    path: "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z",
    width: "448"
  },
  triangleExclamation: {
    path: "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z",
    width: "512"
  },
  twitter: {
    path: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z",
    width: "512"
  },
  upload: {
    path: "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z",
    width: "512"
  },
  user: {
    path: "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z",
    width: "448"
  },
  userGear: {
    path: "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z",
    width: "640"
  },
  userPlus: {
    path: "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z",
    width: "640"
  },
  users: {
    path: "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z",
    width: "640"
  },
  video: {
    path: "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z",
    width: "576"
  },
  wavePulse: {
    path: "M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H499.8L444.6 398.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4L323.7 167.3 255.3 486.7c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H135.9c28.6 0 53.7 18.9 61.5 46.4L219.6 348 288.7 25.3C291.8 10.9 304.4 .4 319.1 0z",
    width: "640"
  },
  windowRestore: {
    path: "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z",
    width: "512"
  },
  wordpress: {
    path: "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8 .9 0 1.8 .1 2.8 .2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7 .3 13.7 .3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z",
    width: "512"
  },
  wrench: {
    path: "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z",
    width: "512"
  },
  xmark: {
    path: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z",
    width: "384"
  },
  xmarkLarge: {
    path: "M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z",
    width: "500"
  },
  xTwitter: {
    path: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z",
    width: "500"
  },
  youtube: {
    path: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z",
    width: "576"
  }
}, as = Object.keys(Wt), It = 300, u1 = 400, Et = (m) => {
  var p = m, {
    content: s,
    customTrigger: n = null,
    offsetValue: a = 8,
    preferredPlacement: c = "top",
    triggerAccessibleText: r = "Show more information",
    triggerIcon: o = "circleInfo",
    triggerIconColor: l = "default",
    triggerIconSize: i = "sm",
    zIndex: d = u1,
    className: u
  } = p, h = S(p, [
    "content",
    "customTrigger",
    "offsetValue",
    "preferredPlacement",
    "triggerAccessibleText",
    "triggerIcon",
    "triggerIconColor",
    "triggerIconSize",
    "zIndex",
    "className"
  ]);
  const [f, C] = R(!1), $ = typeof n, g = "pds-tooltip", _ = Y([
    `${g}__trigger-custom`,
    $ === "string" ? `${g}__trigger-text` : null
  ]), b = Y([
    `${g}__trigger`,
    `${g}__trigger--${l}`
  ]), { refs: v, floatingStyles: E, context: w } = Ie({
    placement: c,
    open: f,
    onOpenChange: C,
    middleware: [yt(a), wt(), Nt()],
    whileElementsMounted: qe
  }), L = _t(w, {
    restMs: 300,
    delay: { open: 500, close: 0 },
    move: !1
  }), N = gs(w), M = Se(w), k = Te(w, { role: "tooltip" }), { getReferenceProps: x, getFloatingProps: z } = Oe([
    L,
    N,
    M,
    k
  ]);
  return /* @__PURE__ */ e.createElement("div", y({ className: Y([g, u != null ? u : ""]) }, h), n ? /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: _,
      ref: v.setReference
    }, x()),
    n
  ) : /* @__PURE__ */ e.createElement(
    "button",
    y({
      "aria-label": r,
      className: b,
      ref: v.setReference
    }, x()),
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: o,
        className: `${g}__icon`,
        iconSize: i
      }
    )
  ), f && /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: `${g}__container`,
      ref: v.setFloating,
      style: ge(y({}, E), { zIndex: d })
    }, z()),
    s
  ));
}, Ue = ({ crumb: s, lastCrumb: n, classes: a }) => {
  const c = s.label.length > 16 ? `${s.label.slice(0, 16)}...` : null;
  return /* @__PURE__ */ e.createElement("li", { className: `${a || ""}`, key: `key-${s.label}` }, n ? /* @__PURE__ */ e.createElement("a", { className: "pds-breadcrumbs__disabled" }, s.label.length > 15 ? /* @__PURE__ */ e.createElement(Et, { content: s.label, triggerText: c }) : s.label) : /* @__PURE__ */ e.createElement(hs, { end: !0, to: s.uri }, s.label.length > 15 ? /* @__PURE__ */ e.createElement(Et, { content: s.label, triggerText: c }) : s.label));
};
Ue.propTypes = {
  crumb: t.object,
  lastCrumb: t.bool,
  classes: t.string
};
const p1 = (s) => /* @__PURE__ */ e.createElement(hs, { className: "pds-breadcrumbs__mobileCrumbs", end: !0, to: s.uri }, /* @__PURE__ */ e.createElement(q, { iconName: "angleLeft", iconSize: "sm" }), s.label), h1 = (s, n) => s.uri.split("/").length - n.uri.split("/").length, ys = (a) => {
  var c = a, { ariaLabel: s } = c, n = S(c, ["ariaLabel"]);
  const [r, o] = R(!0), { crumbs: l, deferredCrumbIds: i } = ke(Es), d = [...l].sort(h1), u = () => {
    o(!1);
  }, h = d.map(
    ($, g) => g === d.length - 1 ? /* @__PURE__ */ e.createElement(Ue, { crumb: $, lastCrumb: !0, key: g }) : /* @__PURE__ */ e.createElement(Ue, { crumb: $, key: g })
  ), m = d.map(
    ($, g) => g === d.length - 1 ? /* @__PURE__ */ e.createElement(Ue, { crumb: $, key: `breadcrumb-${g}`, lastCrumb: !0 }) : g == 2 ? /* @__PURE__ */ e.createElement(e.Fragment, null, " ", /* @__PURE__ */ e.createElement("li", { className: r ? "" : "pds-breadcrumbs__hidden" }, /* @__PURE__ */ e.createElement(
      "button",
      {
        key: `breadcrumb-button-${g}`,
        className: "pds-breadcrumbs__expand-button",
        onClick: u
      },
      "..."
    )), /* @__PURE__ */ e.createElement(
      Ue,
      {
        crumb: $,
        classes: r ? "pds-breadcrumbs__hidden" : null,
        key: `breadcrumb-${g}`
      }
    )) : g > 2 && g < d.length - 2 ? /* @__PURE__ */ e.createElement(
      Ue,
      {
        crumb: $,
        classes: r ? "pds-breadcrumbs__hidden" : null,
        key: `breadcrumb-${g}`
      }
    ) : /* @__PURE__ */ e.createElement(Ue, { crumb: $, key: `breadcrumb-${g}` })
  ), p = d.length >= 6 ? m : h, f = d[d.length - 2], C = p1(f);
  return /* @__PURE__ */ e.createElement("nav", { className: "pds-breadcrumbs", "aria-label": s, "aria-live": "polite" }, /* @__PURE__ */ e.createElement("ul", y({ className: "pds-breadcrumbs__item" }, n), p), C);
};
ys.propTypes = {
  ariaLabel: t.string.isRequired,
  crumbs: t.array
};
const g1 = (c) => {
  var r = c, { ariaLabel: s, crumbs: n } = r, a = S(r, ["ariaLabel", "crumbs"]);
  return /* @__PURE__ */ e.createElement(Js, null, /* @__PURE__ */ e.createElement(
    Es.Provider,
    {
      value: {
        crumbs: n,
        defferedCrumbIds: []
      }
    },
    /* @__PURE__ */ e.createElement(ys, y({ crumbs: n, ariaLabel: s }, a))
  ));
};
g1.propTypes = {
  ariaLabel: t.string.isRequired,
  crumbs: t.arrayOf([
    { label: t.string },
    { uri: t.string }
  ])
};
const f1 = [
  "angleDown",
  "angleLeft",
  "angleRight",
  "angleUp",
  "arrowDownToLine",
  "arrowLeft",
  "arrowRight",
  "asterisk",
  "banBug",
  "bars",
  "barsFilter",
  "billboard",
  "bitbucket",
  "bolt",
  "book",
  "books",
  "bracketRight",
  "broomWide",
  "building",
  "buildings",
  "calendarDays",
  "caretDown",
  "caretLeft",
  "caretRight",
  "caretUp",
  "ccAmex",
  "ccDiscover",
  "ccGeneric",
  "ccMC",
  "ccVisa",
  "chartLine",
  "chartNetwork",
  "chartSimple",
  "check",
  "circle",
  "circleCheck",
  "circleExclamation",
  "circleInfo",
  "circleMinus",
  "circleMinusOutline",
  "circleNotch",
  "circlePlus",
  "circlePlusOutline",
  "circleQuestion",
  "circleXmark",
  "cloud",
  "cloudArrowUp",
  "code",
  "codeBranch",
  "codeMerge",
  "command",
  "comment",
  "copy",
  "diamondExclamation",
  "discourse",
  "download",
  "drupal",
  "ellipsis",
  "ellipsisVertical",
  "emptySet",
  "exclamation",
  "externalLink",
  "eye",
  "eyeSlash",
  "facebook",
  "file",
  "fileContract",
  "fileCSV",
  "fileExport",
  "fileImport",
  "filePDF",
  "folder",
  "gear",
  "github",
  "gitlab",
  "globe",
  "globeLine",
  "graduationCap",
  "grid",
  "gripDots",
  "gripDotsVertical",
  "heart",
  "house",
  "idCard",
  "instagram",
  "keySkeleton",
  "laptopCode",
  "leaf",
  "lifeRing",
  "linkedin",
  "linkSimple",
  "linkSimpleSlash",
  "magnifyingGlass",
  "messages",
  "minus",
  "moon",
  "paperclip",
  "paperPlane",
  "pen",
  "phone",
  "play",
  "plus",
  "quotesLeft",
  "quotesRight",
  "rectangleList",
  "robot",
  "rotate",
  "rotateClock",
  "rss",
  "save",
  "server",
  "shield",
  "shovel",
  "siren",
  "sitemap",
  "slack",
  "slashForward",
  "slidersSimple",
  "snowflake",
  "sparkles",
  "squareCheck",
  "squareCode",
  "squareMinus",
  "squarePen",
  "squareQuestion",
  "squareTerminal",
  "star",
  "sun",
  "table",
  "terminal",
  "threads",
  "trash",
  "triangleExclamation",
  "twitter",
  "upload",
  "user",
  "userGear",
  "userPlus",
  "users",
  "video",
  "wavePulse",
  "windowRestore",
  "wordpress",
  "wrench",
  "xmark",
  "xmarkLarge",
  "xTwitter",
  "youtube"
], Ht = t.oneOf(f1), ws = t.oneOf([
  "narrow",
  "standard",
  "wide",
  "x-wide",
  "full"
]), b1 = t.exact({
  /**
   * Label for a menu item
   */
  label: t.string.isRequired,
  /**
   * Is the item a heading?
   */
  isHeading: t.bool.isRequired
}), Ns = t.exact({
  /**
   * Description of the item
   */
  description: t.string,
  /**
   *  Is this item disabled?
   */
  disabled: t.bool,
  /**
   *  Optional icon for this item. Choose from available icons in the Icon component.
   */
  iconName: Ht,
  /**
   * Is the item a link?
   */
  isLink: t.bool.isRequired,
  /**
   * The content of the link.
   */
  linkContent: t.node,
  /**
   *  Optional `data-testid` value for this item.
   */
  testId: t.string
}), ks = t.exact({
  /**
   * (optional) Callback function to execute when menu item is activated
   */
  callback: t.func,
  /**
   * Description of the item
   */
  description: t.string,
  /**
   *  Is this item disabled?
   */
  disabled: t.bool,
  /**
   *  Optional icon for this item. Choose from available icons in the Icon component.
   */
  iconName: Ht,
  /**
   * Optional ID value for this item.
   */
  id: t.string,
  /**
   * Label for a menu item
   */
  label: t.string.isRequired,
  /**
   *  Optional `data-testid` value for this item.
   */
  testId: t.string
}), v1 = t.exact({
  /**
   * Is the item a node?
   */
  isNode: t.bool.isRequired,
  /**
   * The content of the node.
   */
  nodeContent: t.node
}), _1 = t.exact({
  /**
   * Is the item a separator?
   */
  isSeparator: t.bool.isRequired
}), ue = {
  base: "pds-input",
  disabled: "pds-is-disabled",
  required: "pds-is-required",
  error: "pds-has-error",
  success: "pds-has-success",
  readonly: "pds-is-readonly"
}, Kt = (s) => s ? { width: `${s / 16}rem` } : null, Zt = () => /* @__PURE__ */ e.createElement(
  q,
  {
    iconName: "asterisk",
    iconSize: "sm",
    className: "pds-input-label__required"
  }
), ht = ({
  id: s,
  label: n,
  showLabel: a = !0,
  required: c,
  disabled: r,
  isLegend: o,
  className: l
}) => {
  const i = Y([
    "pds-input-label",
    a ? null : "visually-hidden",
    l != null ? l : ""
  ]);
  return o ? /* @__PURE__ */ e.createElement("legend", { className: i, id: `${s}-legend` }, n, c && !r && /* @__PURE__ */ e.createElement(Zt, null)) : /* @__PURE__ */ e.createElement("label", { htmlFor: s, className: i }, n, c && !r && /* @__PURE__ */ e.createElement(Zt, null));
}, Qe = ({
  id: s,
  message: n,
  hasValidationMessage: a,
  validationMessageHasDecorators: c,
  validationStatus: r,
  className: o
}) => {
  const l = "pds-input-message", i = r && a ? `${l}--${r}` : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: Y([l, i, o != null ? o : ""]),
      id: `${s}__message`,
      role: r === "error" ? "alert" : null
    },
    c && r && /* @__PURE__ */ e.createElement(Yt, { variant: r }),
    n
  );
}, E1 = {
  search: "magnifyingGlass",
  error: "triangleExclamation",
  success: "check"
}, Yt = ({ variant: s }) => {
  const n = "pds-input-decorator";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [n, `${n}--${s}`].join(" ").trim().replace(/\s+/g, " ")
    },
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: E1[s],
        iconSize: "md",
        className: `${n}__icon`
      }
    )
  );
}, Hs = ({
  inputId: s,
  shortcutLabel: n
}) => (n1("/", (c) => {
  const r = document.getElementById(s);
  r && r.focus(), c.preventDefault();
}), /* @__PURE__ */ e.createElement("div", { className: "pds-input-search-shortcut" }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, n), /* @__PURE__ */ e.createElement(q, { iconName: "slashForward", iconSize: "md" }))), zs = ({
  id: s,
  clearLabel: n,
  handleClearInput: a
}) => /* @__PURE__ */ e.createElement(
  "button",
  {
    type: "button",
    className: "pds-input-clear-button",
    title: n,
    "aria-controls": s,
    onClick: a
  },
  /* @__PURE__ */ e.createElement(q, { iconName: "xmark", iconSize: "md" })
), C1 = ({
  id: s,
  currentLength: n,
  maxLength: a,
  overLimitMessage: c = "Character limit exceeded by"
}) => {
  const r = n > a, o = n - a, l = "pds-input-character-counter", i = r ? `${l}--overLimit` : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      id: `${s}__counter`,
      className: Y([l, i])
    },
    n,
    "/",
    a,
    /* @__PURE__ */ e.createElement("span", { className: "visually-hidden", "aria-live": "polite" }, r && `${c} ${o}`)
  );
}, Xt = (a) => {
  var c = a, { label: s } = c, n = S(c, ["label"]);
  return /* @__PURE__ */ e.createElement("span", y({ className: "visually-hidden" }, n), s);
}, $1 = Be(
  (o, r) => {
    var l = o, { children: s, isActive: n, className: a } = l, c = S(l, ["children", "isActive", "className"]);
    const i = fs(), d = "pds-input__select-option", u = n ? `${d}--active` : null;
    return /* @__PURE__ */ e.createElement(
      "li",
      y({
        ref: r,
        role: "option",
        id: i,
        "aria-selected": n,
        className: Y([d, u, a])
      }, c),
      s
    );
  }
), zt = (i) => {
  var d = i, {
    colorType: s = "full-color",
    isInline: n = !1,
    label: a = "Loading",
    showLabel: c = !1,
    size: r = "md",
    className: o = ""
  } = d, l = S(d, [
    "colorType",
    "isInline",
    "label",
    "showLabel",
    "size",
    "className"
  ]);
  const u = "pds-spinner", h = s !== "full-color" ? `${u}--${s}` : null, m = `${u}--${r}`, p = n ? `${u}--inline` : null;
  return /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: [u, h, p, m, o].join(" ").trim().replace(/\s+/g, " "),
      role: "status"
    }, l),
    /* @__PURE__ */ e.createElement("span", { className: `${u}__icon` }),
    c && !n ? /* @__PURE__ */ e.createElement("span", { className: `${u}__label` }, a) : /* @__PURE__ */ e.createElement(Xt, { label: a })
  );
}, Ke = Be(
  (C, f) => {
    var $ = C, {
      ariaLabel: s,
      buttonType: n = "button",
      disabled: a = !1,
      displayType: c = "label-only",
      iconName: r,
      isLoading: o = !1,
      isSplitButton: l = !1,
      label: i,
      onClick: d,
      size: u = "md",
      variant: h = "primary",
      className: m
    } = $, p = S($, [
      "ariaLabel",
      "buttonType",
      "disabled",
      "displayType",
      "iconName",
      "isLoading",
      "isSplitButton",
      "label",
      "onClick",
      "size",
      "variant",
      "className"
    ]);
    const g = "pds-button", _ = u !== "md" ? `${g}--${u}` : null, b = h !== "primary" ? `${g}--${h}` : null;
    let v;
    switch (u) {
      case "sm":
        v = "sm";
        break;
      case "md":
        v = "md";
        break;
      case "lg":
        v = "lg";
    }
    const E = /* @__PURE__ */ e.createElement(
      q,
      {
        key: "icon",
        iconName: r,
        iconSize: v,
        className: `${g}__icon`
      }
    );
    let w = [i];
    return c == "icon-start" && r && w.unshift(E), c == "icon-end" && r && w.push(E), l && (w = [E], s = i), /* @__PURE__ */ e.createElement(
      "button",
      ge(y({}, p), {
        type: n,
        className: [g, _, b, m].join(" ").trim().replace(/\s+/g, " "),
        disabled: a || o,
        "aria-label": s,
        onClick: d,
        ref: f
      }),
      o && /* @__PURE__ */ e.createElement(zt, { className: `${g}__loading-indicator`, size: "md" }),
      w
    );
  }
);
Ke.displayName = "Button";
Ke.propTypes = {
  /**
   * Aria-label attribute.
   */
  ariaLabel: t.string,
  /**
   * Type of button
   */
  buttonType: t.oneOf(["button", "submit", "reset"]),
  /**
   * Is the button disabled?
   */
  disabled: t.bool,
  /**
   * How the button is displayed.
   */
  displayType: t.oneOf(["label-only", "icon-start", "icon-end"]),
  /**
   * Which icon to render
   */
  iconName: Ht,
  /**
   * Is the button in a loading state?
   */
  isLoading: t.bool,
  /**
   * Will this be used for a split button?
   */
  isSplitButton: t.bool,
  /**
   * The text of the button
   */
  label: t.node.isRequired,
  /**
   * Click event handler callback
   */
  onClick: t.func,
  /**
   * Which size of button to render
   */
  size: t.oneOf(["sm", "md", "lg"]),
  /**
   * Which variant of button to render
   */
  variant: t.oneOf([
    "primary",
    "secondary",
    "subtle",
    "brand",
    "brand-secondary",
    "critical",
    "navbar",
    "inline"
  ]),
  /**
   * Additional class names
   */
  className: t.string
};
const ct = (d) => {
  var u = d, {
    disabled: s = !1,
    displayType: n = "label-only",
    iconName: a,
    linkContent: c,
    size: r = "md",
    variant: o = "primary",
    className: l
  } = u, i = S(u, [
    "disabled",
    "displayType",
    "iconName",
    "linkContent",
    "size",
    "variant",
    "className"
  ]);
  const h = "pds-button-link", m = "pds-button", p = r !== "md" ? `${m}--${r}` : null, f = o !== "primary" ? `${m}--${o}` : null, C = Y([
    m,
    p,
    f
  ]), $ = Pe(c) ? c.props.children : null, g = /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: a,
      iconSize: r,
      className: `${h}__icon`,
      key: a
    }
  );
  let _ = [$];
  n === "icon-start" && a ? _ = [g, $] : n === "icon-end" && a && (_ = [$, g]);
  const b = Pe(c) ? Ge(c, {
    className: C,
    children: _
  }) : null;
  return s ? /* @__PURE__ */ e.createElement(
    Ke,
    {
      className: Y([h, l != null ? l : ""]),
      disabled: !0,
      label: _,
      size: r,
      variant: o
    }
  ) : /* @__PURE__ */ e.createElement("span", y({ className: Y([h, l != null ? l : ""]) }, i), b);
}, y1 = (h) => {
  var m = h, {
    bodyText: s,
    headingLevel: n = "h2",
    headingText: a,
    image: c,
    isClickable: r = !1,
    kickerText: o,
    primaryLink: l,
    secondaryLink: i,
    className: d
  } = m, u = S(m, [
    "bodyText",
    "headingLevel",
    "headingText",
    "image",
    "isClickable",
    "kickerText",
    "primaryLink",
    "secondaryLink",
    "className"
  ]);
  const p = "pds-card", f = r ? `${p}--clickable` : null, C = `${n}`, $ = l.type, g = c ? /* @__PURE__ */ e.createElement("div", { className: `${p}__image` }, !r && l ? /* @__PURE__ */ e.createElement(
    $,
    y({
      tabIndex: "-1",
      "aria-hidden": "true"
    }, l.props),
    /* @__PURE__ */ e.createElement("img", { src: c.src, alt: c.alt })
  ) : /* @__PURE__ */ e.createElement("img", { src: c.src, alt: c.alt })) : null, _ = /* @__PURE__ */ e.createElement("div", { className: `${p}__text-elements` }, o && /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${p}__kicker pds-overline-text pds-overline-text--sm`
    },
    o
  ), a && /* @__PURE__ */ e.createElement(C, { className: `${p}__heading` }, a), s && /* @__PURE__ */ e.createElement("div", { className: `${p}__bodytext` }, /* @__PURE__ */ e.createElement("p", null, s)), !r && l && /* @__PURE__ */ e.createElement("div", { className: `${p}__links pds-button-group` }, /* @__PURE__ */ e.createElement(ct, { linkContent: l, variant: "primary" }), i && /* @__PURE__ */ e.createElement(ct, { linkContent: i, variant: "secondary" })));
  return r && l ? /* @__PURE__ */ e.createElement(
    $,
    y({
      className: [p, f, d].join(" ").trim().replace(/\s+/g, " ")
    }, l.props),
    g,
    _
  ) : /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [p, f, d].join(" ").trim().replace(/\s+/g, " ")
    }, u),
    g,
    _
  );
};
y1.propTypes = {
  /**
   * Short description or summary. Can be string or JSX.
   */
  bodyText: t.oneOfType([t.string, t.node]),
  /**
   *  Heading level or `span`
   */
  headingLevel: t.oneOf(["h2", "h3", "h4", "span"]),
  /**
   * Card heading
   */
  headingText: t.string.isRequired,
  /**
   * Card image
   */
  image: t.shape({
    src: t.string,
    alt: t.string
  }),
  /**
   * If the whole card is clickable. If true, the primary link will be used, and the link buttons will be hidden. The secondary link will be ignored.
   */
  isClickable: t.bool,
  /**
   * Card kicker
   */
  kickerText: t.string,
  /**
   * Primary link. A link element using the router of your choice.
   */
  primaryLink: t.node.isRequired,
  /**
   * Optional secondary link. A link element using the router of your choice.
   */
  secondaryLink: t.node,
  /**
   * Additional class names
   */
  className: t.string
};
const w1 = (u) => {
  var h = u, {
    id: s,
    initialSelection: n,
    label: a,
    labelDisplay: c = "left",
    layout: r = "auto",
    onChange: o,
    options: l,
    className: i
  } = h, d = S(h, [
    "id",
    "initialSelection",
    "label",
    "labelDisplay",
    "layout",
    "onChange",
    "options",
    "className"
  ]);
  const m = "pds-card-select-group";
  let p = `${m}__legend`;
  c === "center" && (p = `${m}__legend ${m}__legend--center`), c === "hidden" && (p = `${m}__legend visually-hidden`);
  const [f, C] = R(n), $ = (E) => {
    C(E.target.value), o && o(E.target.value);
  }, g = l.length, _ = "pds-grid-item pds-grid-item--sm-4 pds-grid-item--md-6", b = "pds-grid-item pds-grid-item--sm-4 pds-grid-item--md-4";
  let v = "";
  return r === "twoAcross" ? v = _ : r === "threeAcross" ? v = b : r === "auto" && (g % 3 === 0 ? v = b : g % 2 === 0 ? v = _ : v = b), /* @__PURE__ */ e.createElement(
    "fieldset",
    y({
      className: [m, i].join(" ").trim().replace(/\s+/g, " "),
      id: s
    }, d),
    /* @__PURE__ */ e.createElement("legend", { className: p }, a),
    /* @__PURE__ */ e.createElement("div", { className: `${m}__options pds-grid pds-grid--narrow` }, l.map((E, w) => /* @__PURE__ */ e.createElement(
      "div",
      {
        className: [`${m}__option`, v].join(" ").trim().replace(/\s+/g, " "),
        key: `${s}-option-${w}`
      },
      /* @__PURE__ */ e.createElement(
        "input",
        {
          type: "radio",
          id: `${s}-option-${w}`,
          name: s,
          value: E.value,
          onClick: $,
          defaultChecked: f === E.value
        }
      ),
      /* @__PURE__ */ e.createElement(
        "label",
        {
          htmlFor: `${s}-option-${w}`,
          className: f === E.value ? `${m}__option-label ${m}__option-label--selected` : `${m}__option-label`
        },
        /* @__PURE__ */ e.createElement("div", { className: `${m}__option-label-indicator` }, /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: f === E.value ? "circleCheck" : "circle",
            iconSize: "xl",
            className: f === E.value ? `${m}__option-icon ${m}__option-icon--selected` : `${m}__option-icon`
          }
        )),
        /* @__PURE__ */ e.createElement("div", { className: `${m}__option-label-text` }, E.label, E.description && /* @__PURE__ */ e.createElement("div", { className: `${m}__option-description` }, E.description))
      )
    )))
  );
};
w1.propTypes = {
  /**
   * Unique ID for the card select group
   */
  id: t.string.isRequired,
  /**
   * Optional initial selected option value
   */
  initialSelection: t.string,
  /**
   * Label for the card select group
   */
  label: t.string.isRequired,
  /**
   * Display of the component label. `hidden` visually hides the label but keeps it accessible to screen readers.
   */
  labelDisplay: t.oneOf(["left", "center", "hidden"]),
  /**
   * Column layout of the cards at breakpoints medium and above.
   */
  layout: t.oneOf(["auto", "twoAcross", "threeAcross"]),
  /**
   * Callback function that will return the updated value from the instance when it changes.
   * Function should have the shape of: `(value) => { <do stuff here> } `.
   */
  onChange: t.func,
  /**
   * Array of card options
   */
  options: t.arrayOf(
    t.shape({
      /**
       * Option label
       */
      label: t.oneOfType([t.string, t.node]).isRequired,
      /**
       * Option description
       */
      description: t.oneOfType([t.string, t.node]),
      /**
       * Option value
       */
      value: t.string.isRequired
    })
  ),
  /**
   * Additional class names
   */
  className: t.string
};
const N1 = (u) => {
  var h = u, {
    backgroundColor: s = "default",
    containerWidth: n = "standard",
    headingLevel: a = "h2",
    headingText: c,
    leadText: r,
    primaryLink: o,
    secondaryLink: l,
    className: i
  } = h, d = S(h, [
    "backgroundColor",
    "containerWidth",
    "headingLevel",
    "headingText",
    "leadText",
    "primaryLink",
    "secondaryLink",
    "className"
  ]);
  const m = "pds-cta-slice", p = s && s !== "default" ? `${m}--${s}` : null, f = n && n !== "default" ? `pds-container pds-container--${n}` : "pds-container", C = `${a}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [m, p, i].join(" ").trim().replace(/\s+/g, " ")
    }, d),
    /* @__PURE__ */ e.createElement("div", { className: f }, c && /* @__PURE__ */ e.createElement(C, { className: `${m}__heading pds-ts-4xl` }, c), r && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${m}__lead-text pds-lead-text pds-lead-text--sm`
      },
      r
    ), o && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${m}__links pds-button-group pds-button-group--lg`
      },
      /* @__PURE__ */ e.createElement(
        "a",
        {
          href: o.url,
          className: "pds-button pds-button--lg",
          target: o.target
        },
        o.text
      ),
      l && /* @__PURE__ */ e.createElement(
        "a",
        {
          href: l.url,
          className: "pds-button pds-button--lg pds-button--secondary",
          target: l.target
        },
        l.text
      )
    ))
  );
};
N1.propTypes = {
  /**
   * Background color of slice
   */
  backgroundColor: t.oneOf(["default", "secondary"]),
  /**
   * PDS container width.
   */
  containerWidth: ws,
  /**
   *  Heading level
   */
  headingLevel: t.oneOf(["h2", "h3", "h4"]),
  /**
   * Heading text
   */
  headingText: t.string.isRequired,
  /**
   * Further explain block
   */
  leadText: t.string,
  /**
   * Primary link.
   */
  primaryLink: t.shape({
    text: t.string,
    url: t.string,
    target: t.oneOf(["_self", "_blank"])
  }).isRequired,
  /**
   * Optional secondary link
   */
  secondaryLink: t.shape({
    text: t.string,
    url: t.string,
    target: t.oneOf(["_self", "_blank"])
  }),
  /**
   * Additional class names
   */
  className: t.string
};
const Fe = $t(null), k1 = ({
  children: s,
  mobileMenuMaxWidth: n = 640
}) => {
  const [a, c] = R(1025);
  oe(() => (c(window.innerWidth), window.addEventListener("resize", r), () => {
    window.removeEventListener("resize", r);
  }), []);
  const r = () => {
    c(window.innerWidth);
  }, l = {
    isMobile: a <= n,
    mobileMenuMaxWidth: n,
    windowWidth: a
  };
  return /* @__PURE__ */ e.createElement(Fe.Provider, { value: l }, s);
}, H1 = (r) => {
  var o = r, {
    destination: s = "main",
    text: n = "Skip to main content",
    className: a
  } = o, c = S(o, [
    "destination",
    "text",
    "className"
  ]);
  return /* @__PURE__ */ e.createElement(
    "a",
    y({
      href: `#${s}`,
      className: ["pds-skiplink", a].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    n
  );
}, Mt = $t(null), K2 = (m) => {
  var p = m, {
    children: s,
    hasSidebarToggle: n = !0,
    initialSidebarExpanded: a = !0,
    isAdmin: c = !1,
    logoLinkContent: r,
    sidebarCollapsedWidth: o = 2.125,
    sidebarExpandedWidth: l = 13.5,
    sidebarToggleLabel: i = "Toggle sidebar",
    skiplinkText: d = "Skip to main content",
    className: u
  } = p, h = S(p, [
    "children",
    "hasSidebarToggle",
    "initialSidebarExpanded",
    "isAdmin",
    "logoLinkContent",
    "sidebarCollapsedWidth",
    "sidebarExpandedWidth",
    "sidebarToggleLabel",
    "skiplinkText",
    "className"
  ]);
  const [f, C] = R(
    a
  ), { isMobile: $ } = ke(Fe), g = se(), [_] = kt(g), b = _.width, v = {
    isSidebarExpanded: $ ? !0 : f,
    logoLinkContent: r,
    navbarWidth: b,
    isAdmin: c
  }, E = "pds-dashboard", w = $ ? `${E}--isMobile` : `${E}--notMobile`, L = $ ? null : f ? `${E}--sidebarExpanded` : `${E}--sidebarCollapsed`, N = f ? `${l}rem` : `${o}rem`, M = {
    width: N,
    transition: "width 200ms ease-in-out"
  }, k = $ ? {} : {
    width: `calc(100% - ${N})`,
    transition: "width 200ms ease-in-out"
  }, x = () => {
    C(!f);
  }, z = $s(s), T = z.header, V = z.sidebar, H = z.main, I = z.footer, A = /* @__PURE__ */ e.createElement("aside", { className: `${E}__sidebar` }, V), j = /* @__PURE__ */ e.createElement("aside", { className: `${E}__sidebar`, style: M }, n && /* @__PURE__ */ e.createElement(
    "button",
    {
      className: `${E}__sidebar-toggle-button`,
      onClick: x,
      "aria-expanded": f,
      "aria-label": i
    },
    /* @__PURE__ */ e.createElement("span", { className: `${E}__sidebar-toggle-icon` }, /* @__PURE__ */ e.createElement(q, { iconName: "angleLeft", iconSize: "sm" }))
  ), /* @__PURE__ */ e.createElement("div", { className: `${E}__sidebar-inner` }, V));
  return /* @__PURE__ */ e.createElement(Mt.Provider, { value: v }, /* @__PURE__ */ e.createElement(H1, { text: d, destination: "main" }), /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: Y([
        E,
        w,
        L,
        "pds-typography--product",
        u != null ? u : ""
      ])
    }, h),
    $ && T,
    $ ? A : j,
    /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: g,
        className: `${E}__container`,
        style: k
      },
      !$ && /* @__PURE__ */ e.createElement("div", { className: `${E}__header` }, T),
      /* @__PURE__ */ e.createElement("main", { id: "main", className: `${E}__main` }, /* @__PURE__ */ e.createElement("div", { className: `${E}__main-inner` }, H), I && /* @__PURE__ */ e.createElement("footer", { className: `${E}__footer` }, I))
    )
  ));
}, Qt = (i) => {
  var d = i, {
    color: s = "transparent",
    hasStatusIndicator: n = !1,
    label: a,
    statusIndicatorText: c = "Status indicator: ",
    statusType: r,
    className: o
  } = d, l = S(d, [
    "color",
    "hasStatusIndicator",
    "label",
    "statusIndicatorText",
    "statusType",
    "className"
  ]);
  const u = "pds-status-badge", h = `${u}--${s}`, m = `${u}__status`, p = r ? `${m}--${r}` : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [u, h, o != null ? o : ""].join(" ").trim().replace(/\s+/g, " ")
    }, l),
    n === !0 && /* @__PURE__ */ e.createElement("span", { className: [m, p].join(" ").trim() }, r && /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, c, " ", r)),
    /* @__PURE__ */ e.createElement("span", { className: `${u}__label` }, a)
  );
}, Ms = ({ option: s }) => {
  const n = "pds-dashboard-search", a = {
    drupal: "drupal",
    wordpress: "wordpress",
    gatsby: "bolt",
    nextjs: "bolt"
  }, c = s.type ? a[s.type] : "bolt", r = se(), [o] = kt(r), l = o.width / 16 - 7.5;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: r,
      className: `${n}__option-display`,
      title: s.name
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${n}__option-inner`,
        style: { pointerEvents: "none" }
      },
      /* @__PURE__ */ e.createElement("div", { className: `${n}__option-icon` }, /* @__PURE__ */ e.createElement(q, { iconName: c })),
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: `${n}__option-label`,
          style: { maxWidth: `${l}rem` }
        },
        s.name
      )
    ),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${n}__option-status`,
        style: { pointerEvents: "none" }
      },
      /* @__PURE__ */ e.createElement(
        Qt,
        {
          color: "neutral",
          hasStatusIndicator: !0,
          label: s.status === "frozen" ? "Frozen" : "Active",
          statusType: s.status === "frozen" ? "frozen" : "success"
        }
      )
    )
  );
};
Ms.propTypes = { option: t.object };
const z1 = Be(
  (z, x) => {
    var T = z, {
      defaultValue: s,
      disabled: n = !1,
      hasClearButton: a = !0,
      hasDropdownTrigger: c = !1,
      hasSearchIcon: r = !0,
      hasSearchShortcut: o = !1,
      id: l,
      inputWidth: i,
      isLoading: d = !1,
      label: u,
      labelStrings: h = {
        clearButton: "Clear input text",
        inputInstructions: "Type to search options",
        searchShortcut: "Press / to focus the search field",
        triggerButton: "Toggle dropdown menu"
      },
      loadingText: m = "Loading results...",
      message: p,
      noResultsText: f = "No results found",
      onBlur: C,
      onClear: $,
      onFocus: g,
      onOptionSelect: _,
      options: b,
      placeholder: v,
      required: E = !1,
      showLabel: w = !0,
      validationMessage: L,
      validationStatus: N,
      className: M
    } = T, k = S(T, [
      "defaultValue",
      "disabled",
      "hasClearButton",
      "hasDropdownTrigger",
      "hasSearchIcon",
      "hasSearchShortcut",
      "id",
      "inputWidth",
      "isLoading",
      "label",
      "labelStrings",
      "loadingText",
      "message",
      "noResultsText",
      "onBlur",
      "onClear",
      "onFocus",
      "onOptionSelect",
      "options",
      "placeholder",
      "required",
      "showLabel",
      "validationMessage",
      "validationStatus",
      "className"
    ]);
    const V = Kt(i), H = "pds-combobox", I = n ? ue.disabled : null, A = E && !n ? ue.required : null, j = N === "error" ? ue.error : null, B = N === "success" ? ue.success : null;
    let W = null;
    r && (W = "search"), N === "error" && (W = "error"), N === "success" && (W = "success");
    const Z = L || p, K = (pe) => {
      const fe = b.find((xe) => xe.value === pe);
      return fe ? fe.label : "";
    }, [O, D] = R(!1), [F, U] = R(null), [ie, Q] = R(
      s ? K(s) : ""
    ), [ve, te] = R([]), de = se([]), { context: le, refs: ne } = Ie({
      open: O,
      onOpenChange: D,
      whileElementsMounted: qe
    }), Ee = Te(le, { role: "listbox" }), ee = Se(le), J = pt(le, {
      listRef: de,
      activeIndex: F,
      onNavigate: U,
      virtual: !0,
      loop: !0,
      allowEscape: !0
    }), { getReferenceProps: G, getFloatingProps: he, getItemProps: we } = Oe([Ee, ee, J]), { isMounted: ae, styles: ce } = Xe(le, {
      duration: {
        open: 300,
        close: 150
      },
      initial: {
        opacity: 0
      },
      open: {
        opacity: 1
      },
      close: {
        opacity: 0
      }
    }), Le = () => {
      D(!O);
    }, He = () => {
      var pe;
      Q(""), U(null), D(!0), (pe = ne.domReference.current) == null || pe.focus(), $ && $();
    }, ze = (pe) => {
      let fe = pe.target.value;
      fe.length > 0 && (fe = fe.trimStart()), Q(fe), fe ? (U(null), D(!0)) : D(!1);
    }, _e = (pe) => {
      C && g(pe);
    }, We = (pe) => {
      g && g(pe);
    }, gt = (pe) => {
      const fe = ve[pe];
      Q(fe.label), U(null), D(!1), _ && _(fe);
    }, Vt = (pe) => pe.map((xe) => {
      const { label: Re, optionDisplay: De, value: Ae, searchIndex: ft } = xe, P = Ae || Re, re = [Re, Ae];
      return ft && re.push(...ft), {
        label: Re,
        value: P,
        searchIndex: re,
        optionDisplay: De
      };
    });
    oe(() => {
      const pe = Vt(b).filter(
        (fe) => {
          const xe = fe.searchIndex.map(
            (De) => De.toLowerCase()
          ), Re = ie.toLowerCase();
          return xe.some((De) => De.includes(Re));
        }
      );
      te(pe);
    }, [ie, d, b]);
    const et = ve.map((pe, fe) => {
      const { label: xe, value: Re, optionDisplay: De } = pe;
      return /* @__PURE__ */ e.createElement(
        $1,
        ge(y({
          key: pe
        }, we({
          key: Re,
          ref(Ae) {
            de.current[fe] = Ae;
          },
          onClick() {
            var Ae;
            gt(fe), (Ae = ne.domReference.current) == null || Ae.focus();
          }
        })), {
          tabIndex: F === fe ? 0 : -1,
          isActive: F === fe
        }),
        De || xe
      );
    });
    return /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: Y([
          ue.base,
          H,
          I,
          A,
          j,
          B,
          M != null ? M : ""
        ]),
        style: i ? V : null
      }, k),
      /* @__PURE__ */ e.createElement(
        ht,
        {
          id: l,
          label: u,
          showLabel: w,
          required: E,
          disabled: n
        }
      ),
      /* @__PURE__ */ e.createElement(
        "span",
        {
          className: `${H}__input-wrapper`,
          ref: x,
          id: l,
          "aria-disabled": n ? !0 : null,
          "aria-required": E ? !0 : null,
          "aria-invalid": N === "error" ? !0 : null,
          "aria-describedby": Z ? `${l}__message` : null
        },
        W && /* @__PURE__ */ e.createElement(Yt, { variant: W }),
        /* @__PURE__ */ e.createElement(
          "input",
          y({
            ref: ne.setReference,
            className: `${H}__input`,
            id: `input-${l}`,
            autoComplete: "off"
          }, G({
            "aria-autocomplete": "list",
            "aria-label": h.inputInstructions,
            disabled: n,
            placeholder: v,
            value: ie,
            onBlur: _e,
            onChange: ze,
            onFocus: We,
            onKeyDown(pe) {
              pe.key === "Enter" && F != null && ve[F] && gt(F);
            }
          }))
        ),
        ie && a && /* @__PURE__ */ e.createElement(
          zs,
          {
            id: `input-${l}`,
            clearLabel: h.clearButton,
            handleClearInput: He
          }
        ),
        o && !ie && /* @__PURE__ */ e.createElement(
          Hs,
          {
            inputId: `input-${l}`,
            shortcutLabel: h.searchShortcut
          }
        ),
        c && /* @__PURE__ */ e.createElement(
          "button",
          ge(y({
            ref: ne.setReference
          }, G({
            onClick: Le,
            disabled: n,
            "aria-expanded": O,
            "aria-label": h.triggerButton
          })), {
            className: `${H}__trigger`
          }),
          /* @__PURE__ */ e.createElement(
            q,
            {
              iconName: "angleDown",
              className: `${H}__trigger-icon`
            }
          )
        )
      ),
      ae && /* @__PURE__ */ e.createElement(
        "div",
        y({
          ref: ne.setFloating,
          className: `${H}__dropdown`
        }, he({
          style: {
            zIndex: "var(--pds-z-index-dropdown)"
          }
        })),
        /* @__PURE__ */ e.createElement("div", { style: y({}, ce) }, d ? /* @__PURE__ */ e.createElement("div", { className: `${H}__loading` }, m) : ve.length > 0 ? /* @__PURE__ */ e.createElement("ul", { className: `${H}__options` }, et) : /* @__PURE__ */ e.createElement("div", { className: `${H}__no-results` }, f))
      ),
      Z && /* @__PURE__ */ e.createElement(
        Qe,
        {
          id: l,
          message: Z,
          hasValidationMessage: !!L,
          validationMessageHasDecorators: !1,
          validationStatus: N
        }
      )
    );
  }
), M1 = (C) => {
  var $ = C, {
    disabled: s = !1,
    id: n,
    isLoading: a = !1,
    label: c = "Search sites",
    labelStrings: r = {
      clearButton: "Clear input text",
      inputInstructions: "Type to search options",
      openSearchButton: "Open search field"
    },
    loadingText: o = "Loading results...",
    noResultsText: l = "No results found",
    onFocus: i,
    onOptionSelect: d,
    placeholder: u = "Search sites",
    siteList: h,
    horizontalOffset: m = 0,
    className: p
  } = $, f = S($, [
    "disabled",
    "id",
    "isLoading",
    "label",
    "labelStrings",
    "loadingText",
    "noResultsText",
    "onFocus",
    "onOptionSelect",
    "placeholder",
    "siteList",
    "horizontalOffset",
    "className"
  ]);
  const [g, _] = R(!1), [b, v] = R(null), E = se(null);
  let w = !1;
  const L = ke(Fe);
  L && (w = L.isMobile);
  let N = null, M = !1;
  const k = ke(Mt);
  k && (N = k.navbarWidth, M = k.isAdmin);
  const x = 2.25, z = 22, T = M ? 14.25 : 9.25, V = N > 900 ? z : N / 16 - (T + m) - x * 0.675;
  let H = x;
  g && !N && (H = z), g && N && (H = V);
  const I = {
    right: `${T + m}rem`,
    width: `${H}rem`
  }, A = "pds-dashboard-search", j = w ? `${A}--isMobile` : null, B = () => {
    _(!0), setTimeout(() => {
      E.current.querySelector("input").focus();
    }, 500);
  }, W = () => {
    setTimeout(() => {
      _(!1);
    }, 150);
  }, Z = (U) => {
    v(U.value), d && d(U);
  };
  oe(() => {
    if (g) {
      const U = E.current.querySelector("input");
      return U.addEventListener("blur", W), () => {
        U.removeEventListener("blur", W);
      };
    }
  }, [g]);
  const K = h.map((U) => {
    const { id: ie, name: Q } = U;
    return {
      label: Q,
      value: ie,
      optionDisplay: /* @__PURE__ */ e.createElement(Ms, { option: U })
    };
  }), O = /* @__PURE__ */ e.createElement(
    z1,
    {
      ref: E,
      disabled: s,
      hasClearButton: !1,
      id: `${n}-combobox`,
      defaultValue: b,
      isLoading: a,
      label: c,
      labelStrings: r,
      loadingText: o,
      noResultsText: l,
      onFocus: i,
      onOptionSelect: Z,
      placeholder: u,
      options: K,
      showLabel: !1,
      className: `${A}__combobox`
    }
  ), D = /* @__PURE__ */ e.createElement("div", { className: `${A}--inner` }, /* @__PURE__ */ e.createElement(
    "span",
    {
      style: g ? { visibility: "visible" } : { visibility: "hidden" }
    },
    O
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      className: `${A}__search-toggle`,
      "aria-label": r.openSearchButton,
      onClick: B,
      style: g ? { visibility: "hidden" } : { visibility: "visible" }
    },
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: "magnifyingGlass",
        className: `${A}__search-toggle-icon`
      }
    )
  )), F = /* @__PURE__ */ e.createElement("div", { className: `${A}--mobile-inner` }, O);
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [A, j, p].join(" ").trim().replace(/\s+/g, " "),
      id: n,
      style: w ? null : I,
      onKeyDown: w ? null : (U) => {
        U.key === "Escape" && W();
      }
    }, f),
    w ? F : D
  );
};
M1.propTypes = {
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * Input ID.
   */
  id: t.string,
  /**
   * Are the site options in the process of being loaded?
   */
  isLoading: t.bool,
  /**
   * Label for the input. Will be rendered as an aria-label.
   */
  label: t.string,
  /**
   * Strings for the label and input instructions.
   */
  labelStrings: t.shape({
    /**
     * Clear button label
     */
    clearButton: t.string,
    /**
     * Input instructions
     */
    inputInstructions: t.string,
    /**
     * Open search button label
     */
    openSearchButton: t.string
  }),
  /**
   * Text to display when site options are still loading.
   */
  loadingText: t.string,
  /**
   * Text to display when no results are found.
   */
  noResultsText: t.string,
  /**
   * Optional callback function when the search input field is focused.
   */
  onFocus: t.func,
  /**
   * Callback function that will return the selected option object when selected.
   * Function should have the shape of: `(option) => { <do stuff here> } `.
   */
  onOptionSelect: t.func,
  /**
   * Optional placeholder text to display when the input field is empty.
   */
  placeholder: t.string,
  /**
   * List of sites to display in the search dropdown.
   */
  siteList: t.arrayOf(
    t.shape({
      /**
       * Site ID
       */
      id: t.string,
      /**
       * Site name.
       */
      name: t.string,
      /**
       * Site status
       */
      status: t.oneOf(["active", "frozen"]),
      /**
       * Site type
       */
      type: t.oneOf(["drupal", "wordpress", "gatsby", "nextjs"])
    })
  ),
  /**
   * offset for starting right position for the search input in rems.
   */
  horizontalOffset: t.number,
  /**
   * Additional class names
   */
  className: t.string
};
const L1 = (l) => {
  var i = l, {
    children: s,
    id: n,
    isOpen: a = !1,
    summary: c,
    className: r
  } = i, o = S(i, [
    "children",
    "id",
    "isOpen",
    "summary",
    "className"
  ]);
  const d = n || `expansion-panel-${je()}`, u = "pds-expansion-panel";
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [u, r].join(" ").trim().replace(/\s+/g, " ")
    }, o),
    /* @__PURE__ */ e.createElement("details", { key: c, id: d, open: a }, /* @__PURE__ */ e.createElement("summary", null, /* @__PURE__ */ e.createElement("span", null, c), /* @__PURE__ */ e.createElement(q, { iconName: "angleDown", className: `${u}__icon` })), /* @__PURE__ */ e.createElement("div", { className: `${u}__content` }, s))
  );
};
L1.propTypes = {
  /**
   * The content of the expansion panel.
   */
  children: t.node,
  /**
   * The ID of the expansion panel. If not provided, a unique ID will be generated.
   */
  id: t.string,
  /**
   * Whether the expansion panel is open or not.
   */
  isOpen: t.bool,
  /**
   * The summary label of the expansion panel.
   */
  summary: t.oneOfType([t.string, t.node]),
  /**
   * Additional class names.
   */
  className: t.string
};
const x1 = (r) => {
  var o = r, {
    children: s,
    displayType: n = "standard",
    className: a
  } = o, c = S(o, [
    "children",
    "displayType",
    "className"
  ]);
  const l = "pds-expansion-panel-group", i = `${l}--${n}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [l, i, a].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    s
  );
};
x1.propTypes = {
  /**
   * The content of the expansion panel group. This should be a series of ExpansionPanel components.
   */
  children: t.node,
  /**
   * The display type of the expansion panel group.
   */
  displayType: t.oneOf(["standard", "no-border", "stacked"]),
  /**
   * Additional class names
   */
  className: t.string
};
const $e = {
  error: "pds-has-error",
  success: "pds-has-success",
  required: "pds-is-required",
  disabled: "pds-is-disabled"
}, Lt = ({ id: s, label: n, handleClearInput: a }) => /* @__PURE__ */ e.createElement(
  "button",
  {
    type: "button",
    className: "pds-input__clear",
    title: n,
    "aria-controls": s,
    onClick: a
  },
  /* @__PURE__ */ e.createElement(q, { iconName: "xmark" })
);
Lt.propTypes = {
  id: t.string.isRequired,
  label: t.string.isRequired,
  handleClearInput: t.func
};
const rt = ({ type: s }) => {
  let n;
  switch (s) {
    case "search":
      n = "magnifyingGlass";
      break;
    case "error":
      n = "triangleExclamation";
      break;
    case "success":
      n = "check";
      break;
  }
  return /* @__PURE__ */ e.createElement("div", { className: "pds-input-field__decorator" }, /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: n,
      iconSize: "md",
      className: "pds-input-field__decorator-icon"
    }
  ));
};
rt.propTypes = {
  type: t.oneOf(["search", "error", "success"]).isRequired
};
const Ls = ({ label: s }) => /* @__PURE__ */ e.createElement("div", { className: "pds-input__search-shortcut" }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, s), /* @__PURE__ */ e.createElement(q, { iconName: "slashForward" }));
Ls.propTypes = {
  label: t.string.isRequired
};
const xs = Be(
  (o, r) => {
    var l = o, { children: s, active: n, className: a } = l, c = S(l, ["children", "active", "className"]);
    const i = fs(), d = "pds-input__option", u = n ? `${d}--active` : null;
    return /* @__PURE__ */ e.createElement(
      "li",
      y({
        ref: r,
        role: "option",
        id: i,
        className: [d, u, a].join(" ").trim().replace(/\s+/g, " "),
        "aria-selected": n
      }, c),
      s
    );
  }
);
xs.propTypes = {
  children: t.node.isRequired,
  active: t.bool,
  className: t.string
};
const Je = Be(
  (_, g) => {
    var b = _, {
      children: s,
      decorator: n,
      disabled: a = !1,
      id: c,
      inputFieldType: r,
      inputWidth: o,
      isFieldset: l = !1,
      label: i,
      message: d,
      messagePosition: u = "after",
      readonly: h = !1,
      required: m = !1,
      showLabel: p = !0,
      validationState: f,
      className: C
    } = b, $ = S(b, [
      "children",
      "decorator",
      "disabled",
      "id",
      "inputFieldType",
      "inputWidth",
      "isFieldset",
      "label",
      "message",
      "messagePosition",
      "readonly",
      "required",
      "showLabel",
      "validationState",
      "className"
    ]);
    const v = "pds-input-wrapper", E = `${v}--${r}`, w = "pds-input-label", L = `pds-input-field__message pds-input-field__message--${u}`, N = f === "error" ? "pds-has-error" : null, M = f === "success" ? "pds-has-success" : null, k = a ? "pds-is-disabled" : null, x = h ? "pds-is-readonly" : null, z = m && !a ? "pds-is-required" : null, T = o ? `${o / 16}rem` : null, V = o ? { width: T } : null, H = l ? "fieldset" : "div", I = m && !a ? /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: "asterisk",
        iconSize: "sm",
        className: "pds-input-label__required"
      }
    ) : null, A = d ? /* @__PURE__ */ e.createElement(
      "div",
      {
        className: L,
        id: `${c}__message`,
        role: f === "error" ? "alert" : null,
        style: V
      },
      d
    ) : null;
    return /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: [
          v,
          E,
          k,
          x,
          z,
          N,
          M,
          C
        ].join(" ").trim().replace(/\s+/g, " "),
        ref: g,
        style: V
      }, $),
      i && !l && r != "file-upload" && /* @__PURE__ */ e.createElement(
        "label",
        {
          className: [w, p ? null : "visually-hidden"].join(" ").trim(),
          htmlFor: c
        },
        i,
        I
      ),
      i && r === "file-upload" && p && /* @__PURE__ */ e.createElement("span", { className: w }, i, I),
      u === "before" && A,
      /* @__PURE__ */ e.createElement(
        H,
        {
          className: `pds-input-field ${r ? `pds-input-field--${r}` : ""}`
        },
        i && l && /* @__PURE__ */ e.createElement("legend", { className: w }, i, I),
        n && /* @__PURE__ */ e.createElement(rt, { type: n }),
        s
      ),
      u === "after" && A
    );
  }
);
Je.propTypes = {
  /**
   * Children. The input field component.
   */
  children: t.node,
  /**
   * Decorator. An icon or other element to display before the input field.
   */
  decorator: t.oneOf(["error", "success", "search"]),
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * Input ID.
   */
  id: t.string.isRequired,
  /**
   * Input field type. Used for class naming.
   */
  inputFieldType: t.string,
  /**
   * Width of the input field with wrapper. Accepts a number in pixels. Leave blank for auto width.
   */
  inputWidth: t.number,
  /**
   * Should the the child component be a fieldset?
   */
  isFieldset: t.bool,
  /**
   * Input label.
   */
  label: t.string,
  /**
   * Input message.
   */
  message: t.string,
  /**
   * Position of the message relative to the input field.
   */
  messagePosition: t.oneOf(["before", "after"]),
  /**
   * Is the field read-only?
   */
  readonly: t.bool,
  /**
   * Is this field required?
   */
  required: t.bool,
  /**
   * Should the label be visible? If false, it will render for screen readers only.
   */
  showLabel: t.bool,
  /**
   * Validation state.
   */
  validationState: t.oneOf(["error", "success"]),
  /**
   * Additional class names
   */
  className: t.string
};
const mt = (m) => {
  var p = m, {
    ariaLabel: s,
    buttonType: n = "button",
    disabled: a = !1,
    hasTooltip: c = !0,
    iconName: r,
    icon2Name: o = null,
    onClick: l = () => {
    },
    size: i = "md",
    variant: d = "standard",
    className: u
  } = p, h = S(p, [
    "ariaLabel",
    "buttonType",
    "disabled",
    "hasTooltip",
    "iconName",
    "icon2Name",
    "onClick",
    "size",
    "variant",
    "className"
  ]);
  const f = "pds-icon-button", C = i !== "md" ? `${f}--${i}` : null, $ = d !== "standard" ? `${f}--${d}` : null, g = {
    fadeOut: `${f}--fadeOut`,
    hide: `${f}--hide`,
    scaleIn: `${f}--scaleIn`
  };
  let _, b;
  switch (i) {
    case "sm":
      b = "md", _ = 8;
      break;
    case "md":
      b = "md", _ = 10;
      break;
    case "lg":
      b = "xl", _ = 12;
  }
  const v = o !== null, E = se(null), w = se(null), L = () => {
    E.current.classList.add(g.fadeOut), E.current.classList.add(g.hide), w.current.classList.remove(g.hide), w.current.classList.add(g.scaleIn), setTimeout(() => {
      E.current.classList.remove(
        g.fadeOut,
        g.hide
      ), E.current.classList.add(g.scaleIn), w.current.classList.remove(g.scaleIn), w.current.classList.add(g.hide);
    }, 2e3);
  }, N = () => {
    v && L(), l && l();
  }, M = v ? /* @__PURE__ */ e.createElement("div", { className: `${f}__content` }, /* @__PURE__ */ e.createElement("div", { ref: E, className: `${f}__icon-wrapper` }, /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: r,
      iconSize: b,
      className: `${f}__icon`
    }
  )), /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: w,
      className: `${f}__icon-wrapper ${g.hide}`
    },
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: o,
        iconSize: b,
        className: `${f}__icon`
      }
    )
  )) : /* @__PURE__ */ e.createElement("div", { className: `${f}__content` }, /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: r,
      iconSize: b,
      className: `${f}__icon`
    }
  ));
  return /* @__PURE__ */ e.createElement(
    "button",
    y({
      "aria-label": s,
      className: [f, C, $, u].join(" ").trim().replace(/\s+/g, " "),
      disabled: a,
      onClick: N,
      type: n,
      title: c && !a ? null : s
    }, h),
    c && !a ? /* @__PURE__ */ e.createElement(
      Et,
      {
        content: s,
        className: `${f}__tooltip`,
        offsetValue: _,
        customTrigger: M
      }
    ) : M
  );
};
mt.displayName = "IconButton";
const V1 = ($) => {
  var g = $, {
    accept: s,
    chooseFileLabel: n = "Choose file",
    clearButtonLabel: a = "Clear selected file",
    disabled: c = !1,
    fieldLabel: r,
    id: o,
    inputWidth: l,
    message: i,
    multiple: d = !1,
    onFileChange: u,
    required: h = !1,
    showLabel: m = !0,
    validationFunction: p,
    className: f
  } = g, C = S(g, [
    "accept",
    "chooseFileLabel",
    "clearButtonLabel",
    "disabled",
    "fieldLabel",
    "id",
    "inputWidth",
    "message",
    "multiple",
    "onFileChange",
    "required",
    "showLabel",
    "validationFunction",
    "className"
  ]);
  const [_, b] = R(!1), [v, E] = R(), [w, L] = R(null), N = "pds-file-upload", M = _ ? `${N}--has-value` : null;
  let k = null;
  w === "error" && (k = "error"), w === "success" && (k = "success");
  const x = () => {
    E(""), L(null);
  }, z = (H) => {
    if (p) {
      const I = p(H.target.files) || {};
      x(), I.error && L("error"), I.success && L("success"), E(I.message);
    }
    u && u(H.target.files), H.target.files.length > 0 ? b(!0) : b(!1);
  }, T = () => {
    const H = document.getElementById(o);
    H.value = "", b(!1), x();
  }, V = v || i;
  return /* @__PURE__ */ e.createElement(
    Je,
    y({
      className: f,
      decorator: k,
      disabled: c,
      id: o,
      inputWidth: l,
      inputFieldType: "file-upload",
      label: r,
      message: V,
      required: h,
      showLabel: m,
      validationState: w
    }, C),
    /* @__PURE__ */ e.createElement(
      "label",
      {
        htmlFor: o,
        className: _ ? "visually-hidden" : `${N}__label`
      },
      /* @__PURE__ */ e.createElement(q, { iconName: "paperclip", iconSize: "sm" }),
      n
    ),
    /* @__PURE__ */ e.createElement(
      "input",
      {
        className: [N, M].join(" ").trim().replace(/\s+/g, " "),
        type: "file",
        id: o,
        accept: s || null,
        disabled: c,
        multiple: d,
        required: h,
        onChange: z
      }
    ),
    _ && /* @__PURE__ */ e.createElement(
      mt,
      {
        ariaLabel: a,
        buttonType: "button",
        iconName: "xmark",
        size: "sm",
        onClick: T
      }
    )
  );
};
V1.propTypes = {
  /**
   * File types the input should accept. Leave null for all file types.
   */
  accept: t.string,
  /**
   * Label for the file selector button. This will be the actual input label.
   */
  chooseFileLabel: t.string,
  /**
   * Translation string for the clear button label. Will be used as the title attribute.
   */
  clearButtonLabel: t.string,
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * Label to be rendered above the input field. Describes the fields purpose. Optional.
   */
  fieldLabel: t.string,
  /**
   * Input ID.
   */
  id: t.string.isRequired,
  /**
   * Width of the input field. Accepts a number in pixels. Leave blank for width: 100%.
   */
  inputWidth: t.number,
  /**
   * Message or description used to help clarify the usage of the input.
   */
  message: t.string,
  /**
   * Should the input accept multiple files? Default is false.
   */
  multiple: t.bool,
  /**
   * Callback function that will run when the file input changes.
   */
  onFileChange: t.func,
  /**
   * Is the field required?
   */
  required: t.bool,
  /**
   * Should the fieldLabel be rendered.
   */
  showLabel: t.bool,
  /**
   * Validation function
   */
  validationFunction: t.func,
  /**
   * Additional class names
   */
  className: t.string
};
const Vs = (r) => {
  var o = r, {
    headingLevel: s = "h3",
    headingText: n,
    className: a
  } = o, c = S(o, [
    "headingLevel",
    "headingText",
    "className"
  ]);
  const l = `${s}`;
  return /* @__PURE__ */ e.createElement(
    l,
    y({
      className: ["pds-footer-heading", "pds-ts-m", a].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    n
  );
};
Vs.propTypes = {
  /**
   *  Heading level
   */
  headingLevel: t.oneOf(["h2", "h3", "h4"]),
  /**
   * Heading text
   */
  headingText: t.string.isRequired,
  /**
   * Additional class names
   */
  className: t.string
};
const I1 = (o) => {
  var l = o, {
    headingLevel: s,
    headingText: n,
    linkItems: a,
    className: c
  } = l, r = S(l, [
    "headingLevel",
    "headingText",
    "linkItems",
    "className"
  ]);
  const i = "pds-footer-links";
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [i, c].join(" ").trim().replace(/\s+/g, " ")
    }, r),
    n && /* @__PURE__ */ e.createElement(
      Vs,
      {
        headingLevel: s,
        className: `${i}__heading`,
        headingText: n
      }
    ),
    /* @__PURE__ */ e.createElement("ul", { className: `${i}__list`, role: "list" }, a.map((d, u) => /* @__PURE__ */ e.createElement("li", { key: u, className: `${i}__item` }, d)))
  );
};
I1.propTypes = {
  /**
   *  Heading level
   */
  headingLevel: t.oneOf(["h2", "h3", "h4"]),
  /**
   * Heading text
   */
  headingText: t.string.isRequired,
  /**
   * Array of links
   */
  linkItems: t.arrayOf(t.node),
  /**
   * Additional class names
   */
  className: t.string
};
const S1 = (r) => {
  var o = r, { children: s, level: n, className: a } = o, c = S(o, ["children", "level", "className"]);
  const l = "pds-heading", i = `${n}`;
  return /* @__PURE__ */ e.createElement(
    i,
    y({
      className: [l, a].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    s
  );
};
S1.propTypes = {
  /**
   * Heading content
   */
  children: t.node.isRequired,
  /**
   * Heading level
   */
  level: t.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]).isRequired,
  /**
   * Additional class names
   */
  className: t.string
};
const T1 = new Intl.NumberFormat().formatToParts(100000089e-2), St = T1.find((s) => s.type === "decimal").value, Tt = 16, ls = 10, O1 = (C) => {
  var $ = C, {
    disabled: s = !1,
    formatting: n,
    hasClearButton: a = !1,
    id: c,
    initialValue: r = "",
    label: o,
    message: l,
    onChange: i,
    placeholder: d,
    required: u = !1,
    showLabel: h = !0,
    validationFunction: m,
    className: p
  } = $, f = S($, [
    "disabled",
    "formatting",
    "hasClearButton",
    "id",
    "initialValue",
    "label",
    "message",
    "onChange",
    "placeholder",
    "required",
    "showLabel",
    "validationFunction",
    "className"
  ]);
  const g = "pds-input-formatted", _ = n ? `${g}--${n}` : null, b = se([
    "pds-input-field",
    g,
    _,
    p
  ]), [v, E] = R(""), [w, L] = R(null), [N, M] = R(null), k = se(null), x = se(null), z = se("");
  oe(() => {
    switch (r && E(Z(r)), z.numExtra = "", n) {
      case "credit-card":
        z.numExtra = 3, z.current = Tt;
        break;
      case "phone":
        z.numExtra = 4, z.current = ls;
        break;
    }
  }, []);
  const T = () => {
    b.current = b.current.filter(
      (O) => O !== $e.required && O !== $e.disabled
    );
  }, V = () => {
    b.current = b.current.filter(
      (O) => O !== $e.error && O !== $e.success
    );
  }, H = () => {
    V(), L(""), M(null);
  }, I = (O) => {
    i && i({
      formattedValue: O,
      rawValue: x.current
    });
  }, A = (O) => {
    E(Z(O.target.value)), H(), I(O.target.value);
  }, j = () => {
    M("error"), b.current.push($e.error);
  }, B = (O) => {
    if (m) {
      const D = m(O.target.value) || {};
      H(), D.error && j(), D.success && (M("success"), b.current.push($e.success)), L(D.message);
    } else
      k.current.checkValidity() === !1 || O.target.value.length < z.current + z.numExtra ? (j(), n === "credit-card" && L(
        `Credit card number must have at least ${z.current} digits.`
      ), n === "phone" && L(
        `Phone number must have at least ${z.current} digits.`
      )) : (n === "credit-card" || n === "phone") && (M("success"), b.current.push($e.success));
    I(O.target.value);
  }, W = () => {
    H(), E(""), x.current = "", k.current.focus(), I("");
  }, Z = (O) => {
    if (O) {
      if (n === "credit-card") {
        const D = ("" + O).replace(/\D/g, "");
        if (x.current = D, D) {
          if (new RegExp("^34|37", "g").test(D)) {
            z.numExtra = 2, z.current = Tt - 1;
            const Q = {};
            return Q.first = D.substring(0, 4), Q.middle = D.substring(4, 10), Q.middle.length > 0 && (Q.middle = ` ${Q.middle}`), Q.last = D.substring(10), Q.last.length > 0 && (Q.last = ` ${Q.last}`), `${Q.first}${Q.middle}${Q.last}`;
          }
          z.numExtra = 3, z.current = Tt;
          const U = new RegExp(".{1,4}", "g");
          return D.match(U).join(" ");
        }
        return D;
      }
      if (n === "phone") {
        const D = ("" + O).replace(/\D/g, "");
        if (x.current = D, D) {
          z.numExtra = 4, z.current = ls;
          let F = D.substring(0, 3), U = D.substring(3, 6);
          U.length > 0 && (F = `(${F})`, U = ` ${U}`);
          let ie = D.substring(6);
          return ie.length > 0 && (ie = `-${ie}`), `${F}${U}${ie}`;
        }
        return D;
      }
      if (n === "number-localized") {
        const D = new RegExp(`[^0-9${St}]`, "g"), F = ("" + O).replace(D, "");
        x.current = F;
        const U = new Intl.NumberFormat(void 0, {
          maximumFractionDigits: 20
        }).format(F);
        return F.endsWith(St) ? U + St : U;
      }
    }
    return O;
  };
  T(), u && !s && b.current.push($e.required), s && b.current.push($e.disabled);
  let K = null;
  return N === "error" && (K = /* @__PURE__ */ e.createElement(rt, { type: "error" })), N === "success" && (K = /* @__PURE__ */ e.createElement(rt, { type: "success" })), /* @__PURE__ */ e.createElement("div", y({ className: b.current.join(" ").trim() }, f), /* @__PURE__ */ e.createElement("span", { className: h ? null : "visually-hidden" }, /* @__PURE__ */ e.createElement("label", { className: "pds-input-label", htmlFor: c }, o)), /* @__PURE__ */ e.createElement("div", { className: "pds-input-field__input-wrapper" }, K && /* @__PURE__ */ e.createElement("div", { className: "pds-input-field__decorators" }, K), /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "pds-input-field__input",
      type: n === "phone" ? "tel" : "text",
      id: c,
      name: c,
      placeholder: d,
      required: u,
      disabled: s,
      value: v,
      onChange: A,
      onBlur: B,
      ref: k,
      "aria-invalid": N === "error",
      "aria-describedby": l || w ? `${c}__message` : null,
      maxLength: z.current + z.numExtra,
      minLength: z.current + z.numExtra
    }
  ), /* @__PURE__ */ e.createElement("div", { className: "pds-input-field__accessories" }, v && a && /* @__PURE__ */ e.createElement(
    Lt,
    {
      id: c,
      label: o,
      handleClearInput: W
    }
  ))), (l || w) && /* @__PURE__ */ e.createElement(
    "div",
    {
      className: "pds-input-field__message",
      id: `${c}__message`,
      role: N === "error" ? "alert" : null
    },
    w || l
  ));
};
O1.propTypes = {
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * Type of formatting the field should use.
   */
  formatting: t.oneOf(["credit-card", "phone", "number-localized"]).isRequired,
  /**
   * ID of the input.
   * <br />
   * Will be used to connect the label element, clear button, and set the name attribute of the input.
   */
  id: t.string.isRequired,
  /**
   * Does the input contain a clear button?
   */
  hasClearButton: t.bool,
  /**
   * Initial value for the input field.
   */
  initialValue: t.string,
  /**
   * Text label associated with the input field.
   */
  label: t.string.isRequired,
  /**
   * Message or description used to help clarify the usage of the input.
   */
  message: t.string,
  /**
   * Function to help lift the state and retrieve the input's values.
   * <br />
   * Should accept one argument, an object with keys of `formattedValue` and `rawValue`.
   */
  onChange: t.func,
  /**
   * Optional placeholder text to display when the input field is empty.
   */
  placeholder: t.string,
  /**
   * Is the field required?
   */
  required: t.bool,
  /**
   * Should the label be visible? If false, it will render for screen readers only. This should be used very rarely and only on single-field forms.
   */
  showLabel: t.bool,
  /**
   * If field validation is desired provide a function that accepts the input's value and will return one of the response objects below.
   *
   * Error:<br/>
   * ```
   * {
   *   error: true,
   *   message: [string],
   * }
   * ```
   *
   * Success:<br/>
   * ```
   * {
   *   success: true,
   *   message: [string]
   * }
   * ```
   */
  validationFunction: t.func,
  /**
   * Additional class names
   */
  className: t.string
};
const R1 = (f) => {
  var C = f, {
    counterFunction: s = () => {
    },
    disabled: n = !1,
    hasClearButton: a = !1,
    id: c,
    initialValue: r = "",
    label: o,
    message: l,
    onChange: i,
    required: d = !1,
    showLabel: u = !0,
    validationFunction: h,
    className: m
  } = C, p = S(C, [
    "counterFunction",
    "disabled",
    "hasClearButton",
    "id",
    "initialValue",
    "label",
    "message",
    "onChange",
    "required",
    "showLabel",
    "validationFunction",
    "className"
  ]);
  const $ = "pds-input-obscured", g = se(["pds-input-field", $, m]), [_, b] = R(r), [v, E] = R(s("")), [w, L] = R(), [N, M] = R(null), [k, x] = R(!1), z = se(null), T = se(null);
  oe(() => {
    r && s && E(s(r));
  }, []);
  const V = () => {
    g.current = g.current.filter(
      (O) => O !== $e.required && O !== $e.disabled
    );
  }, H = () => {
    g.current = g.current.filter(
      (O) => O !== $e.error && O !== $e.success
    );
  }, I = () => {
    H(), L(""), M(null);
  }, A = (O) => {
    b(O.target.value), I(), s && E(s(O.target.value)), i && i(O.target.value);
  }, j = (O) => {
    if (x(!1), h) {
      const D = h(O.target.value) || {};
      I(), D.error && (M("error"), g.current.push($e.error)), D.success && (M("success"), g.current.push($e.success)), L(D.message);
    }
    i && i(_);
  }, B = () => {
    I(), b(""), T.current.value = null, T.current.focus(), s && E(s("")), i && i("");
  }, W = () => {
    x((O) => !O);
  }, Z = (O) => {
    var D;
    (!((D = z.current) != null && D.contains(O.relatedTarget)) || !O.relatedTarget) && x(!1);
  };
  V(), d && !n && g.current.push($e.required), n && g.current.push($e.disabled);
  let K = null;
  return N === "error" && (K = /* @__PURE__ */ e.createElement(rt, { type: "error" })), N === "success" && (K = /* @__PURE__ */ e.createElement(rt, { type: "success" })), /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: g.current.join(" ").trim(),
      ref: z,
      onBlur: Z
    }, p),
    /* @__PURE__ */ e.createElement("span", { className: u ? null : "visually-hidden" }, /* @__PURE__ */ e.createElement("label", { className: "pds-input-label", htmlFor: c }, o)),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: "visually-hidden",
        "aria-live": "polite"
      },
      `Content of ${o} input is ${k ? "visible" : "hidden"}.`
    ),
    /* @__PURE__ */ e.createElement("div", { className: "pds-input-field__input-wrapper" }, K && /* @__PURE__ */ e.createElement("div", { className: "pds-input-field__decorators" }, K), /* @__PURE__ */ e.createElement(
      "input",
      {
        className: "pds-input-field__input",
        type: k ? "text" : "password",
        id: c,
        name: c,
        required: d,
        disabled: n,
        value: _,
        onChange: A,
        onBlur: j,
        ref: T,
        "aria-invalid": N === "error",
        "aria-describedby": l || w ? `${c}__message` : null,
        autoComplete: "off"
      }
    ), /* @__PURE__ */ e.createElement("div", { className: "pds-input-field__accessories" }, v && /* @__PURE__ */ e.createElement("div", { className: "pds-input-field_counter" }, v), _ && a && /* @__PURE__ */ e.createElement(
      Lt,
      {
        id: c,
        label: o,
        handleClearInput: B
      }
    ), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `pds-input-field__accessory ${$}__toggle`,
        title: `${k ? "Hide" : "Show"} content of ${o} input`,
        "aria-controls": c,
        onClick: W,
        onMouseDown: (O) => O.preventDefault()
      },
      k ? /* @__PURE__ */ e.createElement(q, { iconName: "eyeSlash" }) : /* @__PURE__ */ e.createElement(q, { iconName: "eye" })
    ))),
    (l || w) && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: "pds-input-field__message",
        id: `${c}__message`,
        role: N === "error" ? "alert" : null
      },
      w || l
    )
  );
};
R1.propTypes = {
  /**
   * If a counter is desired provide a function that accepts the input's value and will return a string to display.
   * <br />
   * Example: A function that counts characters up to a maximum of 20 will return "5/20" for an input value of "apple".
   */
  counterFunction: t.func,
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * Does the input contain a clear button?
   */
  hasClearButton: t.bool,
  /**
   * ID of the input.
   * <br />
   * Will be used to connect the label element, clear button, and set the name attribute of the input.
   */
  id: t.string.isRequired,
  /**
   * Initial value for the input field.
   */
  initialValue: t.string,
  /**
   * Text label associated with the input field.
   */
  label: t.string.isRequired,
  /**
   * Message to display to aid in clarifying the input field.
   * Should be used rarely.
   */
  message: t.string,
  /**
   * Callback function that will return the updated properties from the input when it changes.
   */
  onChange: t.func,
  /**
   * Is the field required?
   */
  required: t.bool,
  /**
   * Should the label be visible? If false, it will render for screen readers only. This should be used very rarely and only on single-field forms.
   */
  showLabel: t.bool,
  /**
   * If field validation is desired provide a function that accepts the input's value and will return one of the response objects below.
   *
   * Error:<br/>
   * ```
   * {
   *   error: true,
   *   message: [string],
   * }
   * ```
   *
   * Success:<br/>
   * ```
   * {
   *   success: true,
   *   message: [string]
   * }
   * ```
   */
  validationFunction: t.func,
  /**
   * Additional class names
   */
  className: t.string
};
const Ot = 16, cs = 10, D1 = (k) => {
  var x = k, {
    autoComplete: s = "on",
    counterFunction: n = () => {
    },
    disabled: a = !1,
    hasClearButton: c = !1,
    hasSearchShortcut: r = !1,
    id: o,
    initialValue: l = "",
    inputWidth: i,
    label: d,
    labelStrings: u = {
      clearButton: "Clear input text",
      searchShortcut: "Press / to focus the search field",
      visibilityStatus: "The value of the input is",
      visibilityToggleHide: "Hide input value",
      visibilityToggleShow: "Show input value"
    },
    message: h,
    onChange: m,
    onFocus: p,
    placeholder: f,
    readonly: C = !1,
    required: $ = !1,
    showLabel: g = !0,
    specialFormatting: _,
    specialFormattingValidation: b = !1,
    toggleVisibility: v = !1,
    type: E = "text",
    validationFunction: w,
    validationMessages: L = {
      creditCardError: "Please enter a valid credit card number.",
      phoneError: "Please enter a valid phone number."
    },
    className: N
  } = x, M = S(x, [
    "autoComplete",
    "counterFunction",
    "disabled",
    "hasClearButton",
    "hasSearchShortcut",
    "id",
    "initialValue",
    "inputWidth",
    "label",
    "labelStrings",
    "message",
    "onChange",
    "onFocus",
    "placeholder",
    "readonly",
    "required",
    "showLabel",
    "specialFormatting",
    "specialFormattingValidation",
    "toggleVisibility",
    "type",
    "validationFunction",
    "validationMessages",
    "className"
  ]);
  const [z, T] = R(l), [V, H] = R(n("")), [I, A] = R(), [j, B] = R(null), [W, Z] = R(!1), K = se(null), O = se(null), D = se(null), F = se(null), U = "pds-input-text", ie = _ ? `${U}--${_}` : null;
  let Q = null;
  E === "search" && (Q = "search"), j === "error" && (Q = "error"), j === "success" && (Q = "success"), _ && b && oe(() => {
    switch (l && T(te(l)), F.numExtra = "", _) {
      case "credit-card":
        F.numExtra = 3, F.current = Ot;
        break;
      case "phone":
        F.numExtra = 4, F.current = cs;
        break;
    }
  }, []);
  let ve = null;
  (_ === "credit-card" || _ === "phone") && F.current && (ve = F.current + F.numExtra);
  const te = (ae) => {
    if (ae) {
      if (_ === "credit-card") {
        const ce = ("" + ae).replace(/\D/g, "");
        if (D.current = ce, ce) {
          if (new RegExp("^34|37", "g").test(ce)) {
            F.numExtra = 2, F.current = Ot - 1;
            const _e = {};
            return _e.first = ce.substring(0, 4), _e.middle = ce.substring(4, 10), _e.middle.length > 0 && (_e.middle = ` ${_e.middle}`), _e.last = ce.substring(10), _e.last.length > 0 && (_e.last = ` ${_e.last}`), `${_e.first}${_e.middle}${_e.last}`;
          }
          F.numExtra = 3, F.current = Ot;
          const He = new RegExp(".{1,4}", "g");
          return ce.match(He).join(" ");
        }
        return ce;
      }
      if (_ === "phone") {
        const ce = ("" + ae).replace(/\D/g, "");
        if (D.current = ce, ce) {
          F.numExtra = 4, F.current = cs;
          let Le = ce.substring(0, 3), He = ce.substring(3, 6);
          He.length > 0 && (Le = `(${Le})`, He = ` ${He}`);
          let ze = ce.substring(6);
          return ze.length > 0 && (ze = `-${ze}`), `${Le}${He}${ze}`;
        }
        return ce;
      }
    }
    return ae;
  };
  oe(() => {
    l && n && H(n(l));
  }, []);
  const de = () => {
    A(""), B(null);
  }, le = (ae) => {
    p && p(ae.target);
  }, ne = (ae) => {
    _ ? m && m({ formattedValue: ae, rawValue: D.current }) : m && m(ae);
  }, Ee = (ae) => {
    T(_ ? te(ae.target.value) : ae.target.value), de(), n && H(n(_ ? D.current : ae.target.value)), ne(ae.target.value);
  }, ee = (ae) => {
    if (v && Z(!1), w) {
      const ce = w(ae.target.value) || {};
      de(), ce.error && B("error"), ce.success && B("success"), A(ce.message);
    }
    _ && b && !w && (K.current.checkValidity() === !1 || ae.target.value.length < ve ? (B("error"), _ === "credit-card" && A(L.creditCardError), _ === "phone" && A(L.phoneError)) : B("success")), ne(ae.target.value);
  }, J = (ae) => {
    var ce;
    (!((ce = O.current) != null && ce.contains(ae.relatedTarget)) || !ae.relatedTarget) && Z(!1);
  }, G = () => {
    de(), T(""), D.current = "", K.current.focus(), n && H(n("")), ne("");
  };
  oe(() => {
    if (E === "search" && r) {
      const ae = (ce) => {
        ce.key === "/" && (/^(?:input|textarea|select|button)$/i.test(ce.target.tagName) || (ce.preventDefault(), document.getElementById(o).focus()));
      };
      return document.addEventListener("keyup", ae), () => {
        document.removeEventListener("keyup", ae);
      };
    }
  }, []);
  const he = () => {
    Z((ae) => !ae);
  };
  v && E === "password" && (W ? M.type = "text" : M.type = "password"), _ === "phone" && (M.type = "tel");
  const we = I || h;
  return /* @__PURE__ */ e.createElement(
    Je,
    y({
      className: N,
      decorator: Q,
      disabled: a,
      id: o,
      inputFieldType: "text",
      inputWidth: i,
      label: d,
      message: we,
      onBlur: J,
      ref: O,
      readonly: C,
      required: $,
      showLabel: g,
      validationState: j
    }, M),
    v && E === "password" && /* @__PURE__ */ e.createElement("div", { className: "visually-hidden", "aria-live": "polite" }, `${u.visibilityStatus} ${W ? "visible" : "hidden"}.`),
    /* @__PURE__ */ e.createElement(
      "input",
      {
        className: [U, ie].join(" ").trim().replace(/\s+/g, " "),
        type: E,
        id: o,
        name: o,
        placeholder: f,
        required: $,
        readOnly: C,
        disabled: a,
        value: z,
        onBlur: ee,
        onChange: Ee,
        onFocus: le,
        ref: K,
        "aria-invalid": j === "error",
        "aria-describedby": we ? `${o}__message` : null,
        autoComplete: E === "password" ? "off" : s,
        maxLength: ve,
        minLength: ve
      }
    ),
    V && /* @__PURE__ */ e.createElement("div", { className: "pds-input__counter" }, V),
    z && c && /* @__PURE__ */ e.createElement(
      Lt,
      {
        id: o,
        label: u.clearButton,
        handleClearInput: G
      }
    ),
    v && E === "password" && /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: "pds-input__visibility-toggle",
        title: W ? u.visibilityToggleHide : u.visibilityToggleShow,
        "aria-controls": o,
        onClick: he,
        onMouseDown: (ae) => ae.preventDefault()
      },
      /* @__PURE__ */ e.createElement(q, { iconName: W ? "eyeSlash" : "eye" })
    ),
    !z && r && E === "search" && /* @__PURE__ */ e.createElement(Ls, { label: u.searchShortcut })
  );
};
D1.propTypes = {
  /**
   * Auto complete attribute for the input field. The attribute value is either the keyword `off` or `on`, or an ordered list of space-separated tokens. Password fields are automatically off.
   *
   * See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) for more information.
   */
  autoComplete: t.string,
  /**
   * If a counter is desired provide a function that accepts the input's value and will return a string.
   */
  counterFunction: t.func,
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * Does the input contain a clear button?
   */
  hasClearButton: t.bool,
  /**
   * Does the input contain the search shortcut?
   * Only valid if the input type is `search`.
   */
  hasSearchShortcut: t.bool,
  /**
   * Input ID.
   */
  id: t.string.isRequired,
  /**
   * Initial value for the input field. Will be used to set the `value` attribute at initial render. If using specialFormatting, the value should be the raw value.
   */
  initialValue: t.string,
  /**
   * Width of the input field. Accepts a number in pixels. Leave blank for width: 100%.
   */
  inputWidth: t.number,
  /**
   * Input label.
   */
  label: t.string.isRequired,
  /**
   * Translation strings for various labels or other visually-hidden text.
   */
  labelStrings: t.shape({
    clearButton: t.string,
    searchShortcut: t.string,
    visibilityStatus: t.string,
    visibilityToggleHide: t.string,
    visibilityToggleShow: t.string
  }),
  /**
   * Input message. Will be displayed below the input field.
   */
  message: t.string,
  /**
   * Function to help lift the state and retrieve the input's value.
   * Should accept one argument, the input's value, unless using a specialFormatting type in which case the function will accept an object with`formattedValue` and `rawValue`
   */
  onChange: t.func,
  /**
   * Optional function to handle focus events.
   * Should accept one argument, the input element. Element properties can be accessed via `element.property`.
   */
  onFocus: t.func,
  /**
   * Optional placeholder text to display when the input field is empty.
   */
  placeholder: t.string,
  /**
   * Is the field read-only?
   */
  readonly: t.bool,
  /**
   * Is this field required?
   */
  required: t.bool,
  /**
   * Should the label be visible? If false, it will render for screen readers only.
   */
  showLabel: t.bool,
  /**
   * Special specialFormatting for the input field. Omit prop for default formatting.
   */
  specialFormatting: t.oneOf(["credit-card", "phone"]),
  /**
   * Enable or disable built-in validation styles and messages for special formatting types. Text will still be formatted as appropriate.
   */
  specialFormattingValidation: t.bool,
  /**
   * Toggle visibility of the input value. Valid for type `password` only.
   */
  toggleVisibility: t.bool,
  /**
   * Type of input field to use.
   */
  type: t.oneOf([
    "text",
    "search",
    "number",
    "email",
    "password",
    "tel",
    "url"
  ]),
  /**
   * If custom field validation is desired, provide a function that accepts the input's value and will return one of the response objects below.
   *
   * Error:<br/>
   * ```
   * {
   *   error: true,
   *   message: [string],
   * }
   * ```
   *
   * Success:<br/>
   * ```
   * {
   *   success: true,
   *   message: [string]
   * }
   * ```
   */
  validationFunction: t.func,
  /**
   * Translation strings for built-in validation messages.
   */
  validationMessages: t.shape({
    creditCardError: t.string,
    phoneError: t.string
  }),
  /**
   * Additional class names
   */
  className: t.string
};
const A1 = (o) => {
  var l = o, {
    linkItems: s,
    headingLevel: n = "h3",
    headingText: a,
    className: c
  } = l, r = S(l, [
    "linkItems",
    "headingLevel",
    "headingText",
    "className"
  ]);
  const i = "pds-links-card", d = `${n}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [i, c].join(" ").trim().replace(/\s+/g, " ")
    }, r),
    a && /* @__PURE__ */ e.createElement(d, { className: `${i}__heading pds-ts-xl` }, a),
    s && /* @__PURE__ */ e.createElement("ul", { className: `${i}__list`, role: "list" }, s.map((u, h) => /* @__PURE__ */ e.createElement("li", { key: h, className: "pds-cta-links-card__item" }, u)))
  );
};
A1.propTypes = {
  /**
   *  Heading level
   */
  headingLevel: t.oneOf(["h2", "h3", "h4"]),
  /**
   * Link Card heading
   */
  headingText: t.string.isRequired,
  /**
   * Array of links
   */
  linkItems: t.arrayOf(t.node),
  /**
   * Additional class names
   */
  className: t.string
};
const rs = [
  "g01",
  "g02",
  "g03",
  "g04",
  "g05",
  "g06",
  "g07",
  "g08",
  "g09",
  "g10",
  "g11",
  "g12"
], q1 = (s) => {
  const n = parseInt(_s(s), 16);
  return rs[n % rs.length];
}, ut = (l) => {
  var i = l, {
    size: s = "md",
    imageSrc: n,
    linkContent: a,
    uniqueId: c,
    className: r
  } = i, o = S(i, [
    "size",
    "imageSrc",
    "linkContent",
    "uniqueId",
    "className"
  ]);
  const d = "pds-avatar", u = `${d}--${s}`, h = n ? `${d}--image` : null, m = c ? `var(--pds-color-gradient-avatar-${q1(c)})` : null, p = {
    backgroundImage: m,
    borderRadius: "100%",
    height: "100%",
    width: "100%"
  }, f = n ? /* @__PURE__ */ e.createElement(
    "img",
    {
      src: `${n}`,
      style: { backgroundImage: m },
      className: `${d}__image`,
      alt: ""
    }
  ) : /* @__PURE__ */ e.createElement("span", { style: p }), C = /* @__PURE__ */ e.createElement("span", { className: `${d}__content` }, f), $ = Pe(a) ? Ge(
    a,
    ge(y({}, a.props), {
      className: `${d}__content ${d}__content--link`
    }),
    f
  ) : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: Y([d, u, h, r])
    }, o),
    a ? $ : C
  );
}, Rt = (s) => s.isSeparator, Dt = (s) => s.isHeading, At = (s) => s.isLink, P1 = (s) => s.isNode, Is = (g) => {
  var _ = g, {
    avatarImageSrc: s,
    disabled: n,
    displayType: a = "icon-end",
    iconName: c = "ellipsisVertical",
    id: r,
    isSplitButton: o = !1,
    label: l,
    menuItems: i,
    menuPosition: d = "start",
    size: u = "md",
    testId: h,
    undefinedLabel: m = "Unlabeled group",
    variant: p = "primary",
    withinNavbar: f,
    className: C
  } = _, $ = S(_, [
    "avatarImageSrc",
    "disabled",
    "displayType",
    "iconName",
    "id",
    "isSplitButton",
    "label",
    "menuItems",
    "menuPosition",
    "size",
    "testId",
    "undefinedLabel",
    "variant",
    "withinNavbar",
    "className"
  ]);
  const {
    x: b,
    y: v,
    reference: E,
    floating: w,
    strategy: L,
    update: N,
    placement: M,
    refs: k
  } = a1({
    placement: "bottom-start",
    middleware: [l1()]
  });
  let x = !1;
  const z = ke(Fe);
  z && (x = z.isMobile);
  const T = f && x, V = 'data:image/svg+xml,<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12.5" r="12.5" fill="%23CFCFD3"/><path d="M12.5 11.75C11.2422 11.75 10.0938 11.0938 9.46484 10C8.83594 8.93359 8.83594 7.59375 9.46484 6.5C10.0938 5.43359 11.2422 4.75 12.5 4.75C13.7305 4.75 14.8789 5.43359 15.5078 6.5C16.1367 7.59375 16.1367 8.93359 15.5078 10C14.8789 11.0938 13.7305 11.75 12.5 11.75ZM11.2422 13.0625H13.7305C16.4375 13.0625 18.625 15.25 18.625 17.957C18.625 18.3945 18.2422 18.75 17.8047 18.75H7.16797C6.73047 18.75 6.375 18.3945 6.375 17.957C6.375 15.25 8.53516 13.0625 11.2422 13.0625Z" fill="%2323232D"/></svg>', H = "pds-menu-button", I = T ? `${H}--isMobile` : null, A = f ? `${H}--navbar` : null, j = je(), [B] = R(`menu-button-${j}`), [W] = R(`menu-listbox-${j}`), Z = r || B, K = k.floating, O = se(null), [D, F] = R(!1), [U, ie] = R(!1), [Q, ve] = R(""), [te, de] = R(0), le = se([]), ne = se([]), Ee = se([]);
  Xs(() => {
    window.addEventListener("mousedown", _e, !0), N();
    const P = K.current;
    return P && (P.dataset.fuiPlacement = M), U && (setTimeout(() => {
      P.focus();
    }, 0), ie(!1)), () => {
      window.removeEventListener("mousedown", _e, !0);
    };
  }, [D, M]);
  const ee = (P, re) => {
    ve(P), de(re);
  }, J = () => {
    F(!0), ie(!0);
  }, G = () => {
    F(!1), ee(void 0, -1), O.current.querySelector(`#${Z}`).focus();
  }, he = (P) => {
    P = P.toLowerCase();
    let re = !1;
    for (let X = te + 1; X < Ee.current.length; X++)
      if (Ee.current[X].label.toLowerCase().startsWith(P)) {
        ee(ne.current[X], X), re = !0;
        break;
      }
    if (re === !1) {
      for (let X = 0; X < te; X++)
        if (Ee.current[X].label.toLowerCase().startsWith(P)) {
          ee(ne.current[X], X);
          break;
        }
    }
  }, we = (P) => {
    const re = ne.current.indexOf(P), X = Ee.current[re];
    if (X.callback && !X.disabled && X.callback(X), X.linkContent && !X.disabled) {
      const be = O.current.querySelector(`#${P} a`);
      be && be.click();
    }
  }, ae = () => {
    const P = ne.current[te];
    we(P);
  }, ce = (P) => {
    D ? G() : J(), ie((re) => !re), P.stopPropagation(), P.preventDefault();
  }, Le = (P) => {
    we(P.currentTarget.id), T || G();
  }, He = (P) => {
    var re = P.key, X = !1;
    switch (re) {
      case " ":
      case "Enter":
      case "ArrowDown":
      case "Down":
        J(), ee(ne.current[0], 0), X = !0;
        break;
      case "Esc":
      case "Escape":
        G(), X = !0;
        break;
      case "Up":
      case "ArrowUp": {
        const be = ne.current.length - 1;
        J(), ee(ne.current[be], be), X = !0;
        break;
      }
    }
    X && (P.stopPropagation(), P.preventDefault());
  }, ze = (P) => {
    let re = P.key, X = !1, be = "", me = 0;
    function Ne(Ce) {
      return Ce.length === 1 && Ce.match(/\S/);
    }
    if (!(P.ctrlKey || P.altKey || P.metaKey)) {
      if (P.shiftKey)
        Ne(re) && (he(re), X = !0), P.key === "Tab" && (G(), X = !0);
      else
        switch (re) {
          case " ":
          case "Enter":
            G(), ae(), X = !0;
            break;
          case "Esc":
          case "Escape":
            G(), X = !0;
            break;
          case "Up":
          case "ArrowUp":
            me = te - 1, me < 0 && (me = ne.current.length - 1), be = ne.current[me], ee(be, me), X = !0;
            break;
          case "ArrowDown":
          case "Down":
            me = te + 1, me > ne.current.length - 1 && (me = 0), be = ne.current[me], ee(be, me), X = !0;
            break;
          case "Home":
          case "PageUp":
            ee(ne.current[0], 0), X = !0;
            break;
          case "End":
          case "PageDown": {
            const Ce = ne.current.length - 1;
            ee(ne.current[Ce], Ce), X = !0;
            break;
          }
          case "Tab":
            G();
            break;
          default:
            Ne(re) && (he(re), X = !0);
            break;
        }
      X && (P.stopPropagation(), P.preventDefault());
    }
  }, _e = (P) => {
    O.current && !O.current.contains(P.target) && D && G();
  }, We = (P, re, X = "", be = "", ...me) => {
    const Ne = X ? `-group-${X}` : "", Ce = Z + Ne + "-item-" + (re + 1), Ve = P.id ? P.id : Ce;
    if (Rt(P))
      return /* @__PURE__ */ e.createElement("li", { role: "separator", key: Ve });
    if (Dt(P))
      return /* @__PURE__ */ e.createElement(
        "li",
        {
          role: "presentation",
          id: be || null,
          key: be,
          className: `${H}__listbox-heading`
        },
        P.label
      );
    if (P1(P))
      return /* @__PURE__ */ e.createElement("li", { role: "presentation", key: Ve }, P.nodeContent);
    if (At(P) || P.label) {
      ne.current.push(Ve), Ee.current.push(P);
      let bt = !1;
      Q !== "" && !P.disabled && (bt = Q === Ve);
      let Me;
      if (P.label && (Me = [P.label]), At(P) && (Me = [P.linkContent.props.children]), P.iconName) {
        const nt = /* @__PURE__ */ e.createElement(q, { key: `icon-${j}`, iconName: P.iconName, iconSize: "md" });
        Me.unshift(nt);
      }
      let tt;
      P.description && (tt = /* @__PURE__ */ e.createElement("span", { className: `${H}__item-description` }, P.description));
      let st;
      if (At(P)) {
        const nt = P.linkContent.type;
        st = /* @__PURE__ */ e.createElement(nt, y({ tabIndex: -1 }, P.linkContent.props), /* @__PURE__ */ e.createElement("span", { className: `${H}__item-label` }, Me), tt);
      } else
        st = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: `${H}__item-label` }, Me), tt);
      return /* @__PURE__ */ e.createElement(
        "li",
        y({
          id: Ve,
          key: Ve,
          "data-testid": P.testId,
          className: bt ? `${H}__item-focused` : null,
          role: "menuitem",
          tabIndex: -1,
          onClick: Le,
          "aria-disabled": P.disabled ? !0 : null
        }, me),
        st
      );
    }
  }, gt = (P, re) => {
    const X = [];
    let be = re.shift(), me = [];
    return P.map((Ne, Ce) => {
      Ne !== be ? (me.push(Ne), Ce + 1 === P.length && X.push(me)) : (X.push(me), me = [], me.push(Ne), be = re.shift());
    }), X.filter((Ne) => Ne.length > 0);
  }, Vt = (P) => {
    ne.current = [], Ee.current = [];
    const re = P, X = P.filter(
      Dt || Rt
    ), be = X.length > 0;
    let me = [`${H}__listbox`];
    if (f && me.push(`${H}__listbox--navbar`), (a === "avatar" || a === "avatar-with-text") && me.push(`${H}__listbox--avatar`), d === "end" && me.push(`${H}__listbox--end`), a === "icon-only" && me.push(`${H}__listbox--icon-only`), me = me.join(" ").trim().replace(/\s+/g, " "), be) {
      const Ne = gt(P, X);
      Ne.forEach(() => {
        le.current.push(je());
      });
      let Ce = le.current[0];
      const Ve = Ne[0].findIndex(
        (Me) => !Rt(Me) && !Dt(Me)
      ), bt = `${Z}-group-${Ce}-item-${Ve + 1}`;
      return /* @__PURE__ */ e.createElement(
        "div",
        {
          className: me,
          id: W,
          role: "menu",
          tabIndex: -1,
          "aria-labelledby": Z,
          "aria-activedescendant": Q !== "" ? Q : bt,
          style: {
            visibility: D ? "visible" : "hidden",
            opacity: D ? "1" : "0",
            transition: "opacity 300ms ease-in-out 0s",
            position: L,
            transform: `translate(${Math.round(b)}px,${Math.round(v)}px)`,
            zIndex: "var(--pds-z-index-dropdown)"
          },
          onKeyDown: ze,
          ref: w
        },
        Ne.map((Me, tt) => {
          Ce = le.current[tt];
          const st = Me[0].isHeading, nt = st ? `${Z}-group-${Ce}-heading` : "", Bs = `${Z}-group-${Ce}`, Fs = st ? null : `${m} ${tt + 1}`;
          return /* @__PURE__ */ e.createElement(
            "ul",
            {
              role: "group",
              "aria-labelledby": nt,
              "aria-label": Fs,
              key: Bs
            },
            Me.map((Ws, Zs) => We(
              Ws,
              Zs,
              Ce,
              nt
            ))
          );
        })
      );
    } else {
      const Ne = `${Z}-item-1`;
      return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
        "ul",
        {
          className: me,
          id: W,
          role: "menu",
          tabIndex: -1,
          "aria-labelledby": Z,
          "aria-activedescendant": Q !== "" ? Q : Ne,
          style: {
            visibility: D ? "visible" : "hidden",
            opacity: D ? "1" : "0",
            transition: "opacity 300ms ease-in-out 0s",
            position: L,
            transform: `translate(${Math.round(b)}px,${Math.round(v)}px)`
          },
          onKeyDown: ze,
          ref: w
        },
        re.map((Ce, Ve) => We(Ce, Ve))
      ));
    }
  };
  let et;
  a === "icon-end" && (et = /* @__PURE__ */ e.createElement(
    Ke,
    {
      id: Z,
      isSplitButton: o,
      label: l,
      size: u,
      variant: p,
      displayType: a,
      iconName: "angleDown",
      type: "button",
      disabled: n,
      className: `${H}__trigger`,
      "aria-haspopup": "true",
      "aria-controls": W,
      "aria-expanded": D,
      onClick: ce,
      onKeyDown: He,
      ref: E
    }
  )), a === "icon-only" && (et = /* @__PURE__ */ e.createElement(
    mt,
    {
      id: Z,
      ariaLabel: l,
      size: u,
      variant: "standard",
      iconName: c,
      type: "button",
      disabled: n,
      className: `${H}__trigger ${H}__trigger--icon-only`,
      "aria-haspopup": "true",
      "aria-controls": W,
      "aria-expanded": D,
      onClick: ce,
      onKeyDown: He,
      ref: E,
      hasTooltip: !1
    }
  )), (a === "avatar" || a === "avatar-with-text") && (et = /* @__PURE__ */ e.createElement(
    "button",
    {
      id: Z,
      type: "button",
      disabled: n,
      className: `${H}__trigger ${H}__trigger--avatar`,
      "aria-label": a === "avatar" ? l : null,
      "aria-haspopup": "true",
      "aria-controls": W,
      "aria-expanded": D,
      onClick: ce,
      onKeyDown: He,
      ref: E
    },
    /* @__PURE__ */ e.createElement("span", { className: `${H}__avatar-label` }, /* @__PURE__ */ e.createElement(ut, { size: "sm", imageSrc: s || V }), a === "avatar-with-text" && l),
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: "angleDown",
        iconSize: "md",
        className: `${H}__trigger-icon ${H}__trigger-icon--${a}`
      }
    )
  ));
  const pe = (P) => {
    const re = P.target;
    re.classList.toggle(`${H}__toggle--expanded`), re.setAttribute(
      "aria-expanded",
      re.getAttribute("aria-expanded") === "true" ? "false" : "true"
    ), re.nextElementSibling.classList.toggle(`${H}__mobile-menu--expanded`);
  }, fe = () => /* @__PURE__ */ e.createElement("ul", { className: `${H}__mobile-menu`, role: "menu" }, i.map((P, re) => We(P, re)));
  let xe;
  const Re = a === "icon-end" ? "pds-button pds-button--navbar" : null, De = [`${H}__toggle`, Re].join(" ").trim().replace(/\s+/g, " ");
  T && (xe = /* @__PURE__ */ e.createElement(
    "button",
    {
      id: Z,
      type: "button",
      disabled: n,
      className: De,
      "aria-expanded": !1,
      onClick: pe
    },
    a === "avatar" || a === "avatar-with-text" ? /* @__PURE__ */ e.createElement("span", { className: `${H}__avatar-label` }, /* @__PURE__ */ e.createElement(
      ut,
      {
        size: "sm",
        imageSrc: s || V
      }
    ), l) : a === "icon-only" ? /* @__PURE__ */ e.createElement("span", { className: `${H}__icon-label` }, /* @__PURE__ */ e.createElement(q, { iconName: c }), " ", l) : l,
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: "angleDown",
        iconSize: "md",
        className: `${H}__toggle-icon ${H}__toggle-icon--${a}`
      }
    )
  ));
  const Ae = xe, ft = D ? `${H}--expanded` : null;
  return /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: [H, A, I, ft, C].join(" ").trim().replace(/\s+/g, " "),
      "data-testid": h,
      ref: O
    }, $),
    T ? /* @__PURE__ */ e.createElement(e.Fragment, null, Ae, /* @__PURE__ */ e.createElement(fe, null)) : /* @__PURE__ */ e.createElement(e.Fragment, null, et, Vt(i))
  );
};
Is.propTypes = {
  /**
   * Image src for avatar — only necessary for avatar-based buttons.
   */
  avatarImageSrc: t.string,
  /**
   * Is the button disabled?
   */
  disabled: t.bool,
  /**
   * How the button is displayed.
   */
  displayType: t.oneOf([
    "icon-end",
    "icon-only",
    "avatar",
    "avatar-with-text"
  ]),
  /**
   * Icon name for icon-only buttons.
   */
  iconName: Ht,
  /**
   * Optional ID value for this component.
   */
  id: t.string,
  /**
   * Will this be used for a split button?
   */
  isSplitButton: t.bool,
  /**
   * The text of the button
   */
  label: t.node.isRequired,
  /**
   * Array of menu items
   */
  menuItems: t.arrayOf(
    t.oneOfType([
      b1,
      Ns,
      ks,
      v1,
      _1
    ])
  ),
  /**
   * Horizontal position of the menu relative to the button. Applies to breakpoints `md` and up.
   */
  menuPosition: t.oneOf(["start", "end"]),
  /**
   * Which size of button to render — not valid for avatar-based display types.
   */
  size: t.oneOf(["sm", "md"]),
  /**
   *  Optional `data-testid` value for this component
   */
  testId: t.string,
  /**
   *  Translatable string for description of unlabeled group of menu items.
   */
  undefinedLabel: t.string,
  /**
   * Which variant of button to render — only valid for icon-end (default) display type.
   */
  variant: t.oneOf(["primary", "secondary", "navbar"]),
  /**
   * Is this button located in the top nav? Only applies when using the Navbar component from this toolkit. Otherwise set to false or omit.
   */
  withinNavbar: t.bool,
  /**
   * Additional class names
   */
  className: t.string
};
const Ss = ({ items: s, label: n, mobileMenuMaxWidth: a = 640 }) => {
  const [c, r] = R(!1), [o, l] = R(0);
  oe(() => (l(window.innerWidth), window.addEventListener("resize", i), () => {
    window.removeEventListener("resize", i);
  }), []);
  const i = () => {
    l(window.innerWidth);
  }, d = o <= a, u = "pds-nav-menu", { refs: h, context: m } = Ie({
    placement: "bottom-start",
    open: c,
    onOpenChange: r,
    whileElementsMounted: qe
  }), p = ot(m, { event: "mousedown" }), f = Se(m), C = Te(m, { role: "menu" });
  let $;
  d ? $ = _t(m, {
    enabled: !1
  }) : $ = _t(m, {
    handleClose: bs({
      requireIntent: !1,
      buffer: 10,
      blockPointerEvents: !0,
      enabled: !0
    })
  });
  const { getReferenceProps: g, getFloatingProps: _ } = Oe([
    f,
    C,
    p,
    $
  ]), b = (v) => !!(v.isActive || v.linkContent && v.linkContent.props.className && v.linkContent.props.className.includes("pds-isActive"));
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "button",
    y({
      className: `${u}__trigger`,
      ref: h.setReference
    }, g()),
    n,
    /* @__PURE__ */ e.createElement(q, { iconName: "angleDown", className: `${u}__trigger-icon` })
  ), c && /* @__PURE__ */ e.createElement(
    "ul",
    y({
      className: `${u}__dropdown`,
      ref: h.setFloating
    }, _()),
    s.map((v, E) => /* @__PURE__ */ e.createElement(
      "li",
      {
        key: E,
        role: v.isSeparator ? "separator" : "menuitem",
        className: `${u}__item ${v.isSeparator ? `${u}__dropdown--separator` : `${u}__item--second-level`} ${b(v) ? `${u}__item--active` : null}`
      },
      !v.isSeparator && v.linkContent
    ))
  ));
};
Ss.propTypes = {
  items: t.array,
  label: t.string,
  mobileMenuMaxWidth: t.number
};
const j1 = (l) => {
  var i = l, {
    ariaLabel: s = "Main Navigation",
    colorType: n = "default",
    menuItems: a,
    mobileMenuMaxWidth: c = 640,
    className: r
  } = i, o = S(i, [
    "ariaLabel",
    "colorType",
    "menuItems",
    "mobileMenuMaxWidth",
    "className"
  ]);
  const [d, u] = R(1025), [h, m] = R(null), [p, f] = R(-1), [C, $] = R(null), [g, _] = R({
    containerChildren: []
  });
  oe(() => (u(window.innerWidth), window.addEventListener("resize", b), () => {
    window.removeEventListener("resize", b);
  }), []);
  const b = () => {
    u(window.innerWidth);
  }, v = d <= c;
  oe(() => {
    g.containerChildren[h] && (g.containerChildren[h].classList.contains(
      "pds-nav-menu__dropdown--separator"
    ) && C == "down" ? m(h + 1) : g.containerChildren[h].classList.contains(
      "pds-nav-menu__dropdown--separator"
    ) && C == "up" ? m(h - 1) : g.containerChildren[h].children[0].focus());
  }, [h]), oe(() => {
    p != -1 && (N.current[p].children[0].blur(), N.current[p].children[0].focus({
      focusVisible: !0
    }));
  }, [p]);
  const E = "pds-nav-menu", w = n !== "default" ? `${E}--${n}` : "", L = v ? `${E}--isMobile` : `${E}--notMobile`, N = se([]), M = (z) => {
    const T = N.current.length - 1, B = {
      ArrowRight: () => {
        m(-1), f(p === -1 ? 1 : p === T ? 0 : p + 1);
      },
      ArrowLeft: () => {
        m(-1), f(p === 0 ? T : p - 1);
      },
      ArrowDown: () => {
        var K, O, D, F;
        $("down");
        let W = z.target.parentNode.children[1], Z = ((O = (K = z.target) == null ? void 0 : K.parentNode.children[1]) == null ? void 0 : O.children) || ((F = (D = z.target) == null ? void 0 : D.parentNode.parentNode.children[1]) == null ? void 0 : F.children);
        g.container != W && W != null && _({
          container: W,
          containerChildren: [...Z]
        }), h === null || h == g.containerChildren.length - 1 ? m(0) : m(parseInt(h) + 1);
      },
      ArrowUp: () => {
        $("up"), m(h === 0 ? g.containerChildren.length - 1 : parseInt(h) - 1);
      }
    }[z.code];
    B && B();
  }, k = (z) => {
    if (z.isActive || z.linkContent && z.linkContent.props.className && z.linkContent.props.className.includes("pds-isActive"))
      return !0;
    if (z.links) {
      for (let T = 0; T < z.links.length; T++)
        if (k(z.links[T]))
          return !0;
    }
    return !1;
  };
  let x = [];
  return a.map((z, T) => {
    const V = `item-${je()}`, H = z.id ? z.id : V;
    z.links ? x.push(
      /* @__PURE__ */ e.createElement(
        "li",
        {
          key: `${T}-dropdown`,
          id: H,
          ref: (I) => N.current[T] = I,
          className: `${E}__item ${E}__item--top-level ${E}__item--has-children ${k(z) === !0 ? `${E}__item--active` : ""}`
        },
        /* @__PURE__ */ e.createElement(
          Ss,
          {
            label: z.label,
            items: z.links,
            mobileMenuMaxWidth: c
          }
        )
      )
    ) : x.push(
      /* @__PURE__ */ e.createElement(
        "li",
        {
          key: T,
          id: H,
          ref: (I) => N.current[T] = I,
          className: `${E}__item ${E}__item--top-level ${E}__item--has-link ${k(z) === !0 ? `${E}__item--active` : ""}`
        },
        z.linkContent
      )
    );
  }), /* @__PURE__ */ e.createElement(
    "nav",
    y({
      className: [E, w, L, r].join(" ").trim().replace(/\s+/g, " "),
      "aria-label": s,
      onKeyDown: (z) => {
        M(z);
      }
    }, o),
    /* @__PURE__ */ e.createElement("ul", { className: `${E}__menu` }, x)
  );
};
j1.propTypes = {
  /**
   * Aria label for `nav` element.
   */
  ariaLabel: t.string.isRequired,
  /**
   * Color scheme.
   */
  colorType: t.oneOf(["default", "reverse"]),
  /**
   * Menu Items.
   */
  menuItems: t.array,
  /**
   *  Mobile menu will be enabled when viewport is at or below this number in pixels.
   */
  mobileMenuMaxWidth: t.number,
  /**
   * Additional class names
   */
  className: t.string
};
const Ct = (o) => {
  var l = o, {
    label: s,
    size: n = "md",
    color: a = "neutral",
    className: c
  } = l, r = S(l, [
    "label",
    "size",
    "color",
    "className"
  ]);
  const i = "pds-indicator-badge", d = `${i}--${a}`, u = `${i}--${n}`;
  return /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: [i, d, u, c != null ? c : ""].join(" ").trim().replace(/\s+/g, " ")
    }, r),
    /* @__PURE__ */ e.createElement("span", { className: `${i}__label` }, s)
  );
}, Ts = (c) => {
  var r = c, { platformType: s, className: n } = r, a = S(r, ["platformType", "className"]);
  const o = "pds-platform-icon", l = `pds-platform-icon--${s}`;
  let i;
  if (["front-end-sites", "gatsby-wp", "next-drupal", "next-wp"].includes(s)) {
    let u = [];
    switch (s) {
      case "front-end-sites":
        u = ["next", "gatsby"];
        break;
      case "next-drupal":
        u = ["next", "drupal"];
        break;
      case "gatsby-wp":
        u = ["gatsby", "wordpress"];
        break;
      case "next-wp":
        u = ["next", "wordpress"];
        break;
    }
    i = /* @__PURE__ */ e.createElement("span", { className: `${o}__group` }, qt[u[0]], qt[u[1]]);
  } else
    i = qt[s];
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [o, l, n].join(" ").trim().replace(/\s+/g, " ")
    }, a),
    i
  );
};
Ts.propTypes = {
  /**
   * Which platform icon to display
   */
  platformType: t.oneOf([
    "drupal",
    "drupal7",
    "front-end-sites",
    "gatsby",
    "gatsby-wp",
    "import-custom",
    "next",
    "next-drupal",
    "next-wp",
    "wordpress"
  ]),
  /**
   * Additional class names
   */
  className: t.string
};
const qt = {
  drupal: /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        width: "32",
        height: "32",
        rx: "16",
        fill: "var(--pds-color-partner-drupal)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19.4541 9.6854C17.9104 8.13834 16.4379 6.66349 15.9995 5C15.5612 6.66349 14.0886 8.13834 12.545 9.6854C10.2299 12.0051 7.60526 14.6344 7.60526 18.5778C7.60346 23.2271 11.3596 26.9973 15.9959 27C20.6323 27.0018 24.392 23.2353 24.3947 18.586C24.3947 18.5832 24.3947 18.5805 24.3947 18.5778C24.3947 14.6344 21.7701 12.0051 19.4541 9.6854ZM11.1732 20.5401C10.6584 20.5229 8.75918 17.2393 12.2831 13.7435L14.6152 16.2979C14.6935 16.3755 14.6944 16.5018 14.617 16.5804C14.6116 16.5858 14.6062 16.5912 14.5999 16.5957C14.0436 17.168 11.6719 19.5535 11.3767 20.3776C11.3154 20.5482 11.2272 20.541 11.1732 20.5392M15.9995 24.8663C14.4055 24.8663 13.112 23.5701 13.112 21.9716C13.1228 21.2694 13.3776 20.5933 13.8312 20.059C14.3515 19.4209 15.9986 17.6256 15.9986 17.6256C15.9986 17.6256 17.6197 19.447 18.1616 20.0536C18.6332 20.5798 18.8924 21.264 18.8861 21.9716C18.8861 23.5701 17.5936 24.8672 15.9986 24.8672M21.5243 20.1727C21.4622 20.309 21.3209 20.5374 21.1301 20.5437C20.7907 20.5563 20.7538 20.3812 20.5036 20.0094C19.9528 19.1916 15.1436 14.1515 14.2435 13.1767C13.4523 12.3192 14.1318 11.7154 14.4478 11.3985C14.8438 11.0014 15.9977 9.84426 15.9977 9.84426C15.9977 9.84426 19.4406 13.1207 20.8754 15.3592C22.3101 17.5976 21.8151 19.5346 21.5243 20.1736",
        fill: "var(--pds-color-foreground-reverse)"
      }
    )
  ),
  drupal7: /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        width: "32",
        height: "32",
        rx: "16",
        fill: "var(--pds-color-partner-drupal)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M20.2634 9.37661C19.2723 8.72036 18.3214 8.46255 17.375 7.8063C16.7946 7.3938 15.9777 6.40005 15.2991 5.54224C15.1786 6.91567 14.7857 7.47349 14.317 7.86255C13.3661 8.65942 12.7634 8.90317 11.9286 9.37661C11.2232 9.76567 7.42857 12.5079 7.42857 17.6172C7.42857 22.736 11.5268 26.5 16.0804 26.5C20.6205 26.5 24.5714 23.0313 24.5714 17.7813C24.5714 12.5172 20.8661 9.76567 20.2634 9.37661ZM20.375 24.6391C19.4777 25.5813 16.3527 25.9844 15.1652 24.836C14.9509 24.611 15.1786 24.2735 15.4554 24.2735C15.4554 24.2735 16.2143 24.8969 17.7545 24.8969C18.9598 24.8969 19.808 24.536 20.1875 24.2407C20.4598 24.025 20.5625 24.4422 20.375 24.6391ZM17.942 22.1735C18.3304 22.0047 19.2366 21.9954 19.5848 22.2344C19.7679 22.3657 20.3036 23.1157 19.8616 23.3454C19.4866 23.5422 19.808 22.6094 18.6786 22.6094C18.0223 22.6094 17.808 22.8532 17.4866 23.125C17.1741 23.4063 17.0491 23.5 16.942 23.3454C16.6741 22.961 17.6518 22.3 17.942 22.1735ZM22.0714 22.9844C21.3929 22.9375 20.0402 20.6969 19.1696 20.6641C17.7902 20.6219 14.5223 24.4469 11.9688 22.6329C10.2366 21.386 11.317 17.7204 14.2813 17.7016C16.4911 17.6782 18.0223 19.9985 19.125 19.975C20.0759 19.961 21.8839 18.0157 22.7768 18.0157C24.9509 18.0157 23.817 23.1391 22.0714 22.9844Z",
        fill: "white"
      }
    )
  ),
  wordpress: /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        width: "32",
        height: "32",
        rx: "16",
        fill: "var(--pds-color-partner-wordpress)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16 4.72C18.256 4.72 20.452 5.39201 22.312 6.65201C24.124 7.87601 25.552 9.60401 26.404 11.62C27.892 15.136 27.496 19.156 25.36 22.312C24.136 24.124 22.408 25.552 20.392 26.404C16.876 27.892 12.856 27.496 9.7 25.36C7.888 24.136 6.46 22.408 5.608 20.392C4.12 16.876 4.516 12.856 6.652 9.70001C7.876 7.88801 9.60401 6.46001 11.62 5.60801C13 5.02001 14.5 4.72 16 4.72ZM16 4C9.376 4 4 9.37601 4 16C4 22.624 9.376 28 16 28C22.624 28 28 22.624 28 16C28 9.37601 22.624 4 16 4Z",
        fill: "var(--pds-color-foreground-reverse)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.00436 15.9998C6.00436 19.8278 8.18837 23.3318 11.6444 24.9998L6.86836 11.9318C6.29236 13.2158 6.00436 14.5958 6.00436 15.9998ZM22.7564 15.4958C22.7564 14.2598 22.3124 13.4078 21.9284 12.7358C21.5444 12.0638 20.9444 11.2118 20.9444 10.3958C20.9444 9.57983 21.6404 8.61983 22.6244 8.61983H22.7564C18.6884 4.88783 12.3644 5.16383 8.63237 9.24383C8.27237 9.63983 7.93637 10.0598 7.64837 10.5038H8.29637C9.34037 10.5038 10.9604 10.3718 10.9604 10.3718C11.5004 10.3358 11.5604 11.1278 11.0204 11.1998C11.0204 11.1998 10.4804 11.2598 9.88037 11.2958L13.5164 22.1318L15.7004 15.5678L14.1404 11.2958C13.6004 11.2598 13.0964 11.1998 13.0964 11.1998C12.5564 11.1638 12.6164 10.3478 13.1564 10.3718C13.1564 10.3718 14.8124 10.5038 15.7844 10.5038C16.7564 10.5038 18.4484 10.3718 18.4484 10.3718C18.9884 10.3358 19.0484 11.1278 18.5084 11.1998C18.5084 11.1998 17.9684 11.2598 17.3684 11.2958L20.9804 22.0478L22.0124 18.7838C22.4684 17.3558 22.7444 16.3478 22.7444 15.4838L22.7564 15.4958ZM16.1684 16.8638L13.1684 25.5878C15.1844 26.1758 17.3324 26.1278 19.3124 25.4318L19.2404 25.2998L16.1684 16.8638ZM24.7724 11.1998C24.8204 11.5358 24.8444 11.8838 24.8444 12.2318C24.8444 13.2518 24.6524 14.3918 24.0884 15.8078L21.0284 24.6398C25.7084 21.9158 27.3764 15.9518 24.7724 11.1998Z",
        fill: "var(--pds-color-foreground-reverse)"
      }
    )
  ),
  gatsby: /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        width: "32",
        height: "32",
        rx: "16",
        fill: "var(--pds-color-partner-gatsby)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.7785 15.7952L27.8109 16.0481C28.0701 18.0131 27.3442 20.5682 25.9055 22.7082C24.1946 25.2763 21.6478 27.0468 18.7315 27.7083L18.5759 27.7407L4.25366 13.5124L4.2796 13.3632C4.62308 11.2945 5.74423 9.23224 7.42272 7.55908C9.09474 5.89241 11.2139 4.71859 13.3914 4.25814C18.0769 3.26592 23.0929 5.1985 25.5815 8.94689L25.7176 9.15439L25.5362 9.32301C25.5005 9.35868 25.4633 9.39274 25.426 9.42679C25.3887 9.46083 25.3514 9.49488 25.3158 9.53055C25.1473 9.69268 24.9724 9.8548 24.7909 10.0169C24.6378 10.1588 24.4847 10.2907 24.3229 10.43C24.2998 10.45 24.2765 10.47 24.253 10.4903C24.1752 10.5617 24.0909 10.633 24.0067 10.7044L23.7734 10.9054L23.5855 10.6654C20.9284 7.31264 17.5909 6.08048 13.6636 7.00785C10.689 7.70824 8.53737 9.61485 7.26716 12.6693L19.4119 24.6797C22.1144 23.5643 23.8966 21.5928 24.8557 18.6616H19.1592V15.7952H27.7785ZM18.7703 27.1052C21.4793 26.4567 23.8382 24.7835 25.4324 22.3905C26.7221 20.4514 27.409 18.1752 27.247 16.3723H19.7295V18.0714H25.6334L25.5232 18.4476C24.5381 21.7874 22.4903 24.0896 19.4444 25.2893L19.2694 25.3607L6.58024 12.8055L6.6515 12.6239C7.993 9.27761 10.3066 7.18941 13.534 6.43065C17.6038 5.47086 21.0775 6.69008 23.8577 10.0558L23.8771 10.0364C24.065 9.87425 24.2335 9.72511 24.4085 9.56946C24.5706 9.4253 24.7327 9.27556 24.8896 9.13058L24.927 9.09603C24.9399 9.08958 24.9528 9.07669 24.9657 9.06377L24.9658 9.06361C22.555 5.64596 17.8954 3.90797 13.521 4.82885C9.30857 5.71731 5.62754 9.34895 4.88875 13.3113L18.7703 27.1052ZM7.55861 24.6407C5.18671 22.3191 3.8906 19.2451 4.00725 16.2036L4.03313 15.5357L16.5278 27.9416L15.8797 27.9806C15.6853 27.9935 15.4973 28 15.3094 28C12.5551 28 9.76202 26.7938 7.55861 24.6407Z",
        fill: "var(--pds-color-foreground-reverse)"
      }
    )
  ),
  next: /* @__PURE__ */ e.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "32",
      fill: "none",
      viewBox: "0 0 32 32"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        width: "32",
        height: "32",
        fill: "var(--pds-color-partner-nextjs)",
        rx: "16"
      }
    ),
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#clip0_3906_4409)" }, /* @__PURE__ */ e.createElement(
      "mask",
      {
        id: "mask0_3906_4409",
        style: { maskType: "alpha" },
        width: "24",
        height: "24",
        x: "4",
        y: "4",
        maskUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fill: "var(--pds-color-foreground-default)",
          d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z"
        }
      )
    ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0_3906_4409)" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: "var(--pds-color-foreground-default)",
        stroke: "var(--pds-color-foreground-reverse)",
        strokeWidth: "1.333",
        d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: "url(#paint0_linear_3906_4409)",
        d: "M23.934 25.003L13.22 11.2H11.2v9.596h1.615v-7.545l9.851 12.728c.445-.297.869-.624 1.268-.976z"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: "url(#paint1_linear_3906_4409)",
        d: "M20.933 11.2h-1.6v9.6h1.6v-9.6z"
      }
    ))),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_3906_4409",
        x1: "18.533",
        x2: "23.267",
        y1: "19.533",
        y2: "25.4",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "var(--pds-color-foreground-reverse)" }),
      /* @__PURE__ */ e.createElement(
        "stop",
        {
          offset: "1",
          stopColor: "var(--pds-color-foreground-reverse)",
          stopOpacity: "0"
        }
      )
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_3906_4409",
        x1: "20.133",
        x2: "20.107",
        y1: "11.2",
        y2: "18.25",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "var(--pds-color-foreground-reverse)" }),
      /* @__PURE__ */ e.createElement(
        "stop",
        {
          offset: "1",
          stopColor: "var(--pds-color-foreground-reverse)",
          stopOpacity: "0"
        }
      )
    ), /* @__PURE__ */ e.createElement("clipPath", { id: "clip0_3906_4409" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: "var(--pds-color-foreground-reverse)",
        d: "M0 0H24V24H0z",
        transform: "translate(4 4)"
      }
    )))
  ),
  "import-custom": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        width: "32",
        height: "32",
        rx: "16",
        fill: "var(--pds-color-foreground-default)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 10.5V15H21.5C22.0312 15 22.5 15.4688 22.5 16C22.5 16.5625 22.0312 17 21.5 17H17V21.5C17 22.0625 16.5312 22.5 16 22.5C15.4375 22.5 15 22.0625 15 21.5V17H10.5C9.9375 17 9.5 16.5625 9.5 16C9.5 15.4688 9.9375 15 10.5 15H15V10.5C15 9.96875 15.4375 9.5 16 9.5C16.5312 9.5 17 9.96875 17 10.5Z",
        fill: "white"
      }
    )
  )
}, os = {
  "early-access": {
    label: "Early Access",
    color: "success"
  }
}, B1 = (u) => {
  var h = u, {
    badge: s,
    icon: n,
    selectionLink: a,
    subtitle: c,
    supplementalLinks: r,
    summary: o,
    title: l,
    className: i
  } = h, d = S(h, [
    "badge",
    "icon",
    "selectionLink",
    "subtitle",
    "supplementalLinks",
    "summary",
    "title",
    "className"
  ]);
  const m = "pds-new-site-card", p = a.type;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [m, i].join(" ").trim().replace(/\s+/g, " ")
    }, d),
    /* @__PURE__ */ e.createElement(
      p,
      y({
        "aria-label": a.props.children,
        className: `${m}__selection-link`
      }, a.props),
      /* @__PURE__ */ e.createElement("div", { className: `${m}__header` }, n && /* @__PURE__ */ e.createElement("div", { className: `${m}__icon` }, /* @__PURE__ */ e.createElement(Ts, { platformType: n })), /* @__PURE__ */ e.createElement("div", { className: `${m}__title` }, l, c && /* @__PURE__ */ e.createElement("div", { className: `${m}__subtitle` }, c))),
      s && /* @__PURE__ */ e.createElement(
        Ct,
        {
          label: os[s].label,
          size: "sm",
          color: os[s].color,
          className: `${m}__badge`
        }
      ),
      o && /* @__PURE__ */ e.createElement("div", { className: `${m}__summary` }, o)
    ),
    r && r.length <= 2 && /* @__PURE__ */ e.createElement("div", { className: `${m}__links` }, r.map((f, C) => {
      const $ = f.type;
      return /* @__PURE__ */ e.createElement(
        $,
        y({
          key: C,
          className: `${m}__link`
        }, f.props),
        f.props.children,
        f.props.target === "_blank" && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: "externalLink",
            iconSize: "sm",
            className: `${m}__link-icon`
          }
        ), /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, "Opens new window"))
      );
    }))
  );
};
B1.propTypes = {
  /**
   * Optional indicator badge type. Choose from only early-access at this time.
   */
  badge: t.oneOf(["early-access"]),
  /**
   * Icon. Choose from only Platform Icons at this time.
   */
  icon: t.oneOf([
    "drupal",
    "wordpress",
    "gatsby",
    "next",
    "import-custom",
    "next-drupal",
    "gatsby-wp",
    "next-wp"
  ]),
  /**
   * The primary link for the selection card.
   */
  selectionLink: t.node.isRequired,
  /**
   * Card subtitle
   */
  subtitle: t.string,
  /**
   * Card summary
   */
  summary: t.string,
  /**
   * Array of supplemental links. Maximum of 2.
   */
  supplementalLinks: t.arrayOf(t.node),
  /**
   * Card title
   */
  title: t.string.isRequired,
  /**
   * Additional class names
   */
  className: t.string
};
const it = $t({}), F1 = (s) => {
  if (typeof window == "undefined")
    return 0;
  const n = window.location.href.split("/"), c = `/${n[n.length - 1]}`.split("");
  return c.forEach((o, l) => {
    if (o === "?") {
      c.length = l;
      return;
    }
  }), s.findIndex(
    (o) => o.link === c.join("")
  );
}, Os = ({
  pages: s,
  render: n = null,
  paginationItemClickHandler: a = null,
  headingId: c = "Pager-heading",
  buttonCallback: r = null,
  children: o
}) => {
  const [l, i] = R(() => F1(s)), [d, u] = R([]), h = s.length, [m, p] = R("");
  return /* @__PURE__ */ e.createElement(
    it.Provider,
    {
      value: {
        currentKey: l,
        setCurrentKey: i,
        currentPages: d,
        setCurrentPages: u,
        pageDirection: m,
        setDirection: p,
        itemLength: h,
        pages: s,
        render: n,
        paginationItemClickHandler: a,
        buttonCallback: r,
        headingId: c
      }
    },
    o
  );
};
Os.propTypes = {
  children: t.node.isRequired,
  render: t.func,
  paginationItemClickHandler: t.func,
  buttonCallback: t.func,
  pages: t.arrayOf(t.shape({ link: t.string })).isRequired,
  headingId: t.string
};
const xt = (C) => {
  var $ = C, {
    disabled: s = !1,
    id: n,
    initialValue: a,
    inputWidth: c,
    label: r,
    message: o,
    onOptionSelect: l,
    options: i,
    required: d = !1,
    selectOptionsLabel: u = "Select an option...",
    showLabel: h = !0,
    validationFunction: m,
    className: p
  } = $, f = S($, [
    "disabled",
    "id",
    "initialValue",
    "inputWidth",
    "label",
    "message",
    "onOptionSelect",
    "options",
    "required",
    "selectOptionsLabel",
    "showLabel",
    "validationFunction",
    "className"
  ]);
  const [g, _] = R(!1), [b, v] = R(null), [E, w] = R(a), [L, N] = R(), [M, k] = R(null), x = se([]), z = "pds-select", { context: T, refs: V } = Ie({
    open: g,
    onOpenChange: _,
    whileElementsMounted: qe
  }), H = Te(T, { role: "listbox" }), I = Se(T), A = pt(T, {
    listRef: x,
    activeIndex: b,
    onNavigate: v,
    loop: !0,
    openOnArrowKeyDown: !0
  }), { getReferenceProps: j, getFloatingProps: B, getItemProps: W } = Oe(
    [I, H, A]
  ), { isMounted: Z, styles: K } = Xe(T, {
    duration: {
      open: 300,
      close: 150
    },
    initial: {
      opacity: 0
    },
    open: {
      opacity: 1
    },
    close: {
      opacity: 0
    }
  }), O = (ee) => {
    const J = i.find((G) => G.value === ee);
    return J ? J.label : "";
  }, F = ((ee) => ee.map((G) => {
    const { label: he, value: we } = G;
    return {
      label: he,
      value: we || he
    };
  }))(i), U = () => {
    N(""), k(null);
  }, ie = (ee) => {
    const J = m(ee) || {};
    U(), J.error && k("error"), J.success && k("success"), N(J.message);
  }, Q = (ee) => {
    const J = F[ee];
    w(J.value), v(null), _(!1), l && l(J), m && ie(J);
  }, ve = /* @__PURE__ */ e.createElement(q, { iconName: "angleDown", className: `${z}__trigger-icon` }), te = /* @__PURE__ */ e.createElement(q, { iconName: "check", className: `${z}__checked-icon` }), de = F.map((ee, J) => /* @__PURE__ */ e.createElement(
    xs,
    ge(y({
      key: ee
    }, W({
      key: ee.value,
      ref(G) {
        x.current[J] = G;
      },
      onClick() {
        var G;
        Q(J), (G = V.domReference.current) == null || G.focus();
      },
      onKeyDown(G) {
        (G.key === "Enter" || G.key === " ") && Q(J);
      }
    })), {
      tabIndex: b === J ? 0 : -1,
      active: b === J
    }),
    ee.label,
    E === ee.value && te
  )), le = L || o, ne = c ? `${c / 16}rem` : null, Ee = c ? { width: ne } : null;
  return /* @__PURE__ */ e.createElement(
    Je,
    y({
      className: p,
      disabled: s,
      id: n,
      inputFieldType: "select",
      inputWidth: c,
      label: r,
      message: le,
      required: d,
      showLabel: h,
      validationState: M
    }, f),
    /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: [z].join(" ").trim().replace(/\s+/g, " "),
        id: n,
        name: n,
        style: Ee,
        tabIndex: 0,
        "aria-label": r,
        "aria-disabled": s,
        "aria-required": d ? !0 : null,
        "aria-invalid": M === "error",
        "aria-describedby": le ? `${n}__message` : null,
        ref: V.setReference
      }, j({
        "aria-autocomplete": "list",
        disabled: s,
        onClick: () => s ? null : _(!g),
        onChange: Q,
        onKeyDown: (ee) => {
          (ee.key === "Enter" || ee.key === " ") && _(!0);
        }
      })),
      /* @__PURE__ */ e.createElement("span", null, O(E) || u),
      ve
    ),
    Z && /* @__PURE__ */ e.createElement(
      "div",
      y({
        ref: V.setFloating,
        className: `${z}__dropdown`
      }, B({
        style: {
          zIndex: "var(--pds-z-index-dropdown)"
        }
      })),
      /* @__PURE__ */ e.createElement("div", { style: y({}, K) }, /* @__PURE__ */ e.createElement("ul", { className: `${z}__options` }, de))
    )
  );
};
xt.displayName = "Select";
xt.propTypes = {
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * Id of element.
   */
  id: t.string.isRequired,
  /**
   * Initial value to set the select to.
   */
  initialValue: t.string,
  /**
   * Width of the input field. Accepts a number in pixels. Leave blank for width: 100%.
   */
  inputWidth: t.number,
  /**
   * Text label associated with the field.
   */
  label: t.string.isRequired,
  /**
   * Message or description used to help clarify the usage of the input.
   */
  message: t.string,
  /**
   * Callback function that will return the updated value from the instance when an option is selected.
   * Function should have the shape of: `(value) => { <do stuff here> } `.
   */
  onOptionSelect: t.func,
  /**
   * Array of select options
   */
  options: t.arrayOf(
    t.shape({
      /**
       * Option label.
       */
      label: t.string.isRequired,
      /**
       * Option value. Will default to label if not provided.
       */
      value: t.string
    })
  ).isRequired,
  /**
   * Is the field required?
   */
  required: t.bool,
  /**
   * Default string for the select options label.
   */
  selectOptionsLabel: t.string,
  /**
   * Should the label be visible? If false, it will render for screen readers only. This should be used very rarely and only on single-field forms.
   */
  showLabel: t.bool,
  /**
   * If custom field validation is desired, provide a function that accepts the input's value and will return one of the response objects below.
   *
   * Error:<br/>
   * ```
   * {
   *   error: true,
   *   message: [string],
   * }
   * ```
   *
   * Success:<br/>
   * ```
   * {
   *   success: true,
   *   message: [string]
   * }
   * ```
   */
  validationFunction: t.func,
  /**
   * Additional class names
   */
  className: t.string
};
const W1 = {
  left: {
    title: "Go to previous page",
    rel: "prev",
    srText: "Previous page",
    icon: "arrowLeft",
    keyModifier: (s) => s - 1
  },
  right: {
    title: "Go to next page",
    rel: "next",
    srText: "Next page",
    icon: "arrowRight",
    keyModifier: (s) => s + 1
  }
}, Ye = (c) => {
  var r = c, { arrowText: s = null, direction: n } = r, a = S(r, ["arrowText", "direction"]);
  const { buttonCallback: o, currentKey: l, setCurrentKey: i, setDirection: d, pages: u } = ke(it), h = Gt(
    (g, _) => {
      o && (g.preventDefault(), o(_));
    },
    [o, l]
  ), { title: m, rel: p, srText: f, icon: C, keyModifier: $ } = W1[n];
  return /* @__PURE__ */ e.createElement(
    "li",
    y({
      className: `pds-pager__item pds-pager__item--navigation ${s ? `pds-pager__item--navigation-text pds-pager__item--navigation-text-${n}` : null}`
    }, a),
    /* @__PURE__ */ e.createElement(
      "a",
      {
        title: m,
        rel: p,
        href: u[$(l)].link,
        onClick: (g) => {
          h(g, $(l)), i($(l)), d(n);
        }
      },
      n === "right" && s ? /* @__PURE__ */ e.createElement("span", null, s) : null,
      /* @__PURE__ */ e.createElement(q, { iconName: C, classes: "pds-page__icon" }),
      /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, f),
      n === "left" && s ? /* @__PURE__ */ e.createElement("span", null, s) : null
    )
  );
};
Ye.propTypes = {
  arrowText: t.string,
  direction: t.oneOf(["right", "left"])
};
const Z1 = (n) => {
  var s = S(n, []);
  const {
    buttonCallback: a,
    currentKey: c,
    setCurrentKey: r,
    headingId: o,
    itemLength: l,
    pages: i
  } = ke(it), d = [];
  return i.forEach((u, h) => {
    let m = { label: `Page ${h + 1}`, value: `${h + 1}` };
    d.push(m);
  }), /* @__PURE__ */ e.createElement(
    "nav",
    y({
      className: "pds-pager pds-pager__mini",
      role: "navigation",
      "aria-labelledby": o
    }, s),
    /* @__PURE__ */ e.createElement("div", { id: o, className: "visually-hidden" }, "Pagination"),
    /* @__PURE__ */ e.createElement("ul", { className: "pds-pager__items" }, c > 0 ? /* @__PURE__ */ e.createElement(Ye, { arrowText: "Previous", direction: "left" }) : null, /* @__PURE__ */ e.createElement("li", null, /* @__PURE__ */ e.createElement(
      xt,
      {
        label: "Page select dropdown",
        selectOptions: d,
        selectOptionsLabel: `Page ${c + 1}`,
        onChange: (u) => {
          console.log(u), r(parseInt(u - 1)), a(parseInt(u - 1));
        }
      }
    )), /* @__PURE__ */ e.createElement("li", { className: "pds-pager__items-mini" }, `of ${l}`), c < l - 1 ? /* @__PURE__ */ e.createElement(Ye, { arrowText: "Next", direction: "right" }) : null)
  );
};
function U1(s, n, a, c, r, o) {
  if (c > 3) {
    let l = [];
    const i = n.find((d) => d.key == c);
    (n[0].key === c || !i) && (c > r - 3 ? (l = [
      {
        page: s[r - 4],
        key: r - 4
      },
      {
        page: s[r - 3],
        key: r - 3
      },
      {
        page: s[r - 2],
        key: r - 2
      },
      {
        page: s[r - 1],
        key: r - 1
      }
    ], a(l)) : c === r - 1 ? s.forEach((d, u) => {
      u > r - 4 && l.push({ page: d, key: u });
    }) : s.forEach((d, u) => {
      u >= c && u < c + 4 && l.push({ page: d, key: u });
    }), c > 3 && (l = [
      { page: s[0], key: 0 },
      { page: s[1], key: 1 },
      "...",
      ...l
    ]), o === "left" && c === r - 5 && (l = [
      { page: s[0], key: 0 },
      { page: s[1], key: 1 },
      "...",
      {
        page: s[s.length - 6],
        key: s.length - 6
      },
      {
        page: s[s.length - 5],
        key: s.length - 5
      },
      {
        page: s[s.length - 4],
        key: s.length - 4
      },
      {
        page: s[s.length - 3],
        key: s.length - 3
      }
    ]), c > r - 5 ? l = [
      { page: s[0], key: 0 },
      { page: s[1], key: 1 },
      "...",
      {
        page: s[s.length - 4],
        key: s.length - 4
      },
      {
        page: s[s.length - 3],
        key: s.length - 3
      },
      {
        page: s[s.length - 2],
        key: s.length - 2
      },
      {
        page: s[s.length - 1],
        key: s.length - 1
      }
    ] : c < r - 3 && (l = [
      ...l,
      "...",
      {
        page: s[s.length - 2],
        key: s.length - 2
      },
      {
        page: s[s.length - 1],
        key: s.length - 1
      }
    ]), a(l));
  } else {
    let l = [];
    s.forEach((i, d) => {
      d < 4 && l.push({ page: i, key: d });
    }), !(c > r - 3) && r > 4 && (l = [
      ...l,
      "...",
      {
        page: s[s.length - 2],
        key: s.length - 2
      },
      {
        page: s[s.length - 1],
        key: s.length - 1
      }
    ]), a(l);
  }
}
const Rs = (c) => {
  var r = c, { index: s, page: n } = r, a = S(r, ["index", "page"]);
  var h;
  const o = function() {
    i(n == null ? void 0 : n.key);
  }, {
    currentKey: l,
    setCurrentKey: i,
    render: d = null,
    paginationItemClickHandler: u
  } = ke(it);
  return /* @__PURE__ */ e.createElement(e.Fragment, null, n.key || n.key === 0 ? /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: `pds-pager__item ${l == (n == null ? void 0 : n.key) ? " pds-pager__item--active" : ""}`,
      title: s === l ? "Current page" : `Go to page ${s + 1}`,
      onClick: () => {
        o(), u && u(n.key);
      }
    }, a),
    /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, l === s ? "Current Page" : `Page ${(n != null && n.key ? n == null ? void 0 : n.key : s) + 1}`),
    d((h = n.page) == null ? void 0 : h.link, n.key + 1)
  ) : /* @__PURE__ */ e.createElement(
    "span",
    {
      className: "pds-pager__item pds-pager__item--ellipsis",
      role: "presentation",
      key: "ellipses"
    },
    "…"
  ));
};
Rs.propTypes = {
  index: t.number.isRequired,
  page: t.oneOfType([t.object, t.string]).isRequired,
  render: t.func
};
const G1 = (n) => {
  var s = S(n, []);
  const {
    buttonCallback: a,
    currentKey: c,
    setCurrentKey: r,
    currentPages: o,
    setCurrentPages: l,
    headingId: i,
    itemLength: d,
    pageDirection: u,
    pages: h
  } = ke(it), m = Gt(
    (f, C) => {
      a && (f.preventDefault(), a(C));
    },
    [a, c]
  ), [p] = R(h);
  return oe(() => {
    U1(
      h,
      o,
      l,
      c,
      d,
      u
    );
  }, [c]), /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "nav",
    y({
      className: "pds-pager",
      role: "navigation",
      "aria-labelledby": i
    }, s),
    /* @__PURE__ */ e.createElement("div", { id: i, className: "visually-hidden" }, "Pagination"),
    /* @__PURE__ */ e.createElement("ul", { className: "pds-pager__items" }, c > 0 ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("li", { className: "pds-pager__item pds-pager__item--first" }, /* @__PURE__ */ e.createElement(
      "a",
      {
        href: p[p.length - 1].link,
        onClick: (f) => {
          m(f, 0), r(0);
        }
      },
      "First"
    )), /* @__PURE__ */ e.createElement(Ye, { direction: "left" })) : null, o.map((f, C) => /* @__PURE__ */ e.createElement("li", { key: `list-item-${C}` }, /* @__PURE__ */ e.createElement(Rs, y({ index: C, page: f }, s)))), c < d - 1 ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(Ye, { direction: "right" }), /* @__PURE__ */ e.createElement("li", { className: "pds-pager__item pds-pager__item--last" }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, "Last Page"), /* @__PURE__ */ e.createElement(
      "a",
      {
        href: p[p.length - 1].link,
        onClick: (f) => {
          m(f, d - 1), r(d - 1);
        }
      },
      "Last"
    ))) : null)
  ));
}, K1 = (n) => {
  var s = S(n, []);
  const { currentKey: a, headingId: c, itemLength: r } = ke(it);
  return /* @__PURE__ */ e.createElement(
    "nav",
    y({
      className: "pds-pager pds-pager__mini",
      role: "navigation",
      "aria-labelledby": c
    }, s),
    /* @__PURE__ */ e.createElement("div", { id: c, className: "visually-hidden" }, "Pagination"),
    /* @__PURE__ */ e.createElement("ul", { className: "pds-pager__items" }, a > 0 ? /* @__PURE__ */ e.createElement(Ye, { arrowText: "Previous", direction: "left" }) : null, /* @__PURE__ */ e.createElement("li", { className: "pds-pager__items-mini" }, `${a + 1} of ${r}`), a < r - 1 ? /* @__PURE__ */ e.createElement(Ye, { arrowText: "Next", direction: "right" }) : null)
  );
}, Y1 = (s, n, ...a) => {
  switch (s) {
    case "basic":
      return /* @__PURE__ */ e.createElement(G1, y({}, a));
    case "mini":
      return /* @__PURE__ */ e.createElement(K1, y({ location: n }, a));
    case "advanced":
      return /* @__PURE__ */ e.createElement(Z1, y({}, a));
  }
}, X1 = (i) => {
  var d = i, {
    buttonCallback: s = null,
    headingId: n = "pager-heading",
    pages: a,
    paginationItemClickHandler: c = null,
    render: r = null,
    type: o = "basic"
  } = d, l = S(d, [
    "buttonCallback",
    "headingId",
    "pages",
    "paginationItemClickHandler",
    "render",
    "type"
  ]);
  return /* @__PURE__ */ e.createElement(
    Os,
    y({
      pages: a,
      render: r,
      paginationItemClickHandler: c,
      buttonCallback: s,
      headingId: n
    }, l),
    Y1(o)
  );
};
X1.propTypes = {
  /**
   * Optional function for the navigation buttons
   */
  buttonCallback: t.func,
  /**
   * String class to set ID if needed
   */
  headingId: t.string,
  /**
   * Array for pagination data
   */
  pages: t.arrayOf(t.shape({ href: t.string })).isRequired,
  /**
   * Optional function for additional actions on clicking pagination
   */
  paginationItemClickHandler: t.func,
  /**
   * Optional render function for pagination items
   */
  render: t.func,
  /**
   * Sets the type for pagination
   */
  type: t.oneOf(["basic", "mini", "advanced"]),
  /**
   * Additional class names
   */
  className: t.string
};
const Q1 = {
  included: "circleCheck",
  notIncluded: "xmark",
  addon: "circlePlusOutline"
}, is = (i) => {
  var d = i, {
    listItems: s,
    listLabel: n,
    moreLink: a,
    renderTypeLabels: c = !0,
    typeLabels: r = {
      included: "Included",
      notIncluded: "Not included",
      addon: "Add-on"
    },
    className: o
  } = d, l = S(d, [
    "listItems",
    "listLabel",
    "moreLink",
    "renderTypeLabels",
    "typeLabels",
    "className"
  ]);
  const u = "pds-comparison-list";
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [u, o != null ? o : ""].join(" ").trim().replace(/\s+/g, " ")
    }, l),
    n && /* @__PURE__ */ e.createElement("div", { className: `${u}__intro` }, n),
    s && /* @__PURE__ */ e.createElement("ul", { className: `${u}__list` }, s.map((h, m) => /* @__PURE__ */ e.createElement(
      "li",
      {
        key: m,
        className: `${u}__list-item ${u}__list-item--${h.type}`
      },
      /* @__PURE__ */ e.createElement(q, { iconName: Q1[h.type], iconSize: "md" }),
      c && /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, r[h.type], ":", " "),
      h.text
    ))),
    a && /* @__PURE__ */ e.createElement("div", { className: `${u}__more-link` }, a)
  );
}, J1 = (p) => {
  var f = p, {
    actionPrimary: s,
    actionSecondary: n,
    hasComparisonList: a = !0,
    onTierChange: c,
    planDescription: r,
    planName: o,
    planPricingData: l,
    statusBadgeLabels: i = {
      currentPlan: "Current plan",
      mostPopular: "Most popular"
    },
    selectLabel: d = "Select a plan size",
    statusBadgeType: u,
    className: h
  } = f, m = S(f, [
    "actionPrimary",
    "actionSecondary",
    "hasComparisonList",
    "onTierChange",
    "planDescription",
    "planName",
    "planPricingData",
    "statusBadgeLabels",
    "selectLabel",
    "statusBadgeType",
    "className"
  ]);
  const C = "pds-pricing-card", $ = `${C}-container`, g = a ? `${$}--with-list` : null, _ = u ? `${C}--${u}` : null, b = (H) => H.toLowerCase().replace(/\s/g, "-"), v = l && l.length > 1, [E, w] = R(
    b(l[0].label)
  ), [L, N] = R(
    s.label
  );
  let M = null, k = null;
  v || (M = /* @__PURE__ */ e.createElement("div", { className: `${C}__pricing-data` }, /* @__PURE__ */ e.createElement("div", { className: `${C}__price-line` }, /* @__PURE__ */ e.createElement("span", { className: `${C}__price` }, l[0].price), l[0].priceDetails && /* @__PURE__ */ e.createElement("span", { className: `${C}__details` }, l[0].priceDetails)), /* @__PURE__ */ e.createElement("div", { className: `${C}__savings-line` }, l[0].savingsBadgeLabel && /* @__PURE__ */ e.createElement(
    Ct,
    {
      className: `${C}__savings-badge`,
      color: "neutral",
      size: "sm",
      label: l[0].savingsBadgeLabel
    }
  ), l[0].savingsDetails && /* @__PURE__ */ e.createElement("span", { className: `${C}__savings-details` }, l[0].savingsDetails))), k = /* @__PURE__ */ e.createElement(
    is,
    {
      className: `${C}__list`,
      listLabel: l[0].listLabel,
      listItems: l[0].listItems,
      renderTypeLabels: !1
    }
  )), v && (M = l.map((H) => {
    const A = E === b(H.label) ? null : `${C}__pricing-data--hide`;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: [`${C}__pricing-data`, A].join(" ").trim().replace(/\s+/g, " "),
        id: `data-${b(H.label)}`,
        key: b(H.label)
      },
      /* @__PURE__ */ e.createElement("div", { className: `${C}__price-line` }, /* @__PURE__ */ e.createElement("span", { className: `${C}__price` }, H.price), H.priceDetails && /* @__PURE__ */ e.createElement("span", { className: `${C}__details` }, H.priceDetails)),
      /* @__PURE__ */ e.createElement("div", { className: `${C}__savings-line` }, H.savingsBadgeLabel && /* @__PURE__ */ e.createElement(
        Ct,
        {
          className: `${C}__savings-badge`,
          color: "neutral",
          size: "sm",
          label: H.savingsBadgeLabel
        }
      ), H.savingsDetails && /* @__PURE__ */ e.createElement("span", { className: `${C}__savings-details` }, H.savingsDetails))
    );
  }), k = l.map((H) => {
    const A = E === b(H.label) ? null : `${C}__list--hide`;
    return /* @__PURE__ */ e.createElement(
      is,
      {
        className: [`${C}__list`, A].join(" ").trim().replace(/\s+/g, " "),
        listLabel: H.listLabel,
        listItems: H.listItems,
        renderTypeLabels: !1,
        key: `${b(H.label)}-list`
      }
    );
  }));
  const x = (H) => {
    const I = l.find(
      (A) => b(A.label) === H
    );
    return I.customActionLabel ? I.customActionLabel : s.label;
  };
  let z = null;
  v && (z = /* @__PURE__ */ e.createElement(
    xt,
    {
      id: "plan-select",
      className: `${C}__select`,
      label: d,
      showLabel: !1,
      options: l.map((H) => ({
        value: b(H.label),
        label: H.label
      })),
      initialValue: b(l[0].label),
      onOptionSelect: (H) => {
        w(H.value), N(x(H.value)), c && c(H.value);
      }
    }
  ));
  let T = null;
  s && (s.type === "button" && (T = /* @__PURE__ */ e.createElement(
    Ke,
    {
      variant: s.variant,
      label: L,
      onClick: s.buttonAction,
      disabled: s.disabled
    }
  )), s.type === "link" && (T = /* @__PURE__ */ e.createElement(
    ct,
    {
      variant: s.variant,
      linkContent: /* @__PURE__ */ e.createElement("a", { href: s.linkUrl, target: s.linkTarget }, s.label)
    }
  )));
  let V = null;
  return n && (n.type === "button" && (V = /* @__PURE__ */ e.createElement(
    Ke,
    {
      variant: "secondary",
      label: n.label,
      onClick: n.buttonAction
    }
  )), n.type === "link" && (V = /* @__PURE__ */ e.createElement(
    ct,
    {
      variant: "secondary",
      linkContent: /* @__PURE__ */ e.createElement(
        "a",
        {
          href: n.linkUrl,
          target: n.linkTarget
        },
        n.label
      )
    }
  ))), /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [$, g, h].join(" ").trim().replace(/\s+/g, " ")
    }, m),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: [C, _].join(" ").trim().replace(/\s+/g, " ")
      },
      u && /* @__PURE__ */ e.createElement(
        Qt,
        {
          className: `${C}__status-badge`,
          type: u,
          label: i[u],
          color: u === "mostPopular" ? "reverse" : "neutral"
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: `${C}__main-content` }, o && /* @__PURE__ */ e.createElement("div", { className: `${C}__plan pds-overline-text` }, o), M, r && /* @__PURE__ */ e.createElement("div", { className: `${C}__description` }, r), z),
      /* @__PURE__ */ e.createElement("div", { className: `${C}__actions` }, s && T, s && n && V)
    ),
    a && k
  );
};
J1.propTypes = {
  /**
   * Primary card action
   */
  actionPrimary: t.shape({
    type: t.oneOf(["button", "link"]),
    variant: t.oneOf(["primary", "secondary"]),
    label: t.string,
    buttonAction: t.func,
    linkUrl: t.string,
    linkTarget: t.string,
    disabled: t.bool
  }),
  /**
   * Secondary card action
   */
  actionSecondary: t.shape({
    type: t.oneOf(["button", "link"]),
    label: t.string,
    buttonAction: t.func,
    linkUrl: t.string,
    linkTarget: t.string
  }),
  /**
   * Has comparison list. Will be rendered below the card if true.
   * Add corresponding `comparisonListId` to each planPricingData object.
   */
  hasComparisonList: t.bool,
  /**
   * Optional function to handle the change event of the select input. Only valid when multiple tiers of planPricingData are present.
   */
  onTierChange: t.func,
  /**
   * Plan description
   */
  planDescription: t.string,
  /**
   * Plan name
   */
  planName: t.string,
  /**
   * Plan pricing data. An array of objects.
   */
  planPricingData: t.arrayOf(
    t.shape({
      customActionLabel: t.string,
      label: t.string,
      price: t.string,
      priceDetails: t.string,
      savingsBadgeLabel: t.string,
      savingsDetails: t.string,
      listLabel: t.string,
      listItems: t.arrayOf(
        t.shape({
          text: t.string,
          type: t.oneOf(["included", "notIncluded", "addon"])
        })
      )
    })
  ),
  /**
   * Label for the plan size select dropdown. Available to screen readers only. Provide translation string if needed.
   */
  selectLabel: t.string,
  /**
   * Status badge labels. Provide translation strings if needed.
   */
  statusBadgeLabels: t.shape({
    currentPlan: t.string,
    mostPopular: t.string
  }),
  /**
   * Status badge type. Leave empty for no badge. Only one badge of each type may be used in a group of Pricing Cards.
   */
  statusBadgeType: t.oneOf(["currentPlan", "mostPopular"]),
  /**
   * Additional class names for the card item.
   */
  className: t.string,
  /**
   * Additional class names for the card container.
   */
  containerClassName: t.string
};
const e2 = (m) => {
  var p = m, {
    disabled: s = !1,
    id: n,
    initialSelection: a,
    inputWidth: c,
    label: r,
    message: o,
    onChange: l,
    options: i,
    required: d = !1,
    className: u
  } = p, h = S(p, [
    "disabled",
    "id",
    "initialSelection",
    "inputWidth",
    "label",
    "message",
    "onChange",
    "options",
    "required",
    "className"
  ]);
  const f = "pds-radio-group", [C, $] = R(a), g = (_) => {
    $(_.target.value), l && l(_.target.value);
  };
  return /* @__PURE__ */ e.createElement(
    Je,
    y({
      className: u,
      disabled: s,
      id: n,
      inputFieldType: "radio-group",
      inputWidth: c,
      isFieldset: !0,
      label: r,
      message: o,
      required: d
    }, h),
    /* @__PURE__ */ e.createElement("div", { className: [f].join(" ").trim().replace(/\s+/g, " ") }, /* @__PURE__ */ e.createElement("div", { className: `${f}__options` }, i.map((_, b) => /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${f}__option`,
        key: `${n}-option-${b}`
      },
      /* @__PURE__ */ e.createElement(
        "input",
        {
          type: "radio",
          id: `${n}-option-${b}`,
          name: n,
          value: _.value,
          required: d,
          disabled: s || _.disabled,
          onClick: g,
          defaultChecked: C === _.value
        }
      ),
      /* @__PURE__ */ e.createElement("label", { htmlFor: `${n}-option-${b}` }, _.label)
    ))))
  );
};
e2.propTypes = {
  /**
   * Is the radio group field disabled?
   */
  disabled: t.bool,
  /**
   * Unique ID for the radio group
   */
  id: t.string.isRequired,
  /**
   * Optional initial selected option value
   */
  initialSelection: t.string,
  /**
   * Width of the input field. Accepts a number in pixels. Leave blank for width: 100%.
   */
  inputWidth: t.number,
  /**
   * Label for the radio group
   */
  label: t.string.isRequired,
  /**
   * Message or description used to help clarify the usage of the radio group field.
   */
  message: t.string,
  /**
   * Callback function that will return the updated value from the instance when it changes.
   * Function should have the shape of: `(value) => { <do stuff here> } `.
   */
  onChange: t.func,
  /**
   * Array of radio options
   */
  options: t.arrayOf(
    t.shape({
      /**
       * Is the option disabled?
       */
      disabled: t.bool,
      /**
       * Option unique ID
       */
      id: t.string,
      /**
       * Option label
       */
      label: t.oneOfType([t.string, t.node]),
      /**
       * Option value
       */
      value: t.string
    })
  ),
  /**
   * Is the field required?
   */
  required: t.bool,
  /**
   * Additional class names
   */
  className: t.string
};
const t2 = (u) => {
  var h = u, {
    headingLevel: s = "h3",
    gotoText: n = "Go to",
    siteImage: a,
    siteLink: c,
    siteName: r,
    sitePlan: o,
    siteStatus: l,
    className: i
  } = h, d = S(h, [
    "headingLevel",
    "gotoText",
    "siteImage",
    "siteLink",
    "siteName",
    "sitePlan",
    "siteStatus",
    "className"
  ]);
  const m = "pds-site-card", p = `${s}`;
  let f = "";
  l === "Active" && (f = "success"), l === "Frozen" && (f = "frozen");
  const C = /* @__PURE__ */ e.createElement(
    Qt,
    {
      label: l,
      statusType: f,
      hasStatusIndicator: !0
    }
  ), $ = c.type;
  return /* @__PURE__ */ e.createElement(
    $,
    y(y({
      "aria-label": `${n} ${r} dashboard`,
      className: [m, i].join(" ").trim().replace(/\s+/g, " ")
    }, c.props), d),
    /* @__PURE__ */ e.createElement("div", { className: `${m}__image` }, /* @__PURE__ */ e.createElement("img", { src: a, alt: "" })),
    /* @__PURE__ */ e.createElement("div", { className: `${m}__content` }, /* @__PURE__ */ e.createElement("div", { className: `${m}__heading` }, /* @__PURE__ */ e.createElement(p, { className: `${m}__site-name pds-ts-l`, title: r }, r), C), /* @__PURE__ */ e.createElement("div", { className: `${m}__plan` }, o))
  );
};
t2.propTypes = {
  /**
   *  Heading level or `span`.
   */
  headingLevel: t.oneOf(["h2", "h3", "h4", "span"]),
  /**
   * Text for link to site dashboard. Provide a translation string if needed.
   */
  gotoText: t.string,
  /**
   * Thumbnail image of the site.
   */
  siteImage: t.string,
  /**
   * Link to the site's dashboard using the router of your choice. Example: `<Link to='/sites/123'></Link>` or `<a href='/sites/123'></a>`
   */
  siteLink: t.node.isRequired,
  /**
   * Name of the site.
   */
  siteName: t.string,
  /**
   * Plan level for the site.
   */
  sitePlan: t.string,
  /**
   * Status of the site.
   */
  siteStatus: t.oneOf(["Active", "Frozen"]),
  /**
   * Additional class names
   */
  className: t.string
};
const s2 = (o) => {
  var l = o, {
    containerWidth: s = "standard",
    children: n,
    legalLinks: a = [
      "privacy",
      "dataSubjectRequest",
      "cookiePolicy",
      "termsOfUse",
      "acceptableUse",
      "accessibilityStatement"
    ],
    className: c
  } = l, r = S(l, [
    "containerWidth",
    "children",
    "legalLinks",
    "className"
  ]);
  const i = "pds-site-footer", d = s && s !== "default" ? `pds-container pds-container--${s}` : "pds-container", u = (/* @__PURE__ */ new Date()).getFullYear(), h = a.includes("privacy"), m = a.includes("dataSubjectRequest"), p = a.includes("cookiePolicy"), f = a.includes("termsOfUse"), C = a.includes("acceptableUse"), $ = a.includes("accessibilityStatement");
  return /* @__PURE__ */ e.createElement(
    "footer",
    y({
      className: [i, c].join(" ").trim().replace(/\s+/g, " ")
    }, r),
    /* @__PURE__ */ e.createElement("div", { className: d }, n && /* @__PURE__ */ e.createElement("div", { className: `${i}__content` }, n), /* @__PURE__ */ e.createElement("div", { className: `${i}__legal` }, /* @__PURE__ */ e.createElement("span", { className: `${i}__copyright` }, "© ", u, " Pantheon Systems, Inc."), h && /* @__PURE__ */ e.createElement("a", { href: "https://pantheon.io/privacy" }, "Privacy Policy"), m && /* @__PURE__ */ e.createElement("a", { href: "http://pantheon.io/data-subject-request" }, "Data Subject Request"), p && /* @__PURE__ */ e.createElement("a", { href: "https://pantheon.io/pantheon-cookies?_gl=1*12uc311*_gcl_au*NjU2MzA3MDUzLjE2ODk3ODU1NTI." }, "Cookie Policy"), f && /* @__PURE__ */ e.createElement("a", { href: "https://pantheon.io/terms-of-service" }, "Terms of Use"), C && /* @__PURE__ */ e.createElement("a", { href: "https://pantheon.io/acceptable-use-policy" }, "Acceptable Use Policy"), $ && /* @__PURE__ */ e.createElement("a", { href: "https://pantheon.io/accessibility-statement" }, "Accessibility Statement")))
  );
};
s2.propTypes = {
  /**
   * PDS container width.
   */
  containerWidth: ws,
  /**
   * Footer content.
   */
  children: t.node,
  /**
   * Legal policy links.
   */
  legalLinks: t.arrayOf(
    t.oneOf([
      "privacy",
      "dataSubjectRequest",
      "cookiePolicy",
      "termsOfUse",
      "acceptableUse",
      "accessibilityStatement"
    ])
  ),
  /**
   * Additional class names
   */
  className: t.string
};
const n2 = (i) => {
  var d = i, {
    actionItems: s,
    disabled: n,
    moreActionsLabel: a = "More actions",
    size: c = "md",
    variant: r = "primary",
    className: o
  } = d, l = S(d, [
    "actionItems",
    "disabled",
    "moreActionsLabel",
    "size",
    "variant",
    "className"
  ]);
  const u = "pds-split-button", h = `${u}--${r}`, m = s[0], p = s.slice(1);
  let f = null;
  return m.isLink === !0 ? f = /* @__PURE__ */ e.createElement(
    ct,
    {
      className: `${u}__primary-action`,
      size: c,
      variant: r,
      displayType: "label-only",
      disabled: n,
      linkContent: m.linkContent
    }
  ) : f = /* @__PURE__ */ e.createElement(
    Ke,
    {
      className: `${u}__primary-action`,
      label: m.label,
      size: c,
      variant: r,
      disabled: n,
      onClick: () => m.callback(m)
    }
  ), /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: [u, h, o].join(" ").trim().replace(/\s+/g, " ")
    }, l),
    f,
    /* @__PURE__ */ e.createElement(
      Is,
      {
        className: `${u}__menu-button`,
        label: a,
        size: c,
        variant: r,
        menuItems: p,
        displayType: "icon-end",
        isSplitButton: !0,
        disabled: n
      }
    )
  );
};
n2.propTypes = {
  /**
   * Array of menu items
   */
  actionItems: t.arrayOf(
    t.oneOfType([Ns, ks])
  ),
  /**
   * Is the button disabled?
   */
  disabled: t.bool,
  /**
   * Label for the buttons additional actions menu.
   */
  moreActionsLabel: t.string,
  /**
   * Which size of button to render
   */
  size: t.oneOf(["sm", "md"]),
  /**
   * Which variant of button to render
   */
  variant: t.oneOf(["primary", "secondary"]),
  /**
   * Additional class names
   */
  className: t.string
};
const a2 = (c) => {
  var r = c, { listItems: s, className: n } = r, a = S(r, ["listItems", "className"]);
  const o = "pds-tile-list", l = "pds-tile-list--stats", i = ({ item: d }) => {
    const { imageSrc: u, stat: h, description: m } = d;
    return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: `${o}__item` }, u && /* @__PURE__ */ e.createElement("div", { className: `${o}__image` }, /* @__PURE__ */ e.createElement("img", { src: u, alt: "" })), h && /* @__PURE__ */ e.createElement("dt", { className: `${o}__stat` }, h), m && /* @__PURE__ */ e.createElement("dd", { className: `${o}__description` }, m)), /* @__PURE__ */ e.createElement("div", { className: "pds-tile__separator" }));
  };
  return /* @__PURE__ */ e.createElement(
    "dl",
    y({
      className: [o, l, n].join(" ").trim()
    }, a),
    s.map((d, u) => /* @__PURE__ */ e.createElement(i, { key: u, item: d }))
  );
};
a2.propTypes = {
  /**
   * Array of list Items
   */
  listItems: t.arrayOf(
    t.shape({
      /**
       * Image source
       */
      imageSrc: t.node,
      /**
       * Statistic value
       */
      stat: t.string,
      /**
       * Statistic description
       */
      description: t.string
    })
  ),
  /**
   * Additional class names
   */
  className: t.string
};
const l2 = 3.815, c2 = 4.678, r2 = 5.96, o2 = (u) => {
  var h = u, {
    id: s,
    innerLabel: n,
    label: a,
    percentage: c,
    showLabel: r = !1,
    showPercentage: o = !1,
    size: l = "md",
    className: i
  } = h, d = S(h, [
    "id",
    "innerLabel",
    "label",
    "percentage",
    "showLabel",
    "showPercentage",
    "size",
    "className"
  ]);
  const m = s || je(), p = "pds-progress-ring", f = r ? `${p}__label` : "visually-hidden", C = `${p}__loading-text ${p}__loading-text--${l}`, $ = (N) => N * 16;
  let g = $(c2), _ = 7;
  l === "sm" && (g = $(l2), _ = _ / 1.25), l === "lg" && (g = $(r2), _ = _ * 1.25);
  const b = g / 2 - _ / 2, v = `${b / 100}rem`, E = 2 * Math.PI * b, w = E - E * c / 100;
  let L;
  return n ? L = n : o ? L = `${c}%` : L = "", /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [p, i].join(" ").trim().replace(/\s+/g, " "),
      style: {
        "--ring-stroke-dashoffset": w,
        "--ring-stroke-dasharray": E
      }
    }, d),
    /* @__PURE__ */ e.createElement("div", { id: m, className: f }, a),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${p}__ring`,
        role: "progressbar",
        "aria-labelledby": m,
        "aria-valuenow": c
      },
      /* @__PURE__ */ e.createElement(
        "svg",
        {
          height: g,
          width: g,
          viewBox: `0 0 ${g} ${g}`
        },
        /* @__PURE__ */ e.createElement(
          "circle",
          {
            className: `${p}__track`,
            cx: g / 2,
            cy: g / 2,
            r: b,
            strokeWidth: _
          }
        ),
        /* @__PURE__ */ e.createElement(
          "circle",
          {
            className: `${p}__progress`,
            cx: g / 2,
            cy: g / 2,
            r: b,
            strokeWidth: _,
            strokeDasharray: E,
            strokeDashoffset: w,
            transform: `rotate(-90 ${g / 2} ${g / 2})`
          }
        ),
        /* @__PURE__ */ e.createElement(
          "text",
          {
            className: C,
            fill: "var(--pds-color-text-default)",
            x: "50%",
            y: "50%",
            textAnchor: "middle",
            dy: v
          },
          L
        )
      )
    )
  );
}, i2 = (r) => {
  var o = r, {
    steps: s,
    translatableLabels: n = {
      step: "Step",
      completed: "completed",
      hasError: "has an error",
      next: "Next"
    },
    className: a
  } = o, c = S(o, [
    "steps",
    "translatableLabels",
    "className"
  ]);
  const l = "pds-stepper", i = "pds-stepper-mobile", d = se(), [u] = kt(d), h = u.width, m = getComputedStyle(document.body).getPropertyValue("--pds-stepper-step-content-width").replace("rem", "") * 16, p = -40, f = 2, C = 5, $ = s.length, g = s.findLastIndex((v) => v.isCurrent), _ = s.map((v, E) => {
    const w = E + 1, L = E === g, N = E < g, M = v.hasError && L, x = (h - $ * m) / ($ + ($ - 2)), z = m + x * 2, T = m + x, V = x + p * -1, H = E === 0, I = E === $ - 1;
    let A = z;
    (H || I) && (A = T);
    const j = `${l}__step`, B = [j];
    L && B.push(`${j}--current`), N && B.push(`${j}--complete`), M && B.push(`${j}--error`);
    let W = `${n.step} ${w}`;
    N && (W = `${n.step} ${w}, ${n.completed}`), M && (W = `${n.step} ${w}, ${n.hasError}`);
    const Z = N ? /* @__PURE__ */ e.createElement("div", { "aria-hidden": "true", className: `${l}__step-indicator` }, /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: "check",
        iconSize: "md",
        className: `${l}__step-complete-icon`
      }
    )) : /* @__PURE__ */ e.createElement("div", { "aria-hidden": "true", className: `${l}__step-indicator` }), K = /* @__PURE__ */ e.createElement("div", { className: `${l}__step-label` }, v.label);
    let O = /* @__PURE__ */ e.createElement("div", { className: `${l}__step-content` }, K, Z);
    if (N && v.callback) {
      const D = (F) => {
        v.callback(v), F.preventDefault();
      };
      O = /* @__PURE__ */ e.createElement(
        "button",
        {
          className: `${l}__step-content`,
          onClick: D
        },
        K,
        Z
      );
    }
    return /* @__PURE__ */ e.createElement(
      "li",
      {
        key: v.id,
        id: v.id,
        "aria-label": W,
        "aria-posinset": w,
        "aria-setsize": $,
        "aria-current": L ? "step" : null,
        className: B.join(" ").trim().replace(/\s+/g, " "),
        style: { width: A }
      },
      !H && /* @__PURE__ */ e.createElement(
        "span",
        {
          className: `${l}__connector ${l}__connector--before`,
          style: {
            width: V,
            marginRight: p
          }
        }
      ),
      O,
      !I && /* @__PURE__ */ e.createElement(
        "span",
        {
          className: `${l}__connector ${l}__connector--after`,
          style: { width: V, marginLeft: p }
        }
      )
    );
  }), b = s.map((v, E) => {
    const w = E + 1, L = E === g, N = E === $ - 1, M = v.hasError && L, k = s[g + 1] ? s[g + 1].label : null;
    if (L) {
      const x = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, n.step, " "), w, " of ", $), z = w / $ * 100, T = M ? {
        "--pds-color-progress-partial": "var(--pds-color-semantic-critical-foreground)"
      } : {
        "--pds-color-progress-partial": "var(--pds-color-stepper-completed)"
      }, V = /* @__PURE__ */ e.createElement("div", { className: "visually-hidden" }, n.step, " ", w, ", ", n.hasError);
      return /* @__PURE__ */ e.createElement(
        "div",
        {
          key: v.id,
          id: `${v.id}--mobile`,
          className: `${i}__step`
        },
        /* @__PURE__ */ e.createElement("div", { className: `${i}__progress-indicator` }, /* @__PURE__ */ e.createElement(
          o2,
          {
            label: "Step progress",
            size: "sm",
            percentage: z,
            innerLabel: x,
            style: T
          }
        )),
        /* @__PURE__ */ e.createElement("div", { className: `${i}__step-text` }, /* @__PURE__ */ e.createElement("div", { className: `${i}__step-label` }, M && /* @__PURE__ */ e.createElement(e.Fragment, null, V, /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: "diamondExclamation",
            iconSize: "md",
            className: `${i}__error-icon`
          }
        )), v.label), !N && /* @__PURE__ */ e.createElement("div", { className: `${i}__next-step` }, `${n.next}: ${k}`))
      );
    }
  });
  if ($ >= f && $ <= C)
    return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: [l, a].join(" ").trim().replace(/\s+/g, " "),
        "data-steps": $
      }, c),
      /* @__PURE__ */ e.createElement("ol", { className: `${l}__steps`, ref: d }, _)
    ), /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: [i, a].join(" ").trim().replace(/\s+/g, " "),
        "data-steps": $
      }, c),
      /* @__PURE__ */ e.createElement("div", { className: `${i}__steps` }, b)
    ));
};
i2.propTypes = {
  /**
   * An array of step objects
   */
  steps: t.arrayOf(
    t.shape({
      /**
       * Callback function to return to a previously completed step.
       */
      callback: t.func,
      /**
       * If the step has an error.
       */
      hasError: t.bool,
      /**
       * Id for the step.
       */
      id: t.string,
      /**
       * If the step is the current active step.
       */
      isCurrent: t.bool,
      /**
       * The label for the step.
       */
      label: t.string.isRequired
    })
  ),
  /**
   * Translatable strings for visually-hidden text.
   */
  translatableLabels: t.shape({
    step: t.string,
    completed: t.string,
    hasError: t.string,
    next: t.string
  }),
  /**
   * Additional class names
   */
  className: t.string
};
const d2 = (r) => {
  var o = r, { headers: s, rowData: n, className: a } = o, c = S(o, ["headers", "rowData", "className"]);
  const [l] = R(s), [i, d] = R(n), [u, h] = R({ order: "asc", key: "" }), m = (g) => {
    d(i.sort((_, b) => _[g].localeCompare(b[g]))), h({ order: "desc", key: g });
  }, p = (g) => {
    d(i.sort((_, b) => b[g].localeCompare(_[g]))), h({ order: "asc", key: g });
  }, f = (g, _) => {
    h(ge(y({}, u), { key: _ })), u.order === "asc" ? m(_) : p(_);
  }, C = (g, _) => /* @__PURE__ */ e.createElement("tr", { id: _, key: `table-row-${_}` }, g.map((b, v) => /* @__PURE__ */ e.createElement("td", { key: `${_}-cell-${v}` }, /* @__PURE__ */ e.createElement("span", null, b)))), $ = "pds-table";
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "table",
    y({
      className: [$, a].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, l.map((g, _) => /* @__PURE__ */ e.createElement("th", { key: `header-${_}` }, g.sortable ? /* @__PURE__ */ e.createElement("div", { className: `${$}__sort-wrapper` }, /* @__PURE__ */ e.createElement(
      "span",
      {
        className: `${$}__sort-header`,
        onClick: (b) => f(b, _)
      },
      g.title
    ), /* @__PURE__ */ e.createElement(
      "button",
      {
        className: `${$}__sort-button`,
        title: `Sort by ${g.title}`,
        onClick: (b) => f(b, _)
      },
      /* @__PURE__ */ e.createElement(
        "span",
        {
          className: `${$}__sort-button-top ${_ != u.key && u.key !== "" ? "pds-table__sort-innactive" : u.key == _ ? u.order : "asc"}`
        },
        /* @__PURE__ */ e.createElement(q, { iconName: "caretUp", iconSize: "sm" })
      ),
      /* @__PURE__ */ e.createElement(
        "span",
        {
          className: `${$}__sort-button-bottom ${u.key == _ ? u.order : "asc"}`
        },
        /* @__PURE__ */ e.createElement(q, { iconName: "caretDown", iconSize: "sm" })
      )
    )) : /* @__PURE__ */ e.createElement("span", null, g.title))))),
    /* @__PURE__ */ e.createElement("tbody", null, i.map((g, _) => C(g, _)))
  ));
};
d2.propTypes = {
  headers: t.arrayOf(t.object),
  rowData: t.arrayOf(t.node),
  /**
   * Additional class names
   */
  className: t.string
};
const m2 = (u) => {
  var h = u, {
    appendIds: s = !1,
    ariaLabel: n = "Table of contents",
    headingLevel: a = "h2",
    headingText: c = "Table of contents",
    ignoreClass: r = "pds-toc-ignore",
    showHeading: o = !1,
    sourceID: l = "pds-toc-source",
    className: i
  } = h, d = S(h, [
    "appendIds",
    "ariaLabel",
    "headingLevel",
    "headingText",
    "ignoreClass",
    "showHeading",
    "sourceID",
    "className"
  ]);
  const m = "pds-toc", p = `${a}`, f = [
    " ",
    "/",
    ".",
    ":",
    ";",
    ",",
    "?",
    "!",
    "@",
    "$",
    "%",
    "&",
    "*",
    "+",
    "=",
    "|",
    "~"
  ], C = `#${l} h2:not(.${r}), h3:not(.${r})`, $ = () => {
    const [k, x] = R([]);
    return oe(() => {
      const z = Array.from(
        document.querySelectorAll(C)
      );
      z.map((V) => {
        f.forEach((H) => {
          V.id.includes(H) && (V.id = V.id.replaceAll(H, "-"));
        });
      }), z.map((V) => {
        const H = `item-${je()}`;
        V.id || (V.id = H);
      });
      const T = g(z);
      x(T);
    }, []), { nestedHeadings: k };
  }, g = (k) => {
    const x = [];
    return k.forEach((z) => {
      const { innerText: T, id: V } = z;
      z.nodeName === "H2" ? x.push({ id: V, title: T, items: [] }) : z.nodeName === "H3" && x.length > 0 && x[x.length - 1].items.push({
        id: V,
        title: T
      });
    }), x;
  }, { nestedHeadings: _ } = $(), [b, v] = R();
  ((k) => {
    const x = se({});
    oe(() => {
      const z = (H) => {
        x.current = H.reduce((j, B) => (j[B.target.id] = B, j), x.current);
        const I = [];
        Object.keys(x.current).forEach((j) => {
          const B = x.current[j];
          B.isIntersecting && I.push(B);
        });
        const A = (j) => V.findIndex((B) => B.id === j);
        if (I.length === 1)
          k(I[0].target.id);
        else if (I.length > 1) {
          const j = I.sort(
            (B, W) => A(B.target.id) > A(W.target.id)
          );
          k(j[0].target.id);
        }
      }, T = new IntersectionObserver(z, {
        rootMargin: "0px 0px -20% 0px"
      }), V = Array.from(
        document.querySelectorAll(C)
      );
      return V.forEach((H) => T.observe(H)), () => T.disconnect();
    }, [k]);
  })(v);
  const w = (k) => {
    typeof window != "undefined" && window.location.hash !== `#${k}` && window.history.pushState({}, "", `#${k}`);
  }, L = (k) => {
    document.querySelector(`#${k}`).scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, N = (k, x) => {
    k.preventDefault(), s && w(x), L(x);
  }, M = ({ headings: k }) => /* @__PURE__ */ e.createElement("ul", { className: `${m}__list ${m}__list--top-level` }, k.map((x) => /* @__PURE__ */ e.createElement("li", { key: x.id, className: `${m}__list-item` }, /* @__PURE__ */ e.createElement(
    "a",
    {
      className: x.id === b ? `${m}__link ${m}__link--active` : `${m}__link`,
      href: `#${x.id}`,
      onClick: (z) => {
        N(z, x.id);
      }
    },
    x.title
  ), x.items.length > 0 && /* @__PURE__ */ e.createElement(
    "ul",
    {
      className: `${m}__list ${m}__list--second-level`
    },
    x.items.map((z) => /* @__PURE__ */ e.createElement("li", { key: z.id, className: `${m}__list-item` }, /* @__PURE__ */ e.createElement(
      "a",
      {
        className: z.id === b ? `${m}__link ${m}__link--active` : `${m}__link`,
        href: `#${z.id}`,
        onClick: (T) => {
          N(T, z.id);
        }
      },
      z.title
    )))
  ))));
  return M.propTypes = {
    headings: t.array
  }, /* @__PURE__ */ e.createElement(
    "nav",
    y({
      "aria-label": n,
      className: [m, i].join(" ").trim().replace(/\s+/g, " ")
    }, d),
    c && /* @__PURE__ */ e.createElement(
      p,
      {
        className: `${m}__heading ${o ? null : "visually-hidden"}`
      },
      c
    ),
    /* @__PURE__ */ e.createElement(M, { headings: _, activeID: b })
  );
};
m2.propTypes = {
  /**
   * Whether to append the id to the URL when a link is clicked.
   */
  appendIds: t.bool,
  /**
   * aria-label for the TOC.
   */
  ariaLabel: t.string,
  /**
   * Whether the heading should be visible or not. If not visible it will still be presented to screen readers.
   */
  showHeading: t.bool,
  /**
   * Heading level for TOC heading.
   */
  headingLevel: t.oneOf(["h2", "h3"]),
  /**
   * Text for the TOC heading.
   */
  headingText: t.string,
  /**
   * Class name for designating headers to ignore.
   */
  ignoreClass: t.string,
  /**
   * ID name of content region to be indexed.
   */
  sourceID: t.string,
  /**
   * Additional class names.
   */
  className: t.string
};
const u2 = (g) => {
  var _ = g, {
    counterFunction: s = () => {
    },
    disabled: n = !1,
    id: a,
    initialValue: c = "",
    inputWidth: r,
    isResizable: o = !0,
    label: l,
    message: i,
    onChange: d,
    placeholder: u,
    readonly: h = !1,
    required: m = !1,
    rows: p = 5,
    validationFunction: f,
    className: C
  } = _, $ = S(_, [
    "counterFunction",
    "disabled",
    "id",
    "initialValue",
    "inputWidth",
    "isResizable",
    "label",
    "message",
    "onChange",
    "placeholder",
    "readonly",
    "required",
    "rows",
    "validationFunction",
    "className"
  ]);
  const [b, v] = R(c), [E, w] = R(s("")), [L, N] = R(), [M, k] = R(null), x = se(null), z = "pds-textarea", T = o ? "pds-is-resizable" : null;
  oe(() => {
    c && s && w(s(c));
  }, []);
  const V = () => {
    N(""), k(null);
  }, H = (j) => {
    v(j.target.value), V(), s && w(s(j.target.value)), d && d(b);
  }, I = (j) => {
    if (f) {
      const B = f(j.target.value) || {};
      V(), B.error && k("error"), B.success && k("success"), N(B.message);
    }
    d && d(b);
  }, A = L || i;
  return /* @__PURE__ */ e.createElement(
    Je,
    y({
      className: C,
      disabled: n,
      id: a,
      inputFieldType: "textarea",
      inputWidth: r,
      label: l,
      message: A,
      readonly: h,
      required: m,
      validationState: M
    }, $),
    E && /* @__PURE__ */ e.createElement("div", { className: `pds-input__counter ${z}__counter` }, E),
    /* @__PURE__ */ e.createElement(
      "textarea",
      {
        className: [z, T].join(" ").trim().replace(/\s+/g, " "),
        id: a,
        name: a,
        placeholder: u,
        required: m,
        readOnly: h,
        disabled: n,
        value: b,
        rows: p,
        onChange: H,
        onBlur: I,
        ref: x,
        "aria-invalid": M === "error",
        "aria-describedby": A ? `${a}__message` : null
      }
    )
  );
};
u2.propTypes = {
  /**
   * If a counter is desired provide a function that accepts the input's value and will return a string.
   */
  counterFunction: t.func,
  /**
   * Is the field disabled?
   */
  disabled: t.bool,
  /**
   * ID of the textarea.
   */
  id: t.string.isRequired,
  /**
   * Initial value for the input field.
   */
  initialValue: t.string,
  /**
   * Should the textarea be resizable by the user?
   */
  isResizable: t.bool,
  /**
   * Width of the input field. Accepts a number in pixels. Leave blank for width: 100%.
   */
  inputWidth: t.number,
  /**
   * Text label associated with the input field.
   */
  label: t.string.isRequired,
  /**
   * Message or description used to help clarify the usage of the input.
   */
  message: t.string,
  /**
   * Function to help lift the state and retrieve the input's value.
   * Should accept one argument, the input's value
   */
  onChange: t.func,
  /**
   * Optional placeholder text to display when the input field is empty.
   */
  placeholder: t.string,
  /**
   * Is the field read-only?
   */
  readonly: t.bool,
  /**
   * Is the field required?
   */
  required: t.bool,
  /**
   * Rows value to be given to the textarea type.
   */
  rows: t.number,
  /**
   * If custom field validation is desired, provide a function that accepts the input's value and will return one of the response objects below.
   *
   * Error:<br/>
   * ```
   * {
   *   error: true,
   *   message: [string],
   * }
   * ```
   *
   * Success:<br/>
   * ```
   * {
   *   success: true,
   *   message: [string]
   * }
   * ```
   */
  validationFunction: t.func,
  /**
   * Additional class names
   */
  className: t.string
};
const p2 = (r) => {
  var o = r, {
    linkContent: s,
    size: n = "md",
    className: a
  } = o, c = S(o, [
    "linkContent",
    "size",
    "className"
  ]);
  const l = "pds-cta-link", i = n != "md" ? `${l}--${n}` : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [l, i, a != null ? a : ""].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    s,
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: "arrowRight",
        iconSize: n === "sm" ? "md" : "lg",
        className: `${l}__icon`
      }
    )
  );
}, Ds = (d) => {
  var u = d, {
    displayType: s = "border",
    headingLevel: n = "span",
    headingText: a,
    imageSrc: c,
    linkContent: r,
    summary: o,
    className: l
  } = u, i = S(u, [
    "displayType",
    "headingLevel",
    "headingText",
    "imageSrc",
    "linkContent",
    "summary",
    "className"
  ]);
  const h = "pds-tile", m = `${h}--${s}`, p = `${n}`;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [h, m, l].join(" ").trim().replace(/\s+/g, " ")
    }, i),
    c && /* @__PURE__ */ e.createElement("div", { className: `${h}__image` }, /* @__PURE__ */ e.createElement("img", { src: c, alt: "" })),
    a && /* @__PURE__ */ e.createElement(p, { className: `${h}__heading pds-ts-xl` }, a),
    o && /* @__PURE__ */ e.createElement("div", { className: `${h}__summary` }, /* @__PURE__ */ e.createElement("p", null, o)),
    r && (s == "border" || s == "clean") && /* @__PURE__ */ e.createElement(
      p2,
      {
        linkContent: r,
        size: "sm",
        className: `${h}__cta`
      }
    )
  ), /* @__PURE__ */ e.createElement("span", { className: `${h}__separator` }));
};
Ds.propTypes = {
  /**
   * Visual display type.
   */
  displayType: t.oneOf(["border", "clean", "clean-static"]),
  /**
   *  Heading level or `span`.
   */
  headingLevel: t.oneOf(["h2", "h3", "h4", "span"]),
  /**
   * Tile heading
   */
  headingText: t.string,
  /**
   * Tile image source.
   */
  imageSrc: t.node,
  /**
   * A link element using the router of your choice.
   */
  linkContent: t.node,
  /**
   * Summary paragraph.
   */
  summary: t.string,
  /**
   * Additional class names.
   */
  className: t.string
};
const h2 = (o) => {
  var l = o, {
    displayType: s = "border",
    headingLevel: n = "h2",
    tiles: a,
    className: c
  } = l, r = S(l, [
    "displayType",
    "headingLevel",
    "tiles",
    "className"
  ]);
  const i = "pds-tile-grid", d = `${i}--${s}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [i, d, c].join(" ").trim()
    }, r),
    a.map((u, h) => /* @__PURE__ */ e.createElement(
      Ds,
      {
        key: h,
        displayType: s,
        headingLevel: n,
        headingText: u.headingText,
        imageSrc: u.imageSrc,
        linkContent: u.linkContent,
        summary: u.summary,
        className: u.className
      }
    ))
  );
};
h2.propTypes = {
  /**
   * Visual display type
   */
  displayType: t.oneOf(["border", "clean", "clean-static"]),
  /**
   *  Heading level or span
   */
  headingLevel: t.oneOf(["h2", "h3", "h4", "span"]),
  /**
   * Array of Tiles
   */
  tiles: t.arrayOf(
    t.shape({
      /**
       * Tile heading
       */
      headingText: t.string,
      /**
       * Tile image source.
       */
      imageSrc: t.node,
      /**
       * A link element using the router of your choice.
       */
      linkContent: t.node,
      /**
       * Summary paragraph.
       */
      summary: t.string,
      /**
       * Additional class names.
       */
      className: t.string
    })
  ),
  /**
   * Additional class names
   */
  className: t.string
};
const Pt = {
  info: "circleInfo",
  success: "check",
  warning: "triangleExclamation",
  critical: "diamondExclamation"
}, As = ({
  children: s,
  id: n,
  type: a = "info",
  typeLabels: c = {
    info: "Information",
    success: "Success",
    warning: "Warning",
    critical: "Critical",
    working: "Working..."
  },
  className: r
}) => {
  const o = "pds-toast", l = {
    info: `${o}--info`,
    success: `${o}--success`,
    warning: `${o}--warning`,
    critical: `${o}--critical`,
    working: `${o}--working`,
    dismissing: `${o}--dismissing`,
    dismissed: `${o}--dismissed`,
    transition: `${o}--transition`
  }, i = `${c[a]} `;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [o, l[a], r].join(" ").trim().replace(/\s+/g, " "),
      id: n
    },
    /* @__PURE__ */ e.createElement("div", { className: `${o}__icon-container` }, a === "working" ? /* @__PURE__ */ e.createElement(zt, { colorType: "monochromatic", size: "lg" }) : /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: `${a}` in Pt ? Pt[a] : Pt.info,
        className: `${o}__icon ${o}__icon--${a}`
      }
    )),
    /* @__PURE__ */ e.createElement("div", { className: `${o}__message` }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, i), s)
  );
};
As.propTypes = {
  /**
   * Toast message content.
   */
  children: t.node,
  /**
   * ID of individual toast.
   */
  id: t.string,
  /**
   * Type of toast to show.
   */
  type: t.oneOf(["info", "success", "warning", "critical"]),
  /**
   * Toast type labels. Provide translation strings if needed.
   */
  typeLabels: t.shape({
    info: t.string,
    success: t.string,
    warning: t.string,
    critical: t.string,
    working: t.string
  }),
  /**
   * Additional class names
   */
  className: t.string
};
const g2 = ({
  autoCloseDuration: s = 5e3,
  limit: n = 5,
  position: a = "bottom-right",
  className: c
}) => {
  const o = ["pds-toaster", c].join(" ").trim().replace(/\s+/g, " ");
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    c1,
    {
      className: o,
      autoClose: s,
      draggable: !1,
      icon: !1,
      limit: n,
      newestOnTop: !0,
      position: a,
      role: "status",
      transition: r1
    }
  ));
};
g2.propTypes = {
  /**
   * Duration in milliseconds before the toast will auto-close.
   */
  autoCloseDuration: t.number,
  /**
   * Maximum number of toasts that can be displayed at once.
   */
  limit: t.number,
  /**
   * Location toast objects will show in the UI.
   */
  position: t.oneOf(["bottom-right", "top-right"]),
  /**
   * Additional class names
   */
  className: t.string
};
const f2 = (i) => {
  var d = i, {
    disabled: s = !1,
    id: n,
    initialSelection: a,
    label: c,
    onChange: r,
    options: o
  } = d, l = S(d, [
    "disabled",
    "id",
    "initialSelection",
    "label",
    "onChange",
    "options"
  ]);
  const u = "pds-toggle-button", h = "pds-is-disabled", m = se([u]), [p, f] = R(a), C = (g) => {
    f(g.target.value), r && r(g.target.value);
  };
  if ((() => {
    m.current = m.current.filter((g) => g !== h);
  })(), s && m.current.push(h), o.length === 2)
    return /* @__PURE__ */ e.createElement(
      "fieldset",
      y({
        className: m.current.join(" ").trim(),
        id: n
      }, l),
      /* @__PURE__ */ e.createElement("legend", { className: "visually-hidden" }, c),
      /* @__PURE__ */ e.createElement("div", { className: `${u}__options` }, o.map((g, _) => /* @__PURE__ */ e.createElement(
        "div",
        {
          className: `${u}__option`,
          key: `${n}-option-${_}`
        },
        /* @__PURE__ */ e.createElement(
          "input",
          {
            className: "visually-hidden",
            type: "radio",
            id: `${n}-option-${_}`,
            name: n,
            value: g.value,
            disabled: s,
            onClick: C,
            defaultChecked: p === g.value
          }
        ),
        /* @__PURE__ */ e.createElement("label", { htmlFor: `${n}-option-${_}` }, g.iconName && /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: g.iconName,
            iconSize: "sm",
            className: `${u}__icon`
          }
        ), /* @__PURE__ */ e.createElement("span", { className: `${u}__label-text` }, g.label))
      )))
    );
};
f2.propTypes = {
  /**
   * Is the ToggleButton disabled?
   */
  disabled: t.bool,
  /**
   * Unique ID for the ToggleButton
   */
  id: t.string.isRequired,
  /**
   * Optional initial selected option value
   */
  initialSelection: t.string,
  /**
   * Label for the ToggleButton — visually hidden, used for screen readers only.
   */
  label: t.string.isRequired,
  /**
   * Callback function that will return the updated value from the instance when it changes.
   * Function should have the shape of: `(value) => { <do stuff here> } `.
   */
  onChange: t.func,
  /**
   * Array of button options — must be exactly two options.
   */
  options: t.arrayOf(
    t.shape({
      /**
       * Option label
       */
      label: t.string.isRequired,
      /**
       * Option value
       */
      value: t.string.isRequired,
      /**
       * Option icon
       */
      iconName: t.string
    })
  ),
  /**
   * Additional class names
   */
  className: t.string
};
const b2 = (f) => {
  var C = f, {
    disabled: s = !1,
    id: n,
    inputWidth: a,
    label: c,
    message: r,
    onChange: o,
    required: l = !1,
    showLabel: i = !0,
    showStatusLabel: d = !0,
    statusOnLabel: u = "On",
    statusOffLabel: h = "Off",
    className: m
  } = C, p = S(C, [
    "disabled",
    "id",
    "inputWidth",
    "label",
    "message",
    "onChange",
    "required",
    "showLabel",
    "showStatusLabel",
    "statusOnLabel",
    "statusOffLabel",
    "className"
  ]);
  const $ = "pds-toggle-switch", [g, _] = R(!1), b = (w) => {
    _(!g), o && o(w.target);
  };
  let v = g === !0 ? u : h, E;
  return d ? E = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, v), /* @__PURE__ */ e.createElement(
    "span",
    {
      className: "pds-toggle__label pds-toggle__label--on",
      "aria-hidden": "true"
    },
    u
  ), /* @__PURE__ */ e.createElement(
    "span",
    {
      className: "pds-toggle__label pds-toggle__label--off",
      "aria-hidden": "true"
    },
    h
  )) : E = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, v), /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: "check",
      iconSize: "sm",
      className: `${$}__on-icon`
    }
  ), /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: "xmark",
      iconSize: "sm",
      className: `${$}__off-icon`
    }
  )), /* @__PURE__ */ e.createElement(
    Je,
    y({
      className: m,
      disabled: s,
      id: n,
      inputWidth: a,
      inputFieldType: "toggle-switch",
      label: c,
      message: r,
      messagePosition: "before",
      showLabel: i,
      required: l
    }, p),
    /* @__PURE__ */ e.createElement("div", { className: [$].join(" ").trim().replace(/\s+/g, " ") }, /* @__PURE__ */ e.createElement(
      "button",
      {
        id: n,
        className: `${$}__toggle`,
        role: "switch",
        disabled: s,
        "aria-checked": g,
        onClick: b
      },
      E
    ))
  );
};
b2.propTypes = {
  /**
   * Is the switch disabled?
   */
  disabled: t.bool,
  /**
   * Id of the switch.
   */
  id: t.string.isRequired,
  /**
   * Width of the input field. Accepts a number in pixels. Leave blank for width: 100%.
   */
  inputWidth: t.number,
  /**
   * Label of the switch field.
   */
  label: t.string.isRequired,
  /**
   * Message or description used to help clarify the usage of the input.
   */
  message: t.string,
  /**
   * Callback function that will return the updated properties from the toggle switch when it changes.
   */
  onChange: t.func,
  /**
   * Is the field required?
   */
  required: t.bool,
  /**
   * Should the field label be visible? If false, it will render for screen readers only.
   */
  showLabel: t.bool,
  /**
   * Show toggle status label next to switch. If false, icons will render and the text will still be available to screen readers.
   */
  showStatusLabel: t.bool,
  /**
   * Status text for when switch is off.
   */
  statusOffLabel: t.string,
  /**
   * Status text for when switch is on.
   */
  statusOnLabel: t.string,
  /**
   * Additional class names
   */
  className: t.string
};
const Y2 = () => {
  const s = (a, c, r = {}) => {
    const o = /* @__PURE__ */ e.createElement(As, { type: a }, c);
    let l = y({}, r);
    return (a === "critical" || a === "warning") && (l = ge(y({}, l), {
      autoClose: !1,
      role: "alert"
    })), a === "working" && (l = ge(y({}, l), {
      autoClose: !1,
      closeButton: !1,
      closeOnClick: !1
    })), ns(o, l);
  }, n = o1({
    collapse: !1,
    enter: "pds-toast--bounceInPlace",
    exit: "pds-toast--slideOut"
  });
  return [s, ns, n];
}, v2 = Be(
  (T, z) => {
    var V = T, {
      autoComplete: s,
      counterMaxLength: n,
      defaultValue: a,
      disabled: c = !1,
      hasClearButton: r = !1,
      hasSearchShortcut: o = !1,
      id: l,
      inputProps: i,
      inputWidth: d,
      label: u,
      message: h,
      onBlur: m,
      onChange: p,
      onClear: f,
      onFocus: C,
      placeholder: $,
      readonly: g = !1,
      required: _ = !1,
      showLabel: b = !0,
      showVisibilityToggle: v = !1,
      translationStrings: E = {
        clearButton: "Clear input text",
        counterOverLimit: "Character limit exceeded by",
        searchShortcut: "Press / to focus the search field",
        visibilityStatus: "The value of the input is",
        visibilityToggleHide: "Hide input value",
        visibilityToggleShow: "Show input value"
      },
      type: w = "text",
      validationMessage: L,
      validationStatus: N,
      value: M,
      className: k
    } = V, x = S(V, [
      "autoComplete",
      "counterMaxLength",
      "defaultValue",
      "disabled",
      "hasClearButton",
      "hasSearchShortcut",
      "id",
      "inputProps",
      "inputWidth",
      "label",
      "message",
      "onBlur",
      "onChange",
      "onClear",
      "onFocus",
      "placeholder",
      "readonly",
      "required",
      "showLabel",
      "showVisibilityToggle",
      "translationStrings",
      "type",
      "validationMessage",
      "validationStatus",
      "value",
      "className"
    ]);
    const H = Kt(d), I = "pds-text-input", A = c ? ue.disabled : null, j = _ && !c ? ue.required : null, B = N === "error" ? ue.error : null, W = N === "success" ? ue.success : null, Z = g ? ue.readonly : null;
    let K = null;
    w === "search" && (K = "search"), N === "error" && (K = "error"), N === "success" && (K = "success");
    const O = L || h, D = typeof M != "undefined", F = typeof a != "undefined", [U, ie] = R(
      F ? a : ""
    ), Q = M || U, ve = (J) => {
      v && le && ne(!1), m && m(J);
    }, te = (J) => {
      D || ie(J.target.value), p && p(J);
    }, de = () => {
      D || ie(""), f && f();
      const J = document.getElementById(l);
      J && J.focus();
    }, [le, ne] = R(!1), Ee = () => {
      ne((G) => !G);
      const J = document.getElementById(l);
      J && J.focus();
    };
    let ee = w;
    return v && w === "password" && (le ? ee = "text" : ee = "password"), /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: Y([
          ue.base,
          I,
          A,
          j,
          B,
          W,
          Z,
          k != null ? k : ""
        ]),
        style: d ? H : null
      }, x),
      /* @__PURE__ */ e.createElement(
        ht,
        {
          id: l,
          label: u,
          showLabel: b,
          required: _,
          disabled: c
        }
      ),
      v && w === "password" && /* @__PURE__ */ e.createElement("div", { className: "visually-hidden", "aria-live": "polite" }, `${E.visibilityStatus} ${le ? "visible" : "hidden"}.`),
      /* @__PURE__ */ e.createElement("div", { className: `${I}__input-wrapper` }, K && /* @__PURE__ */ e.createElement(Yt, { variant: K }), /* @__PURE__ */ e.createElement(
        "input",
        y({
          ref: z,
          className: `${I}__input`,
          id: l,
          name: l,
          type: ee,
          value: D ? M : U,
          placeholder: $,
          readOnly: g,
          disabled: c,
          required: _,
          autoComplete: w === "password" ? "off" : s,
          onBlur: ve,
          onChange: te,
          onFocus: C,
          "aria-invalid": N === "error" ? !0 : null,
          "aria-describedby": O ? `${l}__message` : null
        }, i)
      ), r && Q && /* @__PURE__ */ e.createElement(
        zs,
        {
          id: l,
          clearLabel: E.clearButton,
          handleClearInput: de
        }
      ), v && w === "password" && /* @__PURE__ */ e.createElement(
        "button",
        {
          type: "button",
          className: `${I}__visibility-toggle`,
          title: le ? E.visibilityToggleHide : E.visibilityToggleShow,
          "aria-controls": l,
          onClick: Ee,
          onMouseDown: (J) => J.preventDefault()
        },
        /* @__PURE__ */ e.createElement(q, { iconName: le ? "eyeSlash" : "eye", iconSize: "md" })
      ), o && w === "search" && !Q && /* @__PURE__ */ e.createElement(
        Hs,
        {
          inputId: l,
          shortcutLabel: E.searchShortcut
        }
      ), n && w !== "password" && /* @__PURE__ */ e.createElement(
        C1,
        {
          id: l,
          currentLength: Q.length,
          maxLength: n,
          overLimitMessage: E.counterOverLimit
        }
      )),
      O && /* @__PURE__ */ e.createElement(
        Qe,
        {
          id: l,
          message: O,
          hasValidationMessage: !!L,
          validationMessageHasDecorators: !1,
          validationStatus: N
        }
      )
    );
  }
), _2 = {
  silver: "Silver",
  gold: "Gold",
  platinum: "Platinum",
  diamond: "Diamond"
}, E2 = (m) => {
  var p = m, {
    ariaLabel: s = "Workspace selector menu",
    createWorkspaceLink: n,
    filterPlaceholder: a = "Find workspace...",
    filterLabel: c = "Filter workspaces",
    menuHeading: r = "Workspaces",
    minFilterItems: o = 8,
    noResultsText: l = "No results found",
    withinNavbar: i = !0,
    workspaceList: d,
    className: u
  } = p, h = S(p, [
    "ariaLabel",
    "createWorkspaceLink",
    "filterPlaceholder",
    "filterLabel",
    "menuHeading",
    "minFilterItems",
    "noResultsText",
    "withinNavbar",
    "workspaceList",
    "className"
  ]);
  const [f, C] = R(!1), [$, g] = R(null), [_, b] = R(d), v = se([]), E = se(null), w = d.length >= o;
  let L = !1;
  const N = ke(Fe);
  N && (L = N.isMobile);
  const M = i && L, k = "pds-workspace-selector", x = M ? `${k}--isMobile` : null, z = `${k}__menu`, T = w ? `${z}--scroll` : null, { refs: V, floatingStyles: H, context: I } = Ie({
    open: f,
    onOpenChange: C,
    whileElementsMounted: qe
  }), A = ot(I, { event: "mousedown" }), j = Se(I), B = Te(I, { role: "menu" }), W = pt(I, {
    listRef: v,
    activeIndex: $,
    onNavigate: g,
    loop: !0,
    openOnArrowKeyDown: !0,
    focusItemOnHover: !0,
    focusItemOnOpen: !1
  }), { getReferenceProps: Z, getFloatingProps: K, getItemProps: O } = Oe(
    [j, B, A, W]
  ), { isMounted: D, styles: F } = Xe(I, {
    duration: {
      open: 300,
      close: 150
    },
    initial: {
      opacity: 0
    },
    open: {
      opacity: 1
    },
    close: {
      opacity: 0
    }
  });
  let U = d.find((G) => G.isActive);
  U || (U = d[0]);
  const ie = (G) => {
    const { value: he } = G.target, we = d.filter((ae) => ae.displayName.toLowerCase().includes(he.toLowerCase()));
    b(we);
  };
  oe(() => {
    const G = d.map((he) => ge(y({}, he), {
      isActive: he.isActive
    }));
    b(G);
  }, [d]);
  const Q = (G) => {
    G.preventDefault(), G.key === "Enter" && v.current[$].querySelector("a").click(), G.key === "Tab" && (G.shiftKey ? w ? document.getElementById("workspace-filter").focus() : C(!1) : n ? E.current.querySelector("a").focus() : C(!1));
  }, ve = /* @__PURE__ */ e.createElement("div", { className: `${k}__button-content` }, /* @__PURE__ */ e.createElement(
    ut,
    {
      size: "sm",
      uniqueId: U.workspaceId,
      imageSrc: U.imageSrc,
      className: `${k}__avatar`
    }
  ), /* @__PURE__ */ e.createElement("span", { className: `${k}__name` }, U.displayName), U.planTier && /* @__PURE__ */ e.createElement(
    Ct,
    {
      size: "sm",
      color: U.planTier,
      label: _2[U.planTier]
    }
  )), te = /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: "angleDown",
      iconSize: "md",
      className: `${k}__trigger-icon`
    }
  ), de = w && /* @__PURE__ */ e.createElement("div", { className: `${k}__filter` }, /* @__PURE__ */ e.createElement(
    v2,
    {
      hasClearButton: !0,
      onClear: () => b(d),
      id: "workspace-filter",
      label: c,
      onChange: ie,
      placeholder: a,
      showLabel: !1,
      type: "search"
    }
  )), le = _.map(
    (G, he) => {
      const we = `${k}__item`, ae = G.isActive ? `${we}--active` : null, ce = G.isUnprivileged ? `${we}--unprivileged` : null, Le = /* @__PURE__ */ e.createElement(q, { iconName: "check", className: `${k}__active-icon` }), He = G.workspaceId, ze = G.workspaceLink.type, _e = G.isUnprivileged ? null : (We) => {
        v.current[he] = We;
      };
      return /* @__PURE__ */ e.createElement(
        "li",
        y({
          key: He,
          id: He,
          className: [
            we,
            ae,
            ce
          ].join(" ").trim().replace(/\s+/g, " "),
          role: "menuitem",
          tabIndex: $ === he ? 0 : -1,
          ref: _e,
          onKeyDown: Q
        }, O()),
        /* @__PURE__ */ e.createElement(
          ze,
          ge(y({}, G.workspaceLink.props), {
            onClick: () => C(!1)
          }),
          /* @__PURE__ */ e.createElement("div", { className: `${k}__item-content` }, /* @__PURE__ */ e.createElement(
            ut,
            {
              size: "sm",
              uniqueId: G.workspaceId,
              imageSrc: G.imageSrc,
              className: `${k}__list-avatar`
            }
          ), G.displayName),
          G.isActive && Le
        )
      );
    }
  ), ne = n && /* @__PURE__ */ e.createElement("div", { className: `${k}__create-link`, ref: E }, /* @__PURE__ */ e.createElement(
    ct,
    {
      displayType: "icon-end",
      iconName: "plus",
      linkContent: n,
      variant: "subtle",
      onBlur: C.bind(null, !1),
      onClick: C.bind(null, !1)
    }
  )), Ee = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "button",
    y({
      className: `${k}__trigger`,
      "aria-label": s,
      ref: V.setReference
    }, Z()),
    ve,
    te
  ), D && /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: `${k}__dropdown`,
      ref: V.setFloating,
      style: {
        floatingStyles: H,
        zIndex: "var(--pds-z-index-dropdown)"
      }
    }, K()),
    /* @__PURE__ */ e.createElement("div", { style: y({}, F) }, de, /* @__PURE__ */ e.createElement(
      "ul",
      {
        className: [z, T].join(" ").trim().replace(/\s+/g, " "),
        role: "menu"
      },
      /* @__PURE__ */ e.createElement("li", { className: `${k}__item-heading`, role: "presentation" }, r),
      le.length === 0 ? /* @__PURE__ */ e.createElement("p", { className: `${k}__no-results` }, l) : le
    ), ne)
  )), ee = (G) => {
    const he = G.target;
    he.classList.toggle(`${k}__toggle--expanded`), he.setAttribute(
      "aria-expanded",
      he.getAttribute("aria-expanded") === "true" ? "false" : "true"
    ), he.nextElementSibling.classList.toggle(`${k}__mobile-menu--expanded`);
  }, J = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "button",
    {
      className: `${k}__toggle`,
      "aria-expanded": !1,
      "aria-label": s,
      onClick: ee
    },
    ve,
    te
  ), /* @__PURE__ */ e.createElement("div", { className: `${k}__mobile-menu` }, de, /* @__PURE__ */ e.createElement(
    "ul",
    {
      className: [z, `${z}--isMobile`].join(" ").trim(),
      role: "menu"
    },
    /* @__PURE__ */ e.createElement("li", { className: `${k}__item-heading`, role: "presentation" }, r),
    le.length === 0 ? /* @__PURE__ */ e.createElement("p", { className: `${k}__no-results` }, l) : le
  ), ne));
  return /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: [k, x, u].join(" ").trim().replace(/\s+/g, " ")
    }, h),
    M ? J : Ee
  );
};
E2.propTypes = {
  /**
   * Aria label for the workspace selector menu.
   */
  ariaLabel: t.string,
  /**
   * Link to create a new workspace. A link element using the router of your choice.
   */
  createWorkspaceLink: t.node,
  /**
   * Placeholder text for the filter input.
   */
  filterPlaceholder: t.string,
  /**
   * Label for the filter input.
   */
  filterLabel: t.string,
  /**
   * Heading for the workspace dropdown menu.
   */
  menuHeading: t.string,
  /**
   * Minimum number of items to enable filtering.
   */
  minFilterItems: t.number,
  /**
   * Text to display when no results are found.
   */
  noResultsText: t.string,
  /**
   * Is this component located in the top nav? Only applies when using the Navbar component from this toolkit. Defaults to true per design.
   */
  withinNavbar: t.bool,
  /**
   * List of all workspaces for a user.
   */
  workspaceList: t.arrayOf(
    t.shape({
      /**
       * Name of the workspace.
       */
      displayName: t.string,
      /**
       * Image src for the workspace.
       */
      imageSrc: t.string,
      /**
       * Is this the currently selected workspace?
       */
      isActive: t.bool,
      /**
       * This user does not have access to this workspace.
       */
      isUnprivileged: t.bool,
      /**
       * Account plan tier.
       */
      planTier: t.oneOf(["silver", "gold", "platinum", "diamond"]),
      /**
       * Id of the workspace.
       */
      workspaceId: t.string,
      /**
       * Link to the workspace. A link element via the router of your choice.
       */
      workspaceLink: t.node
    })
  ),
  /**
   * Additional class names.
   */
  className: t.string
};
const C2 = (o) => {
  var l = o, {
    label: s,
    type: n = "neutral",
    typeLabels: a = {
      info: "Information",
      success: "Success",
      warning: "Warning",
      critical: "Critical",
      neutral: "Neutral"
    },
    className: c
  } = l, r = S(l, [
    "label",
    "type",
    "typeLabels",
    "className"
  ]);
  const i = "pds-tally", d = `${i}--${n}`, h = ["critical", "warning"].includes(n) ? "alert" : "status", m = `${a[n]} notifications: `;
  return /* @__PURE__ */ e.createElement(
    "div",
    ge(y({
      className: [i, d, c != null ? c : ""].join(" ").trim().replace(/\s+/g, " ")
    }, r), {
      role: h
    }),
    /* @__PURE__ */ e.createElement("div", { className: `${i}__label` }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, m), s)
  );
}, X2 = (d) => {
  var u = d, {
    disabled: s = !1,
    id: n,
    initialSelection: a,
    label: c,
    onChange: r,
    options: o,
    className: l
  } = u, i = S(u, [
    "disabled",
    "id",
    "initialSelection",
    "label",
    "onChange",
    "options",
    "className"
  ]);
  const h = "pds-segmented-button", m = "pds-is-disabled", p = se([h]), [f, C] = R(a), $ = (_) => {
    C(_.target.value), r && r(_.target.value);
  };
  if ((() => {
    p.current = p.current.filter((_) => _ !== m);
  })(), s && p.current.push(m), o.length >= 2 && o.length <= 6)
    return /* @__PURE__ */ e.createElement(
      "fieldset",
      y({
        className: [h, l != null ? l : ""].join(" ").trim().replace(/\s+/g, " ")
      }, i),
      /* @__PURE__ */ e.createElement("legend", { className: "visually-hidden" }, c),
      /* @__PURE__ */ e.createElement("div", { className: `${h}__options` }, o.map((_, b) => /* @__PURE__ */ e.createElement(
        "div",
        {
          className: `${h}__option`,
          key: `${n}-option-${b}`
        },
        /* @__PURE__ */ e.createElement(
          "input",
          {
            className: "visually-hidden",
            type: "radio",
            id: `${n}-option-${b}`,
            name: n,
            value: _.value,
            disabled: s,
            onClick: $,
            defaultChecked: f === _.value
          }
        ),
        /* @__PURE__ */ e.createElement("label", { htmlFor: `${n}-option-${b}` }, _.tally ? /* @__PURE__ */ e.createElement(
          C2,
          {
            label: _.tally.label,
            type: _.tally.type,
            className: `${h}__tally`
          }
        ) : _.iconName && /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: _.iconName,
            iconSize: "sm",
            className: `${h}__icon`
          }
        ), /* @__PURE__ */ e.createElement("span", { className: `${h}__label-text` }, _.label))
      )))
    );
}, $2 = {
  info: "Info",
  warning: "Warning",
  success: "Success",
  critical: "Critical",
  discovery: "Discovery",
  code: "Code",
  earlyAccess: "Early access"
}, Q2 = (o) => {
  var l = o, {
    children: s,
    title: n,
    type: a = "info",
    className: c
  } = l, r = S(l, [
    "children",
    "title",
    "type",
    "className"
  ]);
  const i = "pds-callout", d = `${i}--${a}`, u = {
    info: "circleInfo",
    warning: "triangleExclamation",
    success: "circleCheck",
    critical: "diamondExclamation",
    discovery: "squareQuestion",
    code: "squareTerminal",
    earlyAccess: "leaf"
  }, h = `${$2[a]}: `;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [i, d, c != null ? c : ""].join(" ").trim().replace(/\s+/g, " ")
    }, r),
    /* @__PURE__ */ e.createElement("div", { className: `${i}__inner` }, /* @__PURE__ */ e.createElement("div", { className: `${i}__icon ${i}__icon--${a}` }, /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: `${a}` in as ? as[a] : u.info,
        iconSize: "xl"
      }
    )), /* @__PURE__ */ e.createElement("div", { className: `${i}__text` }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, h), n && /* @__PURE__ */ e.createElement("div", { className: `${i}__title` }, n), s && /* @__PURE__ */ e.createElement("div", { className: `${i}__main-content` }, s)))
  );
}, y2 = Be(
  (L, w) => {
    var N = L, {
      checked: s,
      defaultChecked: n,
      disabled: a,
      id: c,
      indeterminate: r,
      inputProps: o,
      inputWidth: l,
      label: i,
      message: d,
      name: u,
      nestingLevel: h = 0,
      onBlur: m,
      onChange: p,
      onFocus: f,
      required: C,
      showLabel: $ = !0,
      validationMessage: g,
      validationStatus: _,
      value: b,
      className: v
    } = N, E = S(N, [
      "checked",
      "defaultChecked",
      "disabled",
      "id",
      "indeterminate",
      "inputProps",
      "inputWidth",
      "label",
      "message",
      "name",
      "nestingLevel",
      "onBlur",
      "onChange",
      "onFocus",
      "required",
      "showLabel",
      "validationMessage",
      "validationStatus",
      "value",
      "className"
    ]);
    const M = l ? { width: `${l / 16}rem` } : null, k = "pds-checkbox", x = a ? ue.disabled : null, z = C && !a ? ue.required : null, T = _ === "error" ? ue.error : null, V = _ === "success" ? ue.success : null, H = h > 0 ? `${k}--indent-${h}` : null, I = g || d, A = typeof s != "undefined", j = typeof n != "undefined", [B, W] = R(
      j ? n : !1
    ), Z = s || B, K = (ie) => {
      A || W(ie.target.checked), p && p(ie);
    }, O = `${k}__box`, D = r ? null : Z ? `${O}--checked` : null, F = r ? `${O}--indeterminate` : null, U = Gt(() => {
      if (r)
        return /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: "minus",
            iconSize: "sm",
            className: `${k}__icon ${k}__icon--indeterminate`
          }
        );
      if (Z)
        return /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: "check",
            iconSize: "sm",
            className: `${k}__icon ${k}__icon--checked`
          }
        );
    }, [r, Z]);
    return /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: [
          k,
          x,
          z,
          T,
          V,
          H,
          v != null ? v : ""
        ].join(" ").trim().replace(/\s+/g, " "),
        style: l ? M : null
      }, E),
      /* @__PURE__ */ e.createElement("div", { className: `${k}__input-wrapper` }, /* @__PURE__ */ e.createElement(
        "input",
        y(ge(y({
          ref: w,
          id: c,
          name: u,
          type: "checkbox",
          checked: A ? s : B,
          "aria-checked": r ? "mixed" : Z ? "true" : "false"
        }, b ? { value: b } : {}), {
          disabled: a,
          required: C,
          onBlur: m,
          onChange: K,
          onFocus: f,
          "aria-invalid": _ === "error" ? !0 : null,
          "aria-describedby": I ? `${c}__message` : null
        }), o)
      ), /* @__PURE__ */ e.createElement("label", { htmlFor: c, className: `${k}__label` }, /* @__PURE__ */ e.createElement(
        "div",
        {
          className: Y([
            O,
            D,
            F
          ])
        },
        /* @__PURE__ */ e.createElement(U, null)
      ), /* @__PURE__ */ e.createElement(
        "div",
        {
          className: Y([
            `${k}__label-text`,
            $ ? "" : "visually-hidden"
          ])
        },
        i,
        " ",
        C && !a && /* @__PURE__ */ e.createElement(Zt, null)
      ))),
      I && /* @__PURE__ */ e.createElement(
        Qe,
        {
          id: c,
          message: I,
          hasValidationMessage: !!g,
          validationMessageHasDecorators: !0,
          validationStatus: _
        }
      )
    );
  }
), J2 = (f) => {
  var C = f, {
    children: s,
    disabled: n = !1,
    fieldsetProps: a,
    id: c,
    inputWidth: r,
    label: o,
    message: l,
    required: i = !1,
    showLabel: d = !0,
    validationMessage: u,
    validationStatus: h,
    className: m
  } = C, p = S(C, [
    "children",
    "disabled",
    "fieldsetProps",
    "id",
    "inputWidth",
    "label",
    "message",
    "required",
    "showLabel",
    "validationMessage",
    "validationStatus",
    "className"
  ]);
  const $ = r ? { width: `${r / 16}rem` } : null, g = "pds-checkbox-group", _ = n ? ue.disabled : null, b = i && !n ? ue.required : null, v = h === "error" ? ue.error : null, E = h === "success" ? ue.success : null, w = u || l;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [
        g,
        _,
        b,
        v,
        E,
        m != null ? m : ""
      ].join(" ").trim().replace(/\s+/g, " "),
      style: r ? $ : null
    }, p),
    /* @__PURE__ */ e.createElement("fieldset", y({ className: `${g}__fieldset`, id: c }, a), /* @__PURE__ */ e.createElement(
      ht,
      {
        disabled: n,
        label: o,
        id: c,
        isLegend: !0,
        required: i,
        showLabel: d
      }
    ), /* @__PURE__ */ e.createElement("div", { className: `${g}__options` }, s)),
    w && /* @__PURE__ */ e.createElement(
      Qe,
      {
        id: c,
        message: w,
        hasValidationMessage: !!u,
        validationMessageHasDecorators: !0,
        validationStatus: h
      }
    )
  );
}, en = ($) => {
  var g = $, {
    disabled: s = !1,
    fieldsetProps: n,
    id: a,
    inputWidth: c,
    label: r,
    message: o,
    onGroupBlur: l,
    onValueChange: i,
    options: d,
    required: u = !1,
    showLabel: h = !0,
    validationMessage: m,
    validationStatus: p,
    className: f
  } = g, C = S(g, [
    "disabled",
    "fieldsetProps",
    "id",
    "inputWidth",
    "label",
    "message",
    "onGroupBlur",
    "onValueChange",
    "options",
    "required",
    "showLabel",
    "validationMessage",
    "validationStatus",
    "className"
  ]);
  const _ = c ? { width: `${c / 16}rem` } : null, b = "pds-checkbox-group", v = s ? ue.disabled : null, E = u && !s ? ue.required : null, w = p === "error" ? ue.error : null, L = p === "success" ? ue.success : null, N = m || o;
  d.map((V) => {
    V.id || (V.id = V.value);
  });
  const M = [];
  d.map((V) => {
    V.checked === !0 && M.push(V.value);
  });
  const [k, x] = R(M), z = (V) => {
    const { value: H } = V.target, I = k.includes(H) ? k.filter((A) => A !== H) : [...k, H];
    x(I), i && i(I);
  };
  d.map((V) => {
    k.includes(V.value) ? V.checked = !0 : V.checked = !1;
  });
  const T = () => {
    l && setTimeout(() => {
      d.some((V) => V.id === document.activeElement.id) || l(k);
    }, 1500);
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [
        b,
        v,
        E,
        w,
        L,
        f != null ? f : ""
      ].join(" ").trim().replace(/\s+/g, " "),
      style: c ? _ : null
    }, C),
    /* @__PURE__ */ e.createElement("fieldset", y({ className: `${b}__fieldset`, id: a }, n), /* @__PURE__ */ e.createElement(
      ht,
      {
        disabled: s,
        label: r,
        id: a,
        isLegend: !0,
        required: u,
        showLabel: h
      }
    ), /* @__PURE__ */ e.createElement("div", { className: `${b}__options` }, d.map((V) => /* @__PURE__ */ e.createElement(
      y2,
      {
        key: V.id,
        checked: V.checked,
        id: V.id,
        label: V.label,
        name: V.name,
        value: V.value,
        disabled: V.disabled || s,
        className: `${b}__checkbox`,
        onChange: z,
        onBlur: T
      }
    )))),
    N && /* @__PURE__ */ e.createElement(
      Qe,
      {
        id: a,
        message: N,
        hasValidationMessage: !!m,
        validationMessageHasDecorators: !0,
        validationStatus: p
      }
    )
  );
}, tn = (c) => {
  var r = c, {
    children: s,
    className: n
  } = r, a = S(r, [
    "children",
    "className"
  ]);
  var f, C, $, g;
  const o = "pds-input-group", l = [s[0], s[1]], i = (f = s[0].props.id) != null ? f : null, d = (C = s[0].props.message) != null ? C : null, u = ($ = s[0].props.validationMessage) != null ? $ : null, h = (g = s[0].props.validationStatus) != null ? g : null, m = u || d, p = m ? `${o}--has-message` : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: Y([o, p, n != null ? n : ""])
    }, a),
    /* @__PURE__ */ e.createElement("div", { className: `${o}__inner` }, l),
    m && /* @__PURE__ */ e.createElement(
      Qe,
      {
        id: i,
        message: m,
        hasValidationMessage: !!u,
        validationMessageHasDecorators: !1,
        validationStatus: h
      }
    )
  );
}, w2 = ({ toggleStatusLabel: s, id: n }) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(Xt, { label: s }), /* @__PURE__ */ e.createElement(
  "label",
  {
    htmlFor: n,
    className: "pds-switch__toggle-label",
    "aria-hidden": "true"
  },
  s
)), N2 = ({ toggleStatusLabel: s }) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(Xt, { label: s }), /* @__PURE__ */ e.createElement(
  "span",
  {
    className: "pds-switch__input-decor",
    "data-switch-input-state": "on",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ e.createElement(q, { iconName: "check", iconSize: "sm" })
), /* @__PURE__ */ e.createElement(
  "span",
  {
    className: "pds-switch__input-decor",
    "data-switch-input-state": "off",
    "aria-hidden": "true"
  },
  /* @__PURE__ */ e.createElement(q, { iconName: "xmark", iconSize: "sm" })
)), sn = Be(
  (b, _) => {
    var v = b, {
      checked: s,
      defaultChecked: n,
      disabled: a = !1,
      id: c,
      inputProps: r,
      inputWidth: o,
      label: l,
      switchPlacement: i = "right",
      message: d,
      offLabel: u = "Off",
      onChange: h,
      onLabel: m = "On",
      required: p = !1,
      showLabel: f = !0,
      showStatusLabel: C = !0,
      className: $
    } = v, g = S(v, [
      "checked",
      "defaultChecked",
      "disabled",
      "id",
      "inputProps",
      "inputWidth",
      "label",
      "switchPlacement",
      "message",
      "offLabel",
      "onChange",
      "onLabel",
      "required",
      "showLabel",
      "showStatusLabel",
      "className"
    ]);
    const E = Kt(o), w = "pds-switch", L = a ? ue.disabled : null, N = p && !a ? ue.required : null, M = typeof s != "undefined", k = i == "below", x = i == "right", z = !M && n ? n : !1, [T, V] = R(z), H = s || T ? m : u, I = (K) => {
      M || V(K.target.checked), h && h(K);
    }, A = /* @__PURE__ */ e.createElement("div", { className: "pds-switch__content" }, /* @__PURE__ */ e.createElement("label", { className: "pds-switch__input" }, /* @__PURE__ */ e.createElement(
      "input",
      y({
        ref: _,
        id: c,
        name: c,
        type: "checkbox",
        role: "switch",
        className: "visually-hidden",
        onChange: I,
        disabled: a,
        required: p,
        checked: s !== void 0 ? s : T,
        "aria-describedby": d ? `${c}__message` : null
      }, r)
    ), !C && /* @__PURE__ */ e.createElement(N2, { toggleStatusLabel: H }), /* @__PURE__ */ e.createElement("span", { className: "pds-switch__thumb", "aria-hidden": "true" })), C && /* @__PURE__ */ e.createElement(w2, { toggleStatusLabel: H, id: c })), j = /* @__PURE__ */ e.createElement(
      ht,
      {
        id: c,
        label: l,
        showLabel: f,
        required: p,
        disabled: a,
        className: Y([
          "pds-input-label--disable-click",
          d ? "" : "pds-input-label--switch-top-message"
        ])
      }
    ), B = d && /* @__PURE__ */ e.createElement(
      Qe,
      {
        id: c,
        message: d,
        hasValidationMessage: !1,
        validationStatus: void 0,
        className: "pds-input-message--switch"
      }
    );
    let W, Z;
    return k ? W = /* @__PURE__ */ e.createElement(e.Fragment, null, j, B, A) : x && (Z = "pds-switch--placement-right", W = d ? /* @__PURE__ */ e.createElement(e.Fragment, null, j, /* @__PURE__ */ e.createElement("div", { className: "pds-switch__toggle-message-container" }, B, /* @__PURE__ */ e.createElement("div", null, A))) : /* @__PURE__ */ e.createElement(
      "div",
      {
        className: Y([
          "pds-switch__label-switch-right",
          "pds-switch__label-switch-right--label-only"
        ])
      },
      j,
      A
    )), /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: Y([
          ue.base,
          w,
          L,
          N,
          Z,
          $
        ]),
        style: o ? E : null
      }, g),
      W
    );
  }
), nn = (u) => {
  var h = u, {
    ariaLabel: s,
    children: n,
    hasCloseButton: a = !0,
    modalIsOpen: c = !1,
    setModalIsOpen: r = () => {
    },
    size: o = "md",
    title: l,
    className: i
  } = h, d = S(h, [
    "ariaLabel",
    "children",
    "hasCloseButton",
    "modalIsOpen",
    "setModalIsOpen",
    "size",
    "title",
    "className"
  ]);
  const m = "pds-modal", p = o !== "md" ? `${m}--${o}` : null, [f, C] = R(c);
  oe(() => {
    C(c);
  }, [c]), oe(() => {
    r(f);
  }, [f]);
  const { refs: $, context: g, floatingStyles: _ } = Ie({
    open: f,
    onOpenChange: C
  }), b = ot(g), v = Se(g, {
    outsidePressEvent: "mousedown"
  }), E = Te(g), { getFloatingProps: w } = Oe([b, v, E]), { isMounted: L, styles: N } = Xe(g, {
    duration: {
      open: 300,
      close: 300
    },
    initial: {
      opacity: 0,
      transform: "translateY(0)"
    },
    open: {
      opacity: 1,
      transform: "translateY(6rem)"
    },
    close: {
      opacity: 0,
      transform: "translateY(1rem)"
    }
  });
  return /* @__PURE__ */ e.createElement(e.Fragment, null, L && /* @__PURE__ */ e.createElement(
    e1,
    {
      lockScroll: !0,
      style: ge(y({}, _), {
        background: "var(--pds-color-overlay)",
        transition: "var(--pds-animation-reveal-transition)",
        zIndex: "var(--pds-z-index-modal)"
      })
    },
    /* @__PURE__ */ e.createElement(vs, { context: g }, /* @__PURE__ */ e.createElement(
      "div",
      y(ge(y({
        ref: $.setFloating,
        "aria-label": s || l
      }, w()), {
        className: [m, p, i].join(" ").trim().replace(/\s+/g, " "),
        style: ge(y(y({}, _), N), {
          position: "relative"
        })
      }), d),
      a && /* @__PURE__ */ e.createElement(
        "button",
        {
          onClick: () => C(!1),
          className: `${m}__close`,
          type: "button"
        },
        /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, "Close"),
        /* @__PURE__ */ e.createElement(q, { iconName: "xmark", iconSize: "xl" })
      ),
      /* @__PURE__ */ e.createElement("div", { className: `${m}__title` }, l),
      /* @__PURE__ */ e.createElement("div", { className: `${m}__content` }, n)
    ))
  ));
}, qs = (s) => typeof s.linkContent != "string" ? !!(s.isActive || s.linkContent.props.className && s.linkContent.props.className.includes("pds-isActive")) : !1, ye = (s) => {
  if (qs(s))
    return !0;
  if (s.links) {
    for (let n = 0; n < s.links.length; n++)
      if (ye(s.links[n]))
        return !0;
  }
  return !1;
}, Ps = (s) => {
  for (let n = 0; n < s.length; n++) {
    if (qs(s[n]))
      return typeof s[n].linkContent == "string" ? null : s[n].linkContent;
    if (s[n].links) {
      const a = Ps(s[n].links);
      if (a)
        return a;
    }
  }
  return null;
}, at = (s) => {
  let n = s;
  return typeof s == "object" && (n = s.props.children), n;
}, lt = (s, n) => {
  let a = null;
  if (typeof s == "string" && n) {
    const c = n ? n[0].linkContent : null;
    e.isValidElement(c) && (a = e.cloneElement(c, y({}, typeof s == "string" ? { children: s } : {})));
  } else
    a = s;
  return a;
}, Ut = (s, n, a, c) => {
  let r = null;
  if (typeof n == "string") {
    const o = c ? [
      /* @__PURE__ */ e.createElement("span", { key: n, className: `${s}__item-inner` }, /* @__PURE__ */ e.createElement("span", { className: `${s}__link-icon` }, /* @__PURE__ */ e.createElement(q, { iconName: c, iconSize: "md" })), /* @__PURE__ */ e.createElement("span", { className: `${s}__link-label` }, n))
    ] : [
      /* @__PURE__ */ e.createElement("span", { key: n, className: `${s}__item-inner` }, /* @__PURE__ */ e.createElement("span", { className: `${s}__link-label` }, n))
    ];
    if (a) {
      const l = a[0].linkContent;
      Pe(l) && (r = Ge(l, y({}, typeof n == "string" ? { children: o } : {})));
    } else
      r = null;
  }
  return typeof n == "object" && (c ? r = Ge(n, ge(y({}, n.props), {
    children: [
      /* @__PURE__ */ e.createElement("span", { key: c, className: `${s}__item-inner` }, /* @__PURE__ */ e.createElement("span", { className: `${s}__link-icon` }, /* @__PURE__ */ e.createElement(q, { iconName: c, iconSize: "md" })), /* @__PURE__ */ e.createElement("span", { className: `${s}__link-label` }, n.props.children))
    ]
  })) : r = n), r;
}, k2 = ({
  icon: s,
  isActive: n,
  isSidebarExpanded: a,
  labels: c,
  linkContent: r,
  links: o
}) => {
  const l = "pds-dashboard-nav", i = `${l}__item`, d = `${l}__menu`, u = /* @__PURE__ */ e.createElement("div", { className: `${i}-wrapper` }, Ut(l, r, o, s)), h = (N, M) => /* @__PURE__ */ e.createElement(
    "ul",
    {
      className: Y([
        d,
        `${d}--${M}`,
        n ? `${d}--expanded` : null
      ])
    },
    N.map((k, x) => /* @__PURE__ */ e.createElement(
      "li",
      {
        key: x,
        className: Y([
          i,
          `${i}--${M}`,
          ye(k) ? `${i}--active` : null
        ])
      },
      k.linkContent
    ))
  ), [m, p] = R(!1), { refs: f, floatingStyles: C, context: $ } = Ie({
    placement: "right-start",
    open: m,
    onOpenChange: p,
    middleware: [yt(12), wt(), Nt()],
    whileElementsMounted: qe
  }), g = _t($, {
    move: !1,
    handleClose: bs()
  }), _ = gs($), b = Se($), v = Te($, { role: "menu" }), { getReferenceProps: E, getFloatingProps: w } = Oe([
    g,
    _,
    b,
    v
  ]), L = (N) => {
    const M = N.target;
    M.classList.toggle(`${l}__toggle--expanded`), M.setAttribute(
      "aria-expanded",
      M.getAttribute("aria-expanded") === "true" ? "false" : "true"
    ), M.parentElement.nextElementSibling.classList.toggle(`${l}__menu--expanded`);
  };
  return /* @__PURE__ */ e.createElement(
    "li",
    y({
      className: Y([
        i,
        `${i}--top-level`,
        o ? `${i}--has-children` : null,
        a ? null : `${i}--collapsed`,
        n ? `${i}--active` : null
      ]),
      ref: a ? null : f.setReference
    }, E()),
    o ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: `${i}-wrapper` }, Ut(
      l,
      r,
      o,
      s
    ), a && /* @__PURE__ */ e.createElement(
      "button",
      {
        "aria-expanded": n,
        className: Y([
          `${l}__toggle`,
          n ? `${l}__toggle--expanded` : null
        ]),
        onClick: L
      },
      /* @__PURE__ */ e.createElement(q, { iconName: "angleDown", iconSize: "md" }),
      /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, `${c.toggle} ${at(r)} ${c.submenu}`)
    )), a && h(o, "second-level"), !a && m && /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: `${l}__flyout`,
        ref: f.setFloating,
        style: C
      }, w()),
      /* @__PURE__ */ e.createElement("div", { className: `${l}__flyout-heading` }, at(r)),
      h(o, "second-level-flyout")
    )) : /* @__PURE__ */ e.createElement(e.Fragment, null, a ? u : /* @__PURE__ */ e.createElement(
      Et,
      {
        content: at(r),
        customTrigger: u,
        offsetValue: {
          mainAxis: -4,
          crossAxis: -12
        },
        preferredPlacement: "right"
      }
    ))
  );
}, Jt = (o) => {
  var l = o, {
    headingText: s,
    menuItems: n,
    selectTextFallback: a = "Navigate to...",
    className: c
  } = l, r = S(l, [
    "headingText",
    "menuItems",
    "selectTextFallback",
    "className"
  ]);
  const i = "pds-dropdown-menu", [d, u] = R(!1), [h, m] = R(null), p = Ps(n), f = p ? p.props.children : a, C = /* @__PURE__ */ e.createElement(
    q,
    {
      iconName: "check",
      iconSize: "md",
      className: `${i}__active-icon`
    }
  ), $ = (I) => {
    var A;
    I.key === "Enter" && ((A = w.current[h].querySelector("a")) == null || A.click());
  }, g = (I) => {
    I.target.nodeName === "A" && u(!1);
  };
  oe(() => {
    if (d) {
      const I = document.querySelector(".pds-dropdown-menu__dropdown");
      return I.addEventListener("click", g), () => {
        I.removeEventListener("click", g);
      };
    }
  }, [d]);
  const _ = ({
    item: I,
    level: A
  }) => ge(y({}, I), {
    level: A,
    linkContent: Ge(
      lt(I.linkContent, I.links),
      {
        tabIndex: -1
      }
    )
  }), b = (I) => {
    const A = [];
    return I.forEach((j) => {
      j.links ? (A.push(_({ item: j, level: "top-level" })), j.links.forEach((B) => {
        B.links ? (A.push(_({ item: B, level: "second-level" })), B.links.forEach((W) => {
          A.push(
            _({ item: W, level: "third-level" })
          );
        })) : A.push(_({ item: B, level: "second-level" }));
      })) : A.push(_({ item: j, level: "top-level" }));
    }), A;
  }, { refs: v, context: E } = Ie({
    placement: "bottom-start",
    open: d,
    onOpenChange: u,
    whileElementsMounted: qe
  }), w = se([]), L = pt(E, {
    listRef: w,
    activeIndex: h,
    onNavigate: m,
    loop: !0,
    openOnArrowKeyDown: !0,
    focusItemOnHover: !0
  }), N = ot(E, { event: "mousedown" }), M = Se(E), k = Te(E, { role: "menu" }), { getReferenceProps: x, getFloatingProps: z, getItemProps: T } = Oe(
    [M, k, N, L]
  ), { isMounted: V, styles: H } = Xe(E, {
    duration: {
      open: 300,
      close: 300
    },
    initial: {
      opacity: 0
    },
    open: {
      opacity: 1
    },
    close: {
      opacity: 0
    }
  });
  return /* @__PURE__ */ e.createElement("div", y({ className: Y([i, c != null ? c : ""]) }, r), s && /* @__PURE__ */ e.createElement("h2", { className: `${i}__heading` }, s), /* @__PURE__ */ e.createElement(
    "button",
    y({
      className: `${i}__trigger`,
      ref: v.setReference
    }, x()),
    /* @__PURE__ */ e.createElement("span", { className: `${i}__active-label` }, f),
    /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: "angleDown",
        iconSize: "md",
        className: `${i}__trigger-icon`
      }
    )
  ), V && /* @__PURE__ */ e.createElement(
    "ul",
    y({
      className: `${i}__dropdown ${i}__menu ${i}__menu--top-level`,
      ref: v.setFloating,
      style: ge(y({}, H), {
        zIndex: "var(--pds-z-index-dropdown)"
      })
    }, z()),
    b(n).map((I, A) => /* @__PURE__ */ e.createElement(
      "li",
      y({
        key: A,
        onKeyDown: $,
        className: `${i}__item ${i}__item--${I.level} ${I.isActive === !0 ? `${i}__item--active` : ""}`,
        tabIndex: h === A ? 0 : -1,
        ref: (j) => {
          w.current[A] = j;
        }
      }, T()),
      I.linkContent,
      I.isActive === !0 && C
    ))
  ));
}, H2 = /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 165 50",
    height: "3.052rem",
    fill: "none",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false"
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.2 0L6.6 10.6H1L2.8 15.2H14.2L2.2 0Z",
      fill: "var(--pds-color-brand-primary-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.1 38.5L15.2 33.9H12.6L7.20001 20.8H4.90001L10.3 33.9H3.70001L15.9 49.1L11.5 38.5H17.1Z",
      fill: "var(--pds-color-brand-primary-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6 29.2H11.5L13 32.8H18.6C18.7 32.8 19.1 32.6 19.1 31C19 29.4 18.7 29.2 18.6 29.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.3 24.9H9.79999L11.3 28.5H19.3C19.4 28.5 19.8 28.3 19.8 26.7C19.7 25.1 19.4 24.9 19.3 24.9Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6 19.9C18.7 19.9 19.1 19.7 19.1 18.1C19.1 16.5 18.8 16.3 18.6 16.3H10.8L12.3 19.9H18.6Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14 24.2H19.2C19.3 24.2 19.7 24 19.7 22.4C19.7 20.8 19.4 20.6 19.2 20.6H12.5L14 24.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6 29.2H11.5L13 32.8H18.6C18.7 32.8 19.1 32.6 19.1 31C19 29.4 18.7 29.2 18.6 29.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.3 24.9H9.79999L11.3 28.5H19.3C19.4 28.5 19.8 28.3 19.8 26.7C19.7 25.1 19.4 24.9 19.3 24.9Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.4 24.2L3.7 19.9H7.6L9.4 24.2H13.1L9.8 16.3H1.7C1.1 16.3 0.7 16.3 0.4 17.2C0.0999996 18.3 0 20.4 0 24.5C0 28.6 -3.8743e-07 30.7 0.4 31.8C0.7 32.7 1 32.7 1.7 32.7H8.8L5.4 24.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M49 16.35H44.6L38.2 32.65H42.7L43.8 29.85H49.6L50.7 32.65H55.2L49 16.35ZM45 26.65L46.7 21.45L48.4 26.65H45Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M32.3 16.35H25.8V32.75H30.2V27.15H32.4C36.1 27.15 38.2 25.55 38.2 21.75C38.2 17.95 35.8 16.35 32.3 16.35ZM30.8 23.95H30.3V19.95H30.8C32.4 19.95 33.8 19.95 33.8 21.95C33.8 23.95 32.3 23.95 30.8 23.95Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M114.9 26.25L119.2 26.35V22.75H114.9V19.95H120.8V16.35H110.5V32.65H120.8V28.65H114.9V26.25Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M76.6 20.75H80.5L80.6 32.65H84.9V20.75H88.9V16.35H76.6V20.75Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M102.5 22.75H96.5V16.35H92.1V32.65H96.5V26.25H102.5V32.65H106.9V16.35H102.5V22.75Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M131.4 20.75C133.5 20.75 135.2 22.45 135.2 24.55C135.2 26.65 133.5 28.35 131.4 28.35C129.3 28.35 127.6 26.65 127.6 24.55C127.6 22.45 129.3 20.75 131.4 20.75ZM131.4 16.35C126.9 16.35 123.2 20.05 123.2 24.55C123.2 29.05 126.9 32.75 131.4 32.75C135.9 32.75 139.6 29.05 139.6 24.55C139.6 20.05 135.9 16.35 131.4 16.35Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M153.9 25.45L146.9 16.35H142.8V32.65H147.2V23.55L153.9 32.65H158.3V16.35H154L153.9 25.45Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M69 25.45L61.9 16.35H57.8V32.65H62.2V23.55L68.9 32.65H73.4V16.35H69V25.45Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M161.5 16.65H161V16.35H162.5V16.65H162V18.25H161.6V16.65H161.5ZM163.6 18.25L163.1 16.75V18.25H162.7V16.35H163.3L163.8 17.85L164.3 16.35H164.9V18.25H164.5V16.75L164 18.25H163.6Z",
      fill: "var(--pds-color-foreground-default)"
    }
  )
), ds = /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 20 50",
    height: "3.052rem",
    fill: "none",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false"
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.2 0L6.6 10.6H1L2.8 15.2H14.2L2.2 0Z",
      fill: "var(--pds-color-brand-primary-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.1 38.5L15.2 33.9H12.6L7.20001 20.8H4.90001L10.3 33.9H3.70001L15.9 49.1L11.5 38.5H17.1Z",
      fill: "var(--pds-color-brand-primary-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6 29.2H11.5L13 32.8H18.6C18.7 32.8 19.1 32.6 19.1 31C19 29.4 18.7 29.2 18.6 29.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.3 24.9H9.79999L11.3 28.5H19.3C19.4 28.5 19.8 28.3 19.8 26.7C19.7 25.1 19.4 24.9 19.3 24.9Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6 19.9C18.7 19.9 19.1 19.7 19.1 18.1C19.1 16.5 18.8 16.3 18.6 16.3H10.8L12.3 19.9H18.6Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14 24.2H19.2C19.3 24.2 19.7 24 19.7 22.4C19.7 20.8 19.4 20.6 19.2 20.6H12.5L14 24.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6 29.2H11.5L13 32.8H18.6C18.7 32.8 19.1 32.6 19.1 31C19 29.4 18.7 29.2 18.6 29.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.3 24.9H9.79999L11.3 28.5H19.3C19.4 28.5 19.8 28.3 19.8 26.7C19.7 25.1 19.4 24.9 19.3 24.9Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.4 24.2L3.7 19.9H7.6L9.4 24.2H13.1L9.8 16.3H1.7C1.1 16.3 0.7 16.3 0.4 17.2C0.0999996 18.3 0 20.4 0 24.5C0 28.6 -3.8743e-07 30.7 0.4 31.8C0.7 32.7 1 32.7 1.7 32.7H8.8L5.4 24.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  )
), z2 = /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 140 17",
    height: "1rem",
    fill: "none",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false"
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.2 0H18.8L12.4 16.3H16.9L18 13.5H23.8L24.9 16.3H29.4L23.2 0ZM19.2 10.3L20.9 5.1L22.6 10.3H19.2Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.5 0H0V16.4H4.4V10.8H6.6C10.3 10.8 12.4 9.2 12.4 5.4C12.4 1.6 10 0 6.5 0ZM5 7.6H4.5V3.6H5C6.6 3.6 8 3.6 8 5.6C8 7.6 6.5 7.6 5 7.6Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M89.1 9.9L93.4 10V6.4H89.1V3.6H95V0H84.7V16.3H95V12.3H89.1V9.9Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M50.8 4.4H54.7L54.8 16.3H59.1V4.4H63.1V0H50.8V4.4Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M76.7 6.4H70.7V0H66.3V16.3H70.7V9.9H76.7V16.3H81.1V0H76.7V6.4Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M105.6 4.4C107.7 4.4 109.4 6.1 109.4 8.2C109.4 10.3 107.7 12 105.6 12C103.5 12 101.8 10.3 101.8 8.2C101.8 6.1 103.5 4.4 105.6 4.4ZM105.6 0C101.1 0 97.4 3.7 97.4 8.2C97.4 12.7 101.1 16.4 105.6 16.4C110.1 16.4 113.8 12.7 113.8 8.2C113.8 3.7 110.1 0 105.6 0Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M128.1 9.1L121.1 0H117V16.3H121.4V7.2L128.1 16.3H132.5V0H128.2L128.1 9.1Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M43.2 9.1L36.1 0H32V16.3H36.4V7.2L43.1 16.3H47.6V0H43.2V9.1Z",
      fill: "var(--pds-color-foreground-default)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M135.7 0.299999H135.2V0H136.7V0.299999H136.2V1.9H135.8V0.299999H135.7ZM137.8 1.9L137.3 0.4V1.9H136.9V0H137.5L138 1.5L138.5 0H139.1V1.9H138.7V0.4L138.2 1.9H137.8Z",
      fill: "var(--pds-color-foreground-default)"
    }
  )
), js = (l) => {
  var i = l, {
    colorType: s = "default",
    displayType: n = "full",
    linkContent: a,
    subBrand: c,
    className: r
  } = i, o = S(i, [
    "colorType",
    "displayType",
    "linkContent",
    "subBrand",
    "className"
  ]);
  const d = "pds-pantheon-logo", u = n && n !== "full" ? `${d}--${n}` : null, h = s && s !== "default" ? `${d}--${s}` : null;
  let m;
  switch (n) {
    case "full":
      m = H2;
      break;
    case "icon":
      m = ds;
      break;
    case "wordmark":
      m = z2;
      break;
    case "sub-brand":
      m = ds;
  }
  const p = e.isValidElement(a) && typeof a.props.children == "string" ? a.props.children : "", f = e.isValidElement(a) ? Ge(a, {
    children: m,
    "aria-label": p || null
  }) : a;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: Y([
        d,
        u,
        h,
        r != null ? r : ""
      ])
    }, o),
    a ? f : m,
    c && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: "pds-pantheon-logo__separator" }), /* @__PURE__ */ e.createElement("div", { className: "pds-pantheon-logo__sub-brand-wordmark" }, c))
  );
}, an = (l) => {
  var i = l, {
    ariaLabel: s,
    labels: n = {
      submenu: "submenu",
      toggle: "Toggle"
    },
    menuItems: a,
    mobileMenuSelectTextFallback: c = "Navigate to...",
    className: r
  } = i, o = S(i, [
    "ariaLabel",
    "labels",
    "menuItems",
    "mobileMenuSelectTextFallback",
    "className"
  ]);
  let d = !1;
  const u = ke(Fe);
  u && (d = u.isMobile);
  const h = ke(Mt);
  let m = !0, p = null;
  h && (m = h.isSidebarExpanded, p = h.logoLinkContent);
  const f = "pds-dashboard-nav", C = m ? `${f}--expanded` : `${f}--collapsed`, $ = /* @__PURE__ */ e.createElement(e.Fragment, null, a.length > 0 && /* @__PURE__ */ e.createElement("ul", { className: `${f}__menu ${f}__menu--top-level` }, a.map((b, v) => /* @__PURE__ */ e.createElement(
    k2,
    {
      key: v,
      icon: b.icon,
      isActive: ye(b),
      isSidebarExpanded: m,
      labels: n,
      linkContent: b.linkContent,
      links: b.links
    }
  )))), g = a.map((b) => ge(y({}, b), {
    linkContent: Ut(
      f,
      b.linkContent,
      b.links,
      b.icon
    )
  })), _ = /* @__PURE__ */ e.createElement(
    Jt,
    {
      menuItems: g,
      selectTextFallback: c
    }
  );
  return /* @__PURE__ */ e.createElement(
    "nav",
    y({
      "aria-label": s,
      className: Y([f, C, r])
    }, o),
    !d && /* @__PURE__ */ e.createElement(
      js,
      {
        className: `${f}__logo`,
        displayType: m ? "full" : "icon",
        linkContent: p
      }
    ),
    d ? _ : $
  );
}, dt = (r) => {
  var o = r, {
    children: s,
    width: n = "standard",
    className: a
  } = o, c = S(o, [
    "children",
    "width",
    "className"
  ]);
  const l = "pds-container", i = n !== "standard" ? `${l}--${n}` : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: Y([l, i, a != null ? a : ""])
    }, c),
    s
  );
}, ln = (p) => {
  var f = p, {
    children: s,
    colorType: n = "default",
    containerWidth: a = "x-wide",
    hideBorder: c,
    hideLogo: r = !1,
    logoDisplayType: o = "full",
    logoLinkContent: l,
    logoSrc: i,
    logoSubBrand: d,
    translationStrings: u = {
      closeMobileNav: "Close navigation area",
      openMobileNav: "Open navigation area"
    },
    className: h
  } = f, m = S(f, [
    "children",
    "colorType",
    "containerWidth",
    "hideBorder",
    "hideLogo",
    "logoDisplayType",
    "logoLinkContent",
    "logoSrc",
    "logoSubBrand",
    "translationStrings",
    "className"
  ]);
  const [C, $] = R(!1);
  let g = !1;
  const _ = ke(Fe);
  _ && (g = _.isMobile);
  const b = ke(Mt);
  b && (l = b.logoLinkContent);
  const v = "pds-navbar", E = c ? `${v}--noBorder` : "", w = n !== "default" ? `${v}--${n}` : "", L = g ? `${v}--isMobile` : `${v}--notMobile`, N = (O) => {
    const D = O.key;
    let F = !1;
    switch (D) {
      case "Esc":
      case "Escape":
        $(!1), F = !0;
        break;
    }
    F && (O.stopPropagation(), O.preventDefault());
  };
  oe(() => (window.addEventListener("keyup", N), () => {
    window.removeEventListener("keyup", N);
  }), []);
  const M = () => $(!C), k = Qs();
  oe(() => {
    if (g && s) {
      const O = Cs(
        document.querySelector(".pds-navbar__mobile")
      ), D = ["a", "button", "input", "select", "textarea"];
      C ? O.forEach((F) => {
        D.includes(F.nodeName.toLowerCase()) && (F.tabIndex = 0);
      }) : O.forEach((F) => {
        D.includes(F.nodeName.toLowerCase()) && (F.tabIndex = -1);
      });
    }
  }, [C]);
  const x = (O) => {
    O.target.nodeName === "A" && $(!1);
  };
  oe(() => {
    if (C) {
      const O = document.querySelector(".pds-navbar__bar-mobile"), D = document.querySelector(".pds-navbar__mobile");
      return O.addEventListener("click", x), D.addEventListener("click", x), () => {
        O.removeEventListener("click", x), D.removeEventListener("click", x);
      };
    }
  }, [C]), oe(() => {
    g ? document.body.classList.add("pds-no-scroll-x") : document.body.classList.remove("pds-no-scroll-x");
  }, [g]), oe(() => {
    C ? document.body.classList.add("pds-no-scroll") : document.body.classList.remove("pds-no-scroll");
  }, [C]);
  const z = $s(s), T = z["items-left"], V = z["items-right"];
  let H = "default";
  (n === "reverse" || n === "reverse-transparent") && (H = "reverse");
  const I = Pe(l) ? l.props.children : null, A = Pe(l) && I ? Ge(l, {
    children: /* @__PURE__ */ e.createElement("img", { className: `${v}__custom-logo`, src: i }),
    "aria-label": I || null
  }) : /* @__PURE__ */ e.createElement("img", { className: `${v}__custom-logo`, src: i, alt: "" }), j = () => i ? A : /* @__PURE__ */ e.createElement(
    js,
    {
      colorType: H,
      displayType: o,
      linkContent: l,
      subBrand: d
    }
  ), B = /* @__PURE__ */ e.createElement(
    "button",
    {
      className: `${v}__menu-toggle`,
      "aria-label": C ? u.closeMobileNav : u.openMobileNav,
      onClick: M
    },
    /* @__PURE__ */ e.createElement(q, { iconName: C ? "xmark" : "bars", iconSize: "lg" })
  ), W = /* @__PURE__ */ e.createElement(
    "div",
    {
      className: C ? `${v}__mobile ${v}__mobile--open` : `${v}__mobile ${v}__mobile--closed`,
      ref: k
    },
    /* @__PURE__ */ e.createElement(dt, null, T, V)
  ), Z = /* @__PURE__ */ e.createElement(
    i1,
    {
      focusTrapOptions: {
        clickOutsideDeactivates: !0,
        initialFocus: !1
      }
    },
    /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(dt, { className: `${v}__bar-mobile` }, /* @__PURE__ */ e.createElement("div", { className: `${v}__inner-mobile` }, j(), s && B)), /* @__PURE__ */ e.createElement(dt, null, s && W))
  ), K = /* @__PURE__ */ e.createElement(dt, { width: a, className: `${v}__inner` }, !r && /* @__PURE__ */ e.createElement("div", { className: `${v}__logo` }, j()), /* @__PURE__ */ e.createElement("div", { className: `${v}__content` }, T ? /* @__PURE__ */ e.createElement("div", { className: `${v}__items-left` }, T) : /* @__PURE__ */ e.createElement("span", null), V && /* @__PURE__ */ e.createElement("div", { className: `${v}__items-right` }, V)));
  return /* @__PURE__ */ e.createElement(
    "header",
    y({
      className: Y([
        v,
        w,
        E,
        L,
        h != null ? h : ""
      ])
    }, m),
    g ? Z : K
  );
}, cn = (u) => {
  var h = u, {
    ariaLabel: s,
    hasMobileMenu: n = !0,
    headingText: a,
    labels: c = {
      submenu: "submenu",
      toggle: "Toggle"
    },
    menuItems: r,
    mobileMenuMaxWidth: o = 640,
    mobileMenuSelectTextFallback: l = "Navigate to...",
    className: i
  } = h, d = S(h, [
    "ariaLabel",
    "hasMobileMenu",
    "headingText",
    "labels",
    "menuItems",
    "mobileMenuMaxWidth",
    "mobileMenuSelectTextFallback",
    "className"
  ]);
  const m = "pds-side-nav", [p, f] = R(1025);
  oe(() => (f(window.innerWidth), window.addEventListener("resize", C), () => {
    window.removeEventListener("resize", C);
  }), []);
  const C = () => {
    f(window.innerWidth);
  }, $ = p <= o, g = (E) => {
    const w = E.target;
    w.classList.toggle(`${m}__toggle--expanded`), w.setAttribute(
      "aria-expanded",
      w.getAttribute("aria-expanded") === "true" ? "false" : "true"
    ), w.parentElement.nextElementSibling.classList.toggle(`${m}__menu--expanded`);
  }, _ = (E, w) => {
    const { linkContent: L, links: N } = E, M = `${m}__item`, k = `${m}__menu`;
    return /* @__PURE__ */ e.createElement(
      "li",
      {
        key: w,
        className: Y([
          M,
          `${M}--top-level`,
          N ? `${M}--has-children` : null,
          ye(E) ? `${M}--active` : null
        ])
      },
      N ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: `${M}-wrapper` }, lt(L, N), /* @__PURE__ */ e.createElement(
        "button",
        {
          "aria-expanded": ye(E),
          className: Y([
            `${m}__toggle`,
            ye(E) ? `${m}__toggle--expanded` : null
          ]),
          onClick: g
        },
        /* @__PURE__ */ e.createElement(q, { iconName: "angleDown", iconSize: "md" }),
        /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, `${c.toggle} ${at(L)} ${c.submenu}`)
      )), /* @__PURE__ */ e.createElement(
        "ul",
        {
          className: Y([
            k,
            `${k}--second-level`,
            ye(E) ? `${k}--expanded` : null
          ])
        },
        N.map((x, z) => /* @__PURE__ */ e.createElement(
          "li",
          {
            key: z,
            className: Y([
              M,
              `${M}--second-level`,
              ye(x) ? `${M}--active` : null
            ])
          },
          lt(
            x.linkContent,
            x.links
          )
        ))
      )) : (
        // If no top-level child links are present, render the link content as is.
        L
      )
    );
  }, b = /* @__PURE__ */ e.createElement(e.Fragment, null, a && /* @__PURE__ */ e.createElement("h2", { className: `${m}__heading` }, a), r.length > 0 && /* @__PURE__ */ e.createElement("ul", { className: `${m}__menu ${m}__menu--top-level` }, r.map((E, w) => _(E, w)))), v = /* @__PURE__ */ e.createElement(
    Jt,
    {
      headingText: a,
      menuItems: r,
      selectTextFallback: l
    }
  );
  return /* @__PURE__ */ e.createElement(
    "nav",
    y({
      "aria-label": s,
      className: Y([m, i != null ? i : ""])
    }, d),
    $ && n ? v : b
  );
}, rn = (u) => {
  var h = u, {
    ariaLabel: s,
    hasMobileMenu: n = !0,
    headingText: a,
    labels: c = {
      submenu: "submenu",
      toggle: "Toggle"
    },
    menuItems: r,
    mobileMenuMaxWidth: o = 640,
    mobileMenuSelectTextFallback: l = "Navigate to...",
    className: i
  } = h, d = S(h, [
    "ariaLabel",
    "hasMobileMenu",
    "headingText",
    "labels",
    "menuItems",
    "mobileMenuMaxWidth",
    "mobileMenuSelectTextFallback",
    "className"
  ]);
  const m = "pds-side-nav-compact", [p, f] = R(1025);
  oe(() => (f(window.innerWidth), window.addEventListener("resize", C), () => {
    window.removeEventListener("resize", C);
  }), []);
  const C = () => {
    f(window.innerWidth);
  }, $ = p <= o, g = (E) => {
    const w = E.target;
    w.classList.toggle(`${m}__toggle--expanded`), w.setAttribute(
      "aria-expanded",
      w.getAttribute("aria-expanded") === "true" ? "false" : "true"
    ), w.parentElement.nextElementSibling.classList.toggle(`${m}__menu--expanded`);
  }, _ = (E, w) => {
    const { linkContent: L, links: N } = E, M = `${m}__item`, k = `${m}__menu`;
    return /* @__PURE__ */ e.createElement(
      "li",
      {
        key: w,
        className: Y([
          M,
          `${M}--top-level`,
          N ? `${M}--has-children` : null,
          ye(E) ? `${M}--active` : null
        ])
      },
      N ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: `${M}-wrapper` }, /* @__PURE__ */ e.createElement(
        "button",
        {
          "aria-expanded": ye(E),
          className: Y([
            `${m}__toggle`,
            ye(E) ? `${m}__toggle--expanded` : null
          ]),
          onClick: g
        },
        /* @__PURE__ */ e.createElement(q, { iconName: "caretDown", iconSize: "md" }),
        /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, `${c.toggle} ${at(L)} ${c.submenu}`)
      ), lt(L, N)), /* @__PURE__ */ e.createElement(
        "ul",
        {
          className: Y([
            k,
            `${k}--second-level`,
            ye(E) ? `${k}--expanded` : null
          ])
        },
        N.map((x, z) => /* @__PURE__ */ e.createElement(
          "li",
          {
            key: z,
            className: Y([
              M,
              `${M}--second-level`,
              ye(x) ? `${M}--active` : null
            ])
          },
          x.links ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: `${M}-wrapper` }, /* @__PURE__ */ e.createElement(
            "button",
            {
              "aria-expanded": ye(x),
              className: Y([
                `${m}__toggle`,
                ye(x) ? `${m}__toggle--expanded` : null
              ]),
              onClick: g
            },
            /* @__PURE__ */ e.createElement(q, { iconName: "caretDown", iconSize: "md" }),
            /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, `${c.toggle} ${at(x.linkContent)} ${c.submenu}`)
          ), lt(
            x.linkContent,
            x.links
          )), /* @__PURE__ */ e.createElement(
            "ul",
            {
              className: Y([
                k,
                `${k}--third-level`,
                ye(x) ? `${k}--expanded` : null
              ])
            },
            x.links.map((T, V) => /* @__PURE__ */ e.createElement(
              "li",
              {
                key: V,
                className: Y([
                  M,
                  `${M}--third-level`,
                  ye(T) ? `${M}--active` : null
                ])
              },
              lt(
                T.linkContent,
                T.links
              )
            ))
          )) : (
            // If no second-level child links are present, render the link content as is.
            x.linkContent
          )
        ))
      )) : (
        // If no top-level child links are present, render the link content as is.
        L
      )
    );
  }, b = /* @__PURE__ */ e.createElement(e.Fragment, null, a && /* @__PURE__ */ e.createElement("h2", { className: `${m}__heading` }, a), r.length > 0 && /* @__PURE__ */ e.createElement("ul", { className: `${m}__menu ${m}__menu--top-level` }, r.map((E, w) => _(E, w)))), v = /* @__PURE__ */ e.createElement(
    Jt,
    {
      headingText: a,
      menuItems: r,
      selectTextFallback: l
    }
  );
  return /* @__PURE__ */ e.createElement(
    "nav",
    y({
      "aria-label": s,
      className: Y([m, i != null ? i : ""])
    }, d),
    $ && n ? v : b
  );
}, on = (d) => {
  var u = d, {
    ariaLabel: s = "User menu",
    menuItems: n,
    userEmail: a,
    userImageSrc: c,
    userName: r,
    withinNavbar: o = !0,
    className: l
  } = u, i = S(u, [
    "ariaLabel",
    "menuItems",
    "userEmail",
    "userImageSrc",
    "userName",
    "withinNavbar",
    "className"
  ]);
  const [h, m] = R(null), [p, f] = R(!1), C = se([]), $ = se([]);
  let g = !1;
  const _ = ke(Fe);
  _ && (g = _.isMobile);
  const b = o && g, v = "pds-user-menu", E = b ? `${v}--isMobile` : null, w = `${v}__menu`, { refs: L, floatingStyles: N, context: M } = Ie({
    placement: "bottom-end",
    open: p,
    onOpenChange: f,
    middleware: [yt(12), wt(), Nt()],
    whileElementsMounted: qe
  }), k = ot(M, { event: "mousedown" }), x = Se(M), z = Te(M, { role: "menu" }), T = se([]), V = pt(M, {
    listRef: T,
    activeIndex: h,
    onNavigate: m,
    loop: !0,
    openOnArrowKeyDown: !0,
    focusItemOnOpen: !1,
    focusItemOnHover: !0
  }), { getReferenceProps: H, getFloatingProps: I, getItemProps: A } = Oe(
    [x, z, k, V]
  ), { isMounted: j, styles: B } = Xe(M, {
    duration: {
      open: 300,
      close: 150
    },
    initial: {
      opacity: 0
    },
    open: {
      opacity: 1
    },
    close: {
      opacity: 0
    }
  }), W = /* @__PURE__ */ e.createElement(
    ut,
    {
      size: "sm",
      imageSrc: c,
      uniqueId: a,
      className: `${v}__avatar`
    }
  ), Z = /* @__PURE__ */ e.createElement(q, { iconName: "angleDown", className: `${v}__trigger-icon` }), K = /* @__PURE__ */ e.createElement("li", { className: `${v}__user-details`, role: "presentation" }, b ? null : /* @__PURE__ */ e.createElement("div", { className: `${v}__user-name` }, r), /* @__PURE__ */ e.createElement("div", { className: `${v}__user-email` }, a));
  n.forEach((te) => {
    const de = te.id ? te.id : je();
    C.current.push(de), $.current.push(te);
  });
  const O = (te) => {
    const de = C.current.indexOf(te), le = $.current[de];
    le.linkContent && !le.disabled && (T.current[de].querySelector("a").click(), f(!1)), le.callback && !le.disabled && (le.callback(le), f(!1));
  }, D = (te) => {
    te.preventDefault(), te.key === "Enter" && O(te.currentTarget.id);
  }, F = (te) => {
    O(te.currentTarget.id);
  }, U = n.map((te, de) => {
    const le = C.current[de], ne = `${v}__item`, Ee = te.disabled ? `${ne}--disabled` : null;
    return /* @__PURE__ */ e.createElement(
      "li",
      y({
        key: le,
        id: le,
        className: Y([ne, Ee]),
        role: "menuitem",
        tabIndex: h === de ? 0 : -1,
        ref: (ee) => {
          T.current[de] = ee;
        },
        onKeyDown: D
      }, A({ onClick: (ee) => F(ee) })),
      te.iconName && /* @__PURE__ */ e.createElement(
        q,
        {
          iconName: te.iconName,
          className: `${v}__icon`,
          iconSize: "sm"
        }
      ),
      te.linkContent ? te.linkContent : te.label
    );
  }), ie = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "button",
    y({
      className: `${v}__trigger`,
      "aria-label": s,
      ref: L.setReference
    }, H()),
    W
  ), j && /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: `${v}__dropdown`,
      ref: L.setFloating,
      style: ge(y({}, N), {
        zIndex: "var(--pds-z-index-dropdown)"
      })
    }, I()),
    /* @__PURE__ */ e.createElement("div", { style: y({}, B) }, /* @__PURE__ */ e.createElement("ul", { className: w, role: "menu" }, K, /* @__PURE__ */ e.createElement("li", { role: "separator" }), U))
  )), Q = (te) => {
    const de = te.currentTarget;
    de.classList.toggle(`${v}__toggle--expanded`), de.setAttribute(
      "aria-expanded",
      de.getAttribute("aria-expanded") === "true" ? "false" : "true"
    ), de.nextElementSibling.classList.toggle(`${v}__mobile-menu--expanded`);
  }, ve = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "button",
    {
      className: `${v}__toggle`,
      "aria-expanded": !1,
      "aria-label": s,
      onClick: Q
    },
    /* @__PURE__ */ e.createElement("span", { className: `${v}__toggle-left` }, W, r || a),
    Z
  ), /* @__PURE__ */ e.createElement("div", { className: `${v}__mobile-menu` }, /* @__PURE__ */ e.createElement(
    "ul",
    {
      className: [w, `${w}--isMobile`].join(" ").trim(),
      role: "menu"
    },
    K,
    /* @__PURE__ */ e.createElement("li", { role: "separator" }),
    U
  )));
  return /* @__PURE__ */ e.createElement(
    "span",
    y({
      className: Y([v, E, l != null ? l : ""])
    }, i),
    b ? ve : ie
  );
}, M2 = {
  info: "circleInfo",
  warning: "triangleExclamation",
  critical: "diamondExclamation"
}, dn = (i) => {
  var d = i, {
    banners: s,
    dismissLabel: n = "Dismiss",
    labelNext: a = "Go to next message",
    labelPrevious: c = "Go to previous message",
    typeLabels: r = {
      info: "Information",
      warning: "Warning",
      critical: "Critical"
    },
    className: o
  } = d, l = S(d, [
    "banners",
    "dismissLabel",
    "labelNext",
    "labelPrevious",
    "typeLabels",
    "className"
  ]);
  const [u, h] = R(s), m = u.length;
  if (m === 0)
    return null;
  const p = "pds-banner", f = m > 1 ? `${p}-group--multiple` : null, C = {
    info: `${p}--info`,
    warning: `${p}--warning`,
    critical: `${p}--critical`
  }, $ = m > 0 ? u[0].type : null, g = $ ? `${p}-group--${$}` : null, _ = (N) => ({
    zIndex: It - N
  }), b = (N) => N === 0 ? 0 : -1, v = () => {
    const N = document.getElementsByClassName(
      `${p}--fading`
    );
    for (; N.length; )
      N[0].classList.remove(`${p}--fading`);
  }, E = () => {
    v(), document.getElementById(u[0].id).classList.add(`${p}--fading`), setTimeout(() => {
      h((N) => [
        ...N.slice(1),
        N[0]
      ]);
    }, 200);
  }, w = () => {
    v(), document.getElementById(u[0].id).style.zIndex = (It + 2).toString(), document.getElementById(u[m - 1].id).style.zIndex = (It + 1).toString(), setTimeout(() => {
      document.getElementById(u[0].id).classList.add(`${p}--fading`);
    }, 50), setTimeout(() => {
      h((N) => [
        N[N.length - 1],
        ...N.slice(0, N.length - 1)
      ]), document.getElementById(u[0].id).classList.remove(`${p}--fading`);
    }, 200);
  }, L = (N, M) => {
    const { id: k, isDismissible: x, message: z, onDismiss: T, type: V } = N, I = ["critical", "warning"].includes(V) ? "alert" : "status", A = `${r[V]}:  `, j = (B) => {
      B.preventDefault(), document.getElementById(k).classList.add(`${p}--dismissing`), setTimeout(() => {
        if (m === 1) {
          h([]);
          return;
        }
        h(
          (W) => W.filter((Z) => Z.id !== k)
        ), T && N.onDismiss();
      }, 200);
    };
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        key: k,
        id: k,
        className: Y([p, C[V]]),
        role: I,
        style: {
          zIndex: _(M).zIndex
        }
      },
      /* @__PURE__ */ e.createElement("div", { className: `${p}__content` }, /* @__PURE__ */ e.createElement(
        q,
        {
          iconName: M2[V],
          iconSize: "md",
          className: `${p}__icon ${p}__icon--${N.type}`
        }
      ), /* @__PURE__ */ e.createElement("div", { className: `${p}__message` }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, A, " "), z)),
      x && /* @__PURE__ */ e.createElement(
        "button",
        {
          className: `${p}__dismiss-button`,
          onClick: j,
          tabIndex: b(M)
        },
        n
      )
    );
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: Y([
        `${p}-group`,
        g,
        f,
        o != null ? o : ""
      ])
    }, l),
    m > 1 ? /* @__PURE__ */ e.createElement("div", { className: `${p}__navigation` }, /* @__PURE__ */ e.createElement(
      mt,
      {
        iconName: "angleLeft",
        size: "lg",
        className: `${p}__nav-button ${p}__nav-button--prev`,
        ariaLabel: c,
        onClick: w
      }
    ), /* @__PURE__ */ e.createElement(
      mt,
      {
        iconName: "angleRight",
        size: "lg",
        className: `${p}__nav-button ${p}__nav-button--next`,
        ariaLabel: a,
        onClick: E
      }
    ), u.map((N, M) => L(N, M))) : L(u[0], 0)
  );
}, jt = {
  info: "circleInfo",
  warning: "triangleExclamation",
  success: "circleCheck",
  critical: "diamondExclamation"
}, mn = (l) => {
  var i = l, {
    title: s,
    secondaryText: n,
    type: a,
    typeLabels: c = {
      info: "Information",
      success: "Success",
      warning: "Warning",
      critical: "Critical",
      working: "Working"
    },
    className: r
  } = i, o = S(i, [
    "title",
    "secondaryText",
    "type",
    "typeLabels",
    "className"
  ]);
  const d = "pds-inline-message", u = {
    error: `${d}--error`,
    success: `${d}--success`,
    warning: `${d}--warning`,
    info: `${d}--info`,
    critical: `${d}--critical`,
    working: `${d}--working`
  }, h = s ? `${d}--hasTitle` : null, p = ["critical", "warning"].includes(a) ? "alert" : "status", f = `${c[a]}: `;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [d, u[a], h, r != null ? r : ""].join(" ").trim().replace(/\s+/g, " "),
      role: p
    }, o),
    /* @__PURE__ */ e.createElement("div", { className: `${d}__content` }, /* @__PURE__ */ e.createElement("div", { className: `${d}__icon ${d}__icon-${a}` }, a === "working" ? /* @__PURE__ */ e.createElement(zt, { colorType: "monochromatic" }) : /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: `${a}` in jt ? jt[a] : jt.info,
        iconSize: "md"
      }
    )), /* @__PURE__ */ e.createElement("div", { className: `${d}__text` }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, f), s && /* @__PURE__ */ e.createElement("div", { className: `${d}__title` }, s), /* @__PURE__ */ e.createElement("div", { className: `${d}__secondaryText` }, n)))
  );
}, Bt = {
  info: "circleInfo",
  warning: "triangleExclamation",
  success: "circleCheck",
  critical: "diamondExclamation",
  discovery: "squareQuestion"
}, un = (h) => {
  var m = h, {
    dismissLabel: s = "Dismiss",
    id: n,
    isDismissible: a,
    onDismiss: c,
    message: r,
    title: o,
    type: l = "info",
    typeLabels: i = {
      info: "Information",
      success: "Success",
      warning: "Warning",
      critical: "Critical",
      discovery: "Discovery"
    },
    className: d
  } = m, u = S(m, [
    "dismissLabel",
    "id",
    "isDismissible",
    "onDismiss",
    "message",
    "title",
    "type",
    "typeLabels",
    "className"
  ]);
  const p = se(null), f = "pds-section-message", C = {
    error: `${f}--error`,
    success: `${f}--success`,
    warning: `${f}--warning`,
    info: `${f}--info`,
    critical: `${f}--critical`,
    discovery: `${f}--discovery`,
    dismissing: `${f}--dismissing`,
    dismissed: `${f}--dismissed`
  }, $ = o ? `${f}--hasTitle` : null, _ = ["critical", "warning"].includes(l) ? "alert" : "status", b = `${i[l]}: `, v = () => {
    p.current.addEventListener("animationend", E, {
      once: !0
    });
  }, E = (L) => {
    c(L, n);
  }, w = () => {
    v(), p.current.classList.toggle(C.dismissing), setTimeout(() => {
      p.current.classList.toggle(C.dismissing), p.current.classList.toggle(C.dismissed);
    }, 400);
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [f, C[l], $, d != null ? d : ""].join(" ").trim().replace(/\s+/g, " "),
      id: n,
      ref: p,
      role: _
    }, u),
    /* @__PURE__ */ e.createElement("div", { className: `${f}__content` }, /* @__PURE__ */ e.createElement("div", { className: `${f}__icon ${f}__icon-${l}` }, /* @__PURE__ */ e.createElement(
      q,
      {
        iconName: `${l}` in Bt ? Bt[l] : Bt.info,
        iconSize: "md"
      }
    )), /* @__PURE__ */ e.createElement("div", { className: `${f}__text` }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, b), o && /* @__PURE__ */ e.createElement("div", { className: `${f}__title` }, o), /* @__PURE__ */ e.createElement("div", { className: `${f}__message` }, r))),
    a && /* @__PURE__ */ e.createElement(
      "button",
      {
        className: `${f}__dismiss`,
        onClick: w,
        "aria-label": s,
        role: "button"
      },
      /* @__PURE__ */ e.createElement(q, { iconSize: "md", iconName: "xmark" })
    )
  );
}, pn = (l) => {
  var i = l, {
    children: s,
    hasStatusIndicator: n = !1,
    statusType: a,
    variant: c = "default",
    className: r
  } = i, o = S(i, [
    "children",
    "hasStatusIndicator",
    "statusType",
    "variant",
    "className"
  ]);
  const d = "pds-panel", u = n ? `${d}__status ${d}__status-${a}` : null, h = `${d}--${c}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [d, h, r != null ? r : ""].join(" ").trim().replace(/\s+/g, " ")
    }, o),
    n && a && /* @__PURE__ */ e.createElement("span", { className: u }),
    /* @__PURE__ */ e.createElement("div", { className: `${d}__content` }, s)
  );
}, Ze = 8, ms = 14, L2 = 6, hn = (f) => {
  var C = f, {
    content: s,
    customTrigger: n = !1,
    hasCloseButton: a = !1,
    offsetValue: c = 0,
    onClose: r = () => {
    },
    placement: o = "top",
    title: l,
    triggerIcon: i = "circleInfo",
    triggerAccessibleText: d = "Show more information",
    popoverIsOpen: u = !1,
    setPopoverIsOpen: h = () => {
    },
    className: m
  } = C, p = S(C, [
    "content",
    "customTrigger",
    "hasCloseButton",
    "offsetValue",
    "onClose",
    "placement",
    "title",
    "triggerIcon",
    "triggerAccessibleText",
    "popoverIsOpen",
    "setPopoverIsOpen",
    "className"
  ]);
  var K, O, D, F;
  const [$, g] = R(u);
  oe(() => {
    g(u);
  }, [u]), oe(() => {
    h($);
  }, [$]);
  const _ = typeof n, b = "pds-popover", v = [
    `${b}__trigger-custom`,
    _ === "string" ? `${b}__trigger-text` : ""
  ].join(" ").trim().replace(/\s+/g, " "), E = n ? c : 0, w = se(null), { refs: L, floatingStyles: N, context: M, middlewareData: k } = Ie({
    placement: o,
    open: $,
    onOpenChange(U) {
      g(U), U || r();
    },
    middleware: [
      yt(Ze + L2 + E),
      wt({ padding: 8 }),
      Nt({ padding: 8 }),
      t1({ element: w })
    ],
    whileElementsMounted: qe
  }), x = () => {
    g(!1), r && r();
  }, z = ot(M), T = Se(M), V = Te(M), { getReferenceProps: H, getFloatingProps: I } = Oe([
    z,
    T,
    V
  ]), A = (O = (K = k.arrow) == null ? void 0 : K.x) != null ? O : 0, j = (F = (D = k.arrow) == null ? void 0 : D.y) != null ? F : 0, B = A + ms / 2, W = j + Ze, { isMounted: Z } = Xe(M, {
    initial: {
      transform: "scale(0)"
    },
    common: ({ side: U }) => ({
      transformOrigin: {
        top: `${B}px calc(100% + ${Ze}px)`,
        bottom: `${B}px ${-Ze}px`,
        left: `calc(100% + ${Ze}px) ${W}px`,
        right: `${-Ze}px ${W}px`
      }[U]
    })
  });
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [b, m].join(" ").trim().replace(/\s+/g, " ")
    }, p),
    /* @__PURE__ */ e.createElement(
      "span",
      y({
        className: `${b}__trigger`,
        ref: L.setReference
      }, H()),
      n ? /* @__PURE__ */ e.createElement("span", { className: v }, n) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, d), /* @__PURE__ */ e.createElement(
        q,
        {
          iconName: i,
          className: `${b}__icon`,
          iconSize: "md"
        }
      ))
    ),
    Z && /* @__PURE__ */ e.createElement(vs, { context: M, modal: !1 }, /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: `${b}__container`,
        ref: L.setFloating,
        style: N
      }, I()),
      /* @__PURE__ */ e.createElement(
        s1,
        {
          ref: w,
          context: M,
          height: Ze,
          width: ms,
          tipRadius: 0,
          fill: "var(--pds-color-background-default)",
          stroke: "var(--pds-color-border-default)",
          strokeWidth: 1,
          className: `${b}__arrow`
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: `${b}__container-inner` }, l && /* @__PURE__ */ e.createElement("div", { className: `${b}__title` }, l), s && /* @__PURE__ */ e.createElement("div", { className: `${b}__content` }, s), a && /* @__PURE__ */ e.createElement("button", { onClick: x, className: `${b}__close` }, /* @__PURE__ */ e.createElement("span", { className: "visually-hidden" }, "Close"), /* @__PURE__ */ e.createElement(q, { iconName: "xmark", iconSize: "lg" })))
    ))
  );
}, us = {
  neutral: "--pds-color-semantic-neutral-utility",
  info: "--pds-color-semantic-info-foreground",
  success: "--pds-color-semantic-success-foreground",
  warning: "--pds-color-semantic-warning-foreground",
  critical: "--pds-color-semantic-critical-foreground"
}, gn = (m) => {
  var p = m, {
    colorBreakpoints: s = [
      { colorType: "info", percentage: 0 },
      { colorType: "success", percentage: 100 }
    ],
    id: n,
    label: a,
    message: c,
    messagePosition: r = "below",
    percentage: o,
    showLabel: l = !1,
    showPercentage: i = !1,
    size: d = "md",
    className: u
  } = p, h = S(p, [
    "colorBreakpoints",
    "id",
    "label",
    "message",
    "messagePosition",
    "percentage",
    "showLabel",
    "showPercentage",
    "size",
    "className"
  ]);
  const f = n || je(), C = "pds-progress-bar", $ = l ? `${C}__label` : "visually-hidden", g = `${C}__track ${C}__track--${d}`, _ = o > 100 ? 100 : o;
  let b = "neutral";
  s.forEach((L) => {
    o >= L.percentage && (b = L.colorType);
  });
  const v = /* @__PURE__ */ e.createElement("div", { className: `${C}__message` }, c), E = c && r === "above", w = c && r === "below";
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [C, u].join(" ").trim().replace(/\s+/g, " "),
      style: { "--bar-percentage": `${_}%` }
    }, h),
    /* @__PURE__ */ e.createElement("div", { id: f, className: $ }, a),
    (E || i) && /* @__PURE__ */ e.createElement("div", { className: `${C}__details` }, E && v, i && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${C}__percentage`,
        style: {
          color: `hsl(from var(${us[b]}) h s calc(l - 7))`
        }
      },
      o,
      "%"
    )),
    /* @__PURE__ */ e.createElement("div", { className: `${C}__wrapper` }, /* @__PURE__ */ e.createElement(
      "div",
      {
        role: "progressbar",
        "aria-labelledby": f,
        "aria-valuenow": _,
        className: g
      },
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: `${C}__bar`,
          style: {
            width: `${_}%`,
            backgroundColor: `var(${us[b]})`
          }
        }
      )
    )),
    w && v
  );
}, fn = (l) => {
  var i = l, {
    attribution: s,
    image: n,
    layoutType: a = "stand-alone",
    quote: c,
    className: r
  } = i, o = S(i, [
    "attribution",
    "image",
    "layoutType",
    "quote",
    "className"
  ]);
  const d = "pds-pull-quote", u = `${d}--${a}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [d, u, r].join(" ").trim().replace(/\s+/g, " ")
    }, o),
    n && a === "stand-alone" && /* @__PURE__ */ e.createElement("div", { className: `${d}__image` }, /* @__PURE__ */ e.createElement("img", { src: n, alt: "" })),
    /* @__PURE__ */ e.createElement("div", { className: `${d}__quote-wrapper` }, /* @__PURE__ */ e.createElement("div", { className: `${d}__icon ${d}__icon--before` }, /* @__PURE__ */ e.createElement(q, { iconName: "quotesLeft", iconSize: "4xl" })), /* @__PURE__ */ e.createElement("div", { className: `${d}__text-wrapper` }, /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${d}__quote pds-quote-text pds-quote-text--lg`
      },
      c
    ), /* @__PURE__ */ e.createElement("div", { className: `${d}__attribution` }, /* @__PURE__ */ e.createElement("span", { className: `${d}__name` }, s.name), s.title && /* @__PURE__ */ e.createElement("span", { className: `${d}__title` }, ", ", s.title), s.org && /* @__PURE__ */ e.createElement("span", { className: `${d}__org` }, ", ", s.org))), /* @__PURE__ */ e.createElement("div", { className: `${d}__icon ${d}__icon--after` }, /* @__PURE__ */ e.createElement(q, { iconName: "quotesRight", iconSize: "4xl" })))
  );
}, Ft = {
  facebook: {
    icon: "facebook",
    url: "https://www.facebook.com/getpantheon",
    label: "Pantheon on Facebook"
  },
  instagram: {
    icon: "instagram",
    url: "https://www.instagram.com/getpantheon",
    label: "Pantheon on Instagram"
  },
  linkedin: {
    icon: "linkedin",
    url: "https://www.linkedin.com/company/getpantheon",
    label: "Pantheon on LinkedIn"
  },
  twitter: {
    icon: "twitter",
    url: "https://twitter.com/getpantheon",
    label: "Pantheon on Twitter"
  },
  x: {
    icon: "xTwitter",
    url: "https://x.com/getpantheon",
    label: "Pantheon on X"
  },
  youtube: {
    icon: "youtube",
    url: "https://www.youtube.com/user/GetPantheon",
    label: "Pantheon on YouTube"
  }
}, bn = (c) => {
  var r = c, {
    linkItems: s = ["facebook", "x", "linkedin", "youtube", "instagram"],
    className: n
  } = r, a = S(r, [
    "linkItems",
    "className"
  ]);
  const o = "pds-social-links";
  return /* @__PURE__ */ e.createElement(
    "ul",
    y({
      className: [o, n].join(" ").trim().replace(/\s+/g, " ")
    }, a),
    s.map((l, i) => /* @__PURE__ */ e.createElement("li", { key: i, className: `${o}__item` }, /* @__PURE__ */ e.createElement(
      "a",
      {
        href: Ft[l].url,
        rel: "noreferrer",
        target: "_blank",
        "aria-label": Ft[l].label
      },
      /* @__PURE__ */ e.createElement(q, { iconName: Ft[l].icon, iconSize: "xl" })
    )))
  );
}, vn = (r) => {
  var o = r, {
    label: s = null,
    type: n = "neutral",
    className: a
  } = o, c = S(o, [
    "label",
    "type",
    "className"
  ]);
  const l = "pds-status-indicator", i = `${l}--${n}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [l, i, a != null ? a : ""].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    n === "working" ? /* @__PURE__ */ e.createElement(
      zt,
      {
        className: `${l}__spinner`,
        colorType: "monochromatic",
        size: "md"
      }
    ) : /* @__PURE__ */ e.createElement("span", { className: `${l}__icon`, role: "img", "aria-hidden": "true" }),
    s && /* @__PURE__ */ e.createElement("span", { className: "pds-status-indicator__label" }, s)
  );
}, _n = (d) => {
  var u = d, {
    onActiveTabChange: s = () => {
    },
    ariaLabel: n,
    defaultSelected: a = 0,
    selectedTab: c,
    size: r = "md",
    tabs: o,
    className: l
  } = u, i = S(u, [
    "onActiveTabChange",
    "ariaLabel",
    "defaultSelected",
    "selectedTab",
    "size",
    "tabs",
    "className"
  ]);
  const h = "pds-tabs", m = r != "md" ? `${h}--${r}` : "", [p, f] = R(c != null ? c : a);
  oe(() => {
    c !== void 0 && f(c);
  }, [c]);
  const C = (b) => {
    const v = b.currentTarget.getAttribute("data-tabnumber");
    if (v) {
      const E = parseInt(v, 10);
      f(E);
    }
  }, $ = se([]);
  oe(() => {
    s(p);
  }, [p, s]), oe(() => {
    const b = $.current.length - 1;
    if (p > b) {
      f(0);
      return;
    } else if (p < 0) {
      f(b);
      return;
    }
  }, [p]);
  const g = (b, v) => {
    const E = p;
    let w = $.current[v === "next" ? E + 1 < $.current.length ? E + 1 : 0 : E - 1 >= 0 ? E - 1 : $.current.length - 1];
    w || (w = v == "next" ? $.current[b + 1] == null ? $.current[0] : $.current[b + 1] : $.current[b - 1]), w.focus();
  }, _ = (b) => {
    const v = $.current.length, E = () => {
      g((p + 1) % v, "next"), f(p + 1);
    }, w = () => {
      g((p - 1 + v) % v, "prev"), f(p - 1);
    }, L = () => {
      g(0), f(0);
    }, N = () => {
      g(v - 1), f(v - 1);
    }, M = () => {
      $.current[p].focus();
    }, x = {
      ArrowRight: E,
      ArrowLeft: w,
      Home: L,
      End: N,
      Space: M,
      Enter: M
    }[b.code];
    x && (b.preventDefault(), x());
  };
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [h, m, l].join(" ").trim().replace(/\s+/g, " ")
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${h}__tablist`,
        role: "tablist",
        "aria-label": n,
        "aria-orientation": "horizontal"
      },
      o.map(({ disabled: b, icon: v, tabId: E, tabLabel: w }, L) => /* @__PURE__ */ e.createElement(
        "button",
        {
          className: `${h}__tab`,
          "aria-selected": L == p,
          "data-tabnumber": L,
          role: "tab",
          id: E,
          onKeyDown: (N) => {
            N.preventDefault(), _(N);
          },
          key: w,
          ref: (N) => b ? null : $.current[L] = N,
          "aria-controls": `tabpanel_${L}`,
          tabIndex: p === L ? 1 : -1,
          "aria-disabled": !!b,
          onClick: b ? null : C
        },
        /* @__PURE__ */ e.createElement("div", { key: v, className: `${h}__tab-text` }, v ? /* @__PURE__ */ e.createElement(q, { iconName: v, iconSize: r }) : null, " ", w)
      ))
    ),
    o.map(({ tabLabel: b, icon: v, disabled: E, panelContent: w }, L) => /* @__PURE__ */ e.createElement(
      "div",
      y({
        className: `${h}__panel`,
        role: "tabpanel",
        key: L,
        id: `${h}__tab--${L}`,
        "aria-labelledby": `${h}__tab--${L}`
      }, i),
      /* @__PURE__ */ e.createElement(
        "button",
        {
          className: `${h}__trigger`,
          "aria-selected": L == p,
          role: "tab",
          "data-tabnumber": L,
          key: b,
          onKeyDown: _,
          "aria-disabled": !!E,
          "aria-controls": `tabpanel_${L}`,
          tabIndex: p === L ? 1 : -1,
          onClick: E ? null : C
        },
        /* @__PURE__ */ e.createElement("div", { key: v, className: `${h}__tab-text` }, v ? /* @__PURE__ */ e.createElement(q, { iconSize: "md", iconName: v }) : null, " ", b),
        L == p ? /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: "angleUp",
            iconSize: "md",
            className: `${h}__panel-content`
          }
        ) : /* @__PURE__ */ e.createElement(
          q,
          {
            iconName: "angleDown",
            iconSize: "md",
            className: `${h}__panel-content`
          }
        )
      ),
      /* @__PURE__ */ e.createElement(
        "section",
        {
          className: `${h}__panel-content`,
          hidden: L != p
        },
        w
      )
    ))
  ));
};
let ps = [
  "color-1",
  "color-2",
  "color-3",
  "color-4",
  "color-5",
  "color-6",
  "color-7",
  "color-8",
  "color-9",
  "color-10",
  "color-11",
  "color-12",
  "color-13",
  "color-14",
  "color-15",
  "color-16",
  "color-17",
  "color-18",
  "color-19",
  "color-20"
];
const x2 = (s) => {
  const n = parseInt(_s(s), 16);
  return ps[n % ps.length];
}, V2 = (s, n) => s.length > n ? s.slice(0, n) + " ..." : s, En = (d) => {
  var u = d, {
    linkContent: s,
    isRemovable: n,
    onRemove: a,
    removeLabel: c = "Remove tag",
    tagColor: r,
    tagLabel: o,
    className: l
  } = u, i = S(u, [
    "linkContent",
    "isRemovable",
    "onRemove",
    "removeLabel",
    "tagColor",
    "tagLabel",
    "className"
  ]);
  const [h, m] = R(!0), p = "pds-tag", f = r ? `${p}--${r}` : `${p}--${x2(o)}`, C = h ? null : "pds-tag--hide", $ = () => {
    m((v) => !v);
  };
  let g, _, b;
  return s && !n && Pe(s) ? (g = s.type, _ = s.props.href ? "href" : "to", b = _ === "href" ? s.props.href : s.props.to) : (g = "span", _ = null, b = null), /* @__PURE__ */ e.createElement(
    g,
    y({
      href: _ === "href" ? b : null,
      to: _ === "to" ? b : null,
      className: [p, f, C, l].join(" ").trim().replace(/\s+/g, " ")
    }, i),
    /* @__PURE__ */ e.createElement("span", { className: `${p}__label`, title: o }, V2(o, 20)),
    n ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${p}__remove`,
        "aria-label": `${c}: ${o}`,
        onClick: () => {
          $(), a();
        }
      },
      /* @__PURE__ */ e.createElement(
        q,
        {
          iconName: "xmark",
          className: `${p}__remove-icon`,
          iconSize: "md"
        }
      )
    ) : null
  );
}, I2 = (h) => {
  var m = h, {
    alignContent: s,
    alignItems: n,
    flexDirection: a,
    flexWrap: c,
    justifyContent: r,
    mobileFlex: o = "reverse",
    spacing: l = "standard",
    children: i,
    className: d
  } = m, u = S(m, [
    "alignContent",
    "alignItems",
    "flexDirection",
    "flexWrap",
    "justifyContent",
    "mobileFlex",
    "spacing",
    "children",
    "className"
  ]);
  const p = "pds-flex", f = l ? `${p}-gap--${l}` : null, C = a ? `${p}-direction--${a}` : null, $ = c ? `${p}--${c}` : null, g = r ? `${p}-justify--${r}` : null, _ = n ? `${p}-align-items--${n}` : null, b = s ? `${p}-align-content--${s}` : null, v = o && o !== "same" ? `${p}-mobile--${o}` : null;
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [
        "pds-flex-container",
        f,
        C,
        $,
        g,
        _,
        b,
        v,
        d
      ].join(" ").trim().replace(/\s+/g, " ")
    }, u),
    i
  );
};
I2.propTypes = {
  /**
   * Align content
   */
  alignContent: t.oneOf(["start", "end", "center"]),
  /**
   * Align items
   */
  alignItems: t.oneOf([
    "start",
    "end",
    "center",
    "stretch",
    "baseline"
  ]),
  /**
   * Flex direction
   */
  flexDirection: t.oneOf([
    "row",
    "row-reverse",
    "column",
    "column-reverse"
  ]),
  /**
   * Flex wrap
   */
  flexWrap: t.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  /**
   * Justify content
   */
  justifyContent: t.oneOf(["start", "end", "center", "between"]),
  /**
   * How should the flex-direction at mobile (small breakpoint)
   */
  mobileFlex: t.oneOf(["none", "reverse", "same"]),
  /**
   * Gap size
   */
  spacing: t.oneOf(["narrow", "standard", "wide"]),
  /**
   * Container content
   */
  children: t.node.isRequired,
  /**
   * Additional class names
   */
  className: t.string
};
const S2 = (i) => {
  var d = i, {
    children: s,
    gridGap: n = "standard",
    sidebarLocation: a = "right",
    sidebarMobileLocation: c = "after",
    sidebarWidth: r = "standard",
    className: o
  } = d, l = S(d, [
    "children",
    "gridGap",
    "sidebarLocation",
    "sidebarMobileLocation",
    "sidebarWidth",
    "className"
  ]);
  const [u, h] = R(1025);
  oe(() => (h(window.innerWidth), window.addEventListener("resize", C), () => {
    window.removeEventListener("resize", C);
  }), []);
  const m = "pds-sidebar-layout", p = n === "standard" ? "pds-grid" : `pds-grid pds-grid--${n}`, f = `${m}--${a}`, C = () => {
    h(window.innerWidth);
  }, $ = {};
  e.Children.forEach(s, (L) => {
    const N = L.props.slot;
    N && ($[N] ? $[N].push(L) : $[N] = [L]);
  });
  let g = "pds-grid-item--md-8 pds-grid-item--lg-9 pds-grid-item--xl-10", _ = "pds-grid-item--md-4 pds-grid-item--lg-3 pds-grid-item--xl-2";
  r === "narrow" && (g = "pds-grid-item--md-9 pds-grid-item--lg-10", _ = "pds-grid-item--md-3 pds-grid-item--lg-2"), r === "wide" && (g = "pds-grid-item--md-7 pds-grid-item--lg-8", _ = "pds-grid-item--md-5 pds-grid-item--lg-4");
  const b = /* @__PURE__ */ e.createElement(
    "div",
    {
      key: "1",
      className: `${m}__content pds-grid-item pds-grid-item--sm-4 ${g}`
    },
    $.content
  ), v = /* @__PURE__ */ e.createElement(
    "div",
    {
      key: "2",
      className: `${m}__side pds-grid-item pds-grid-item--sm-4 ${_}`
    },
    $.sidebar
  ), E = u < 641;
  let w = [];
  return a === "left" && c === "before" && (w = [v, b]), a === "left" && c === "after" && (w = E ? [b, v] : [v, b]), a === "right" && c === "before" && (w = E ? [v, b] : [b, v]), a === "right" && c === "after" && (w = [b, v]), /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [m, p, f, o].join(" ").trim().replace(/\s+/g, " ")
    }, l),
    w
  );
};
S2.propTypes = {
  /**
   * Layout content.
   */
  children: t.node,
  /**
   * Width of gap between items.
   */
  gridGap: t.oneOf(["narrow", "standard", "wide"]),
  /**
   * Position of the sidebar.
   */
  sidebarLocation: t.oneOf(["left", "right"]),
  /**
   * Position of the sidebar for mobile layout.
   */
  sidebarMobileLocation: t.oneOf(["before", "after"]),
  /**
   * Relative width of the sidebar.
   */
  sidebarWidth: t.oneOf(["narrow", "standard", "wide"]),
  /**
   * Additional class names
   */
  className: t.string
};
const T2 = (c) => {
  var r = c, { children: s, className: n } = r, a = S(r, ["children", "className"]);
  const o = {};
  e.Children.forEach(s, (p) => {
    const f = p.props.slot;
    f && (o[f] ? o[f].push(p) : o[f] = [p]);
  });
  const l = o.stepper, i = o.form, d = se(), [u] = kt(d), h = u.width;
  document.documentElement.style.setProperty(
    "--pds-stepper-layout-max-width",
    h + "px"
  );
  const m = "pds-stepper-layout";
  return /* @__PURE__ */ e.createElement(
    dt,
    y({
      className: [m, n].join(" ").trim().replace(/\s+/g, " ")
    }, a),
    l && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${m}__stepper-container`,
        ref: d
      },
      l
    ),
    i && /* @__PURE__ */ e.createElement("div", { className: `${m}__form-container` }, i)
  );
};
T2.propTypes = {
  /**
   * Layout content.
   */
  children: t.node,
  /**
   * Additional class names
   */
  className: t.string
};
const O2 = (r) => {
  var o = r, {
    children: s,
    gridGap: n = "standard",
    className: a
  } = o, c = S(o, [
    "children",
    "gridGap",
    "className"
  ]);
  const l = "pds-three-item-layout", i = n === "standard" ? "pds-grid" : `pds-grid pds-grid--${n}`, d = {};
  e.Children.forEach(s, (h) => {
    const m = h.props.slot;
    m && (d[m] ? d[m].push(h) : d[m] = [h]);
  });
  const u = [
    d["first-item"],
    d["second-item"],
    d["third-item"]
  ];
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [l, i, a].join(" ").trim().replace(/\s+/g, " ")
    }, c),
    u.map((h) => /* @__PURE__ */ e.createElement(
      "div",
      {
        key: h.key,
        className: "pds-grid-item pds-grid-item--sm-12 pds-grid-item--md-4 pds-grid-item--lg-4"
      },
      h
    ))
  );
};
O2.propTypes = {
  /**
   * Item content.
   */
  children: t.node,
  /**
   * Width of gap between items.
   */
  gridGap: t.oneOf(["narrow", "standard", "wide"]),
  /**
   * Additional class names
   */
  className: t.string
};
const R2 = (o) => {
  var l = o, {
    children: s,
    gridGap: n = "standard",
    layoutVariant: a = "equal",
    className: c
  } = l, r = S(l, [
    "children",
    "gridGap",
    "layoutVariant",
    "className"
  ]);
  const i = "pds-two-item-layout", d = n === "standard" ? "pds-grid" : `pds-grid pds-grid--${n}`, u = ["pds-grid-item--md-6"], h = ["pds-grid-item--md-4", "pds-grid-item--lg-3"], m = ["pds-grid-item--md-8", "pds-grid-item--lg-9"], p = ["pds-grid-item", "pds-grid-item--sm-4"];
  let f, C;
  switch (a) {
    case "equal":
      f = p.concat(u), C = p.concat(u);
      break;
    case "one-third-start":
      f = p.concat(h), C = p.concat(m);
      break;
    case "one-third-end":
      f = p.concat(m), C = p.concat(h);
  }
  const $ = {};
  e.Children.forEach(s, (b) => {
    const v = b.props.slot;
    v && ($[v] ? $[v].push(b) : $[v] = [b]);
  });
  const g = $["first-item"], _ = $["second-item"];
  return /* @__PURE__ */ e.createElement(
    "div",
    y({
      className: [i, d, c].join(" ").trim().replace(/\s+/g, " ")
    }, r),
    /* @__PURE__ */ e.createElement("div", { className: f.join(" ").trim() }, g),
    /* @__PURE__ */ e.createElement("div", { className: C.join(" ").trim() }, _)
  );
};
R2.propTypes = {
  /**
   * Item content.
   */
  children: t.node,
  /**
   * Width of gap between items.
   */
  gridGap: t.oneOf(["narrow", "standard", "wide"]),
  /**
   * Layout variant for column widths.
   */
  layoutVariant: t.oneOf(["equal", "one-third-start", "one-third-end"]),
  /**
   * Additional class names
   */
  className: t.string
};
const Cn = ({
  children: s,
  mobileMenuMaxWidth: n = 640
}) => /* @__PURE__ */ e.createElement(k1, { mobileMenuMaxWidth: n }, s);
export {
  ut as Avatar,
  d1 as AvatarTileList,
  dn as Banner,
  g1 as Breadcrumbs,
  Ke as Button,
  ct as ButtonLink,
  p2 as CTALink,
  N1 as CTASlice,
  Q2 as Callout,
  y1 as Card,
  w1 as CardSelectGroup,
  y2 as Checkbox,
  J2 as CheckboxFieldset,
  en as CheckboxGroup,
  z1 as Combobox,
  is as ComparisonList,
  dt as Container,
  Mt as DashboardContext,
  K2 as DashboardLayout,
  an as DashboardNav,
  M1 as DashboardSearch,
  Jt as DropdownMenu,
  L1 as ExpansionPanel,
  x1 as ExpansionPanelGroup,
  V1 as FileUpload,
  I2 as FlexContainer,
  Vs as FooterHeading,
  I1 as FooterLinks,
  Cn as GlobalWrapper,
  S1 as Heading,
  q as Icon,
  mt as IconButton,
  Ct as IndicatorBadge,
  mn as InlineMessage,
  O1 as InputFormatted,
  tn as InputGroup,
  R1 as InputObscured,
  D1 as InputText,
  Je as InputWrapper,
  A1 as LinksCard,
  Is as MenuButton,
  nn as Modal,
  j1 as NavMenu,
  ln as Navbar,
  B1 as NewSiteCard,
  X1 as Pager,
  pn as Panel,
  js as PantheonLogo,
  Ts as PlatformIcon,
  hn as Popover,
  J1 as PricingCard,
  gn as ProgressBar,
  o2 as ProgressRing,
  fn as PullQuote,
  e2 as RadioGroup,
  Fe as ResponsiveContext,
  un as SectionMessage,
  X2 as SegmentedButton,
  xt as Select,
  cn as SideNav,
  rn as SideNavCompact,
  S2 as SidebarLayout,
  t2 as SiteCard,
  s2 as SiteFooter,
  H1 as Skiplink,
  bn as SocialLinks,
  zt as Spinner,
  n2 as SplitButton,
  a2 as StatsTileList,
  Qt as StatusBadge,
  vn as StatusIndicator,
  i2 as Stepper,
  T2 as StepperLayout,
  sn as Switch,
  d2 as Table,
  m2 as TableOfContents,
  _n as Tabs,
  En as Tag,
  C2 as Tally,
  v2 as TextInput,
  u2 as Textarea,
  O2 as ThreeItemLayout,
  Ds as Tile,
  h2 as TileGrid,
  As as Toast,
  g2 as Toaster,
  f2 as ToggleButton,
  b2 as ToggleSwitch,
  Et as Tooltip,
  R2 as TwoItemLayout,
  on as UserMenu,
  E2 as WorkspaceSelector,
  as as iconList,
  ps as tagColors,
  Y2 as useToast
};
//# sourceMappingURL=index.js.map
